{
 "level": 1,
 "units": [
  {
   "id": "hello",
   "title": "Hello",
   "zh": "你好",
   "topic": "Daily life: interaction, polite behaviour (交往)",
   "notes": [
    "Chinese has two words for \"you\": 你 nǐ, for friends and people your own age, and 您 nín, a polite \"you\" for elders, teachers and people you want to show respect to. 您好 is a respectful hello.",
    "In class, students greet their teacher together with 老师好! (\"hello, teacher\"). Among friends a greeting is often simply the other person's name."
   ],
   "lessons": [
    {
     "id": "hello-1",
     "title": "Hello",
     "words": [
      "你好|nǐhǎo",
      "您|nín",
      "好|hǎo",
      "你|nǐ",
      "我|wǒ",
      "很|hěn",
      "吗|ma",
      "呢|ne",
      "也|yě",
      "再见|zàijiàn"
     ],
     "dialogue": [
      {
       "id": "d3faa70ab",
       "who": "A",
       "en": "Hello!",
       "text": "你好！",
       "tokens": [
        {
         "id": "你好|nǐhǎo",
         "py": "nǐhǎo"
        },
        {
         "p": "！"
        }
       ]
      },
      {
       "id": "d9a7bd6ed",
       "who": "B",
       "en": "Hello! (polite)",
       "text": "您好！",
       "tokens": [
        {
         "id": "您|nín",
         "py": "nín"
        },
        {
         "id": "好|hǎo",
         "py": "hǎo"
        },
        {
         "p": "！"
        }
       ]
      },
      {
       "id": "d45ae2151",
       "who": "A",
       "en": "How are you?",
       "text": "你好吗？",
       "tokens": [
        {
         "id": "你|nǐ",
         "py": "nǐ"
        },
        {
         "id": "好|hǎo",
         "py": "hǎo"
        },
        {
         "id": "吗|ma",
         "py": "ma"
        },
        {
         "p": "？"
        }
       ]
      },
      {
       "id": "d9047b8de",
       "who": "B",
       "en": "I'm fine. And you?",
       "text": "我很好。你呢？",
       "tokens": [
        {
         "id": "我|wǒ",
         "py": "wǒ"
        },
        {
         "id": "很|hěn",
         "py": "hěn"
        },
        {
         "id": "好|hǎo",
         "py": "hǎo"
        },
        {
         "p": "。"
        },
        {
         "id": "你|nǐ",
         "py": "nǐ"
        },
        {
         "id": "呢|ne",
         "py": "ne"
        },
        {
         "p": "？"
        }
       ]
      },
      {
       "id": "d6006a3cf",
       "who": "A",
       "en": "I'm fine too.",
       "text": "我也很好。",
       "tokens": [
        {
         "id": "我|wǒ",
         "py": "wǒ"
        },
        {
         "id": "也|yě",
         "py": "yě"
        },
        {
         "id": "很|hěn",
         "py": "hěn"
        },
        {
         "id": "好|hǎo",
         "py": "hǎo"
        },
        {
         "p": "。"
        }
       ]
      },
      {
       "id": "dde1edbfd",
       "who": "B",
       "en": "Goodbye!",
       "text": "再见！",
       "tokens": [
        {
         "id": "再见|zàijiàn",
         "py": "zàijiàn"
        },
        {
         "p": "！"
        }
       ]
      },
      {
       "id": "dde1edbfd",
       "who": "A",
       "en": "Goodbye!",
       "text": "再见！",
       "tokens": [
        {
         "id": "再见|zàijiàn",
         "py": "zàijiàn"
        },
        {
         "p": "！"
        }
       ]
      }
     ],
     "builds": [
      {
       "id": "bd181c28d",
       "text": "我很好。",
       "en": "I'm fine.",
       "pattern": "S A V",
       "chunks": [
        {
         "role": "S",
         "words": [
          "我|wǒ"
         ]
        },
        {
         "role": "A",
         "words": [
          "很|hěn"
         ]
        },
        {
         "role": "V",
         "words": [
          "好|hǎo"
         ]
        }
       ],
       "punct": [
        {
         "at": 3,
         "p": "。"
        }
       ],
       "py": [
        "wǒ",
        "hěn",
        "hǎo"
       ]
      },
      {
       "id": "b6006a3cf",
       "text": "我也很好。",
       "en": "I'm fine too.",
       "pattern": "S A A V",
       "chunks": [
        {
         "role": "S",
         "words": [
          "我|wǒ"
         ]
        },
        {
         "role": "A",
         "words": [
          "也|yě"
         ]
        },
        {
         "role": "A",
         "words": [
          "很|hěn"
         ]
        },
        {
         "role": "V",
         "words": [
          "好|hǎo"
         ]
        }
       ],
       "punct": [
        {
         "at": 4,
         "p": "。"
        }
       ],
       "py": [
        "wǒ",
        "yě",
        "hěn",
        "hǎo"
       ]
      },
      {
       "id": "b45ae2151",
       "text": "你好吗？",
       "en": "How are you?",
       "pattern": "S V X",
       "chunks": [
        {
         "role": "S",
         "words": [
          "你|nǐ"
         ]
        },
        {
         "role": "V",
         "words": [
          "好|hǎo"
         ]
        },
        {
         "role": "X",
         "words": [
          "吗|ma"
         ]
        }
       ],
       "punct": [
        {
         "at": 3,
         "p": "？"
        }
       ],
       "py": [
        "nǐ",
        "hǎo",
        "ma"
       ]
      },
      {
       "id": "b46de8bb1",
       "text": "你呢？",
       "en": "And you?",
       "pattern": "S X",
       "chunks": [
        {
         "role": "S",
         "words": [
          "你|nǐ"
         ]
        },
        {
         "role": "X",
         "words": [
          "呢|ne"
         ]
        }
       ],
       "punct": [
        {
         "at": 2,
         "p": "？"
        }
       ],
       "py": [
        "nǐ",
        "ne"
       ]
      }
     ]
    },
    {
     "id": "hello-2",
     "title": "In class",
     "words": [
      "大家|dàjiā",
      "老师|lǎoshī",
      "学生|xuéshēng",
      "是|shì",
      "不|bù",
      "都|dōu",
      "谢谢|xièxie",
      "不客气|búkèqi",
      "对不起|duìbuqǐ",
      "没关系|méiguānxi"
     ],
     "dialogue": [
      {
       "id": "d4d72a33f",
       "who": "A",
       "en": "Hello, everyone!",
       "text": "大家好！",
       "tokens": [
        {
         "id": "大家|dàjiā",
         "py": "dàjiā"
        },
        {
         "id": "好|hǎo",
         "py": "hǎo"
        },
        {
         "p": "！"
        }
       ]
      },
      {
       "id": "d2448ea00",
       "who": "B",
       "en": "Hello, teacher!",
       "text": "老师好！",
       "tokens": [
        {
         "id": "老师|lǎoshī",
         "py": "lǎoshī"
        },
        {
         "id": "好|hǎo",
         "py": "hǎo"
        },
        {
         "p": "！"
        }
       ]
      },
      {
       "id": "d0b42b029",
       "who": "A",
       "en": "Is everyone here a student?",
       "text": "大家都是学生吗？",
       "tokens": [
        {
         "id": "大家|dàjiā",
         "py": "dàjiā"
        },
        {
         "id": "都|dōu",
         "py": "dōu"
        },
        {
         "id": "是|shì",
         "py": "shì"
        },
        {
         "id": "学生|xuéshēng",
         "py": "xuéshēng"
        },
        {
         "id": "吗|ma",
         "py": "ma"
        },
        {
         "p": "？"
        }
       ]
      },
      {
       "id": "dc5007084",
       "who": "B",
       "en": "Yes, I'm a student.",
       "text": "是，我是学生。",
       "tokens": [
        {
         "id": "是|shì",
         "py": "shì"
        },
        {
         "p": "，"
        },
        {
         "id": "我|wǒ",
         "py": "wǒ"
        },
        {
         "id": "是|shì",
         "py": "shì"
        },
        {
         "id": "学生|xuéshēng",
         "py": "xuéshēng"
        },
        {
         "p": "。"
        }
       ]
      },
      {
       "id": "dbcbf2960",
       "who": "C",
       "en": "Sorry, I'm not a student, I'm a teacher.",
       "text": "对不起，我不是学生，我是老师。",
       "tokens": [
        {
         "id": "对不起|duìbuqǐ",
         "py": "duìbuqǐ"
        },
        {
         "p": "，"
        },
        {
         "id": "我|wǒ",
         "py": "wǒ"
        },
        {
         "id": "不|bù",
         "py": "bú"
        },
        {
         "id": "是|shì",
         "py": "shì"
        },
        {
         "id": "学生|xuéshēng",
         "py": "xuéshēng"
        },
        {
         "p": "，"
        },
        {
         "id": "我|wǒ",
         "py": "wǒ"
        },
        {
         "id": "是|shì",
         "py": "shì"
        },
        {
         "id": "老师|lǎoshī",
         "py": "lǎoshī"
        },
        {
         "p": "。"
        }
       ]
      },
      {
       "id": "d152847ac",
       "who": "A",
       "en": "That's all right! Hello!",
       "text": "没关系！您好！",
       "tokens": [
        {
         "id": "没关系|méiguānxi",
         "py": "méiguānxi"
        },
        {
         "p": "！"
        },
        {
         "id": "您|nín",
         "py": "nín"
        },
        {
         "id": "好|hǎo",
         "py": "hǎo"
        },
        {
         "p": "！"
        }
       ]
      },
      {
       "id": "dbc009ceb",
       "who": "B",
       "en": "Thank you, teacher!",
       "text": "老师，谢谢！",
       "tokens": [
        {
         "id": "老师|lǎoshī",
         "py": "lǎoshī"
        },
        {
         "p": "，"
        },
        {
         "id": "谢谢|xièxie",
         "py": "xièxie"
        },
        {
         "p": "！"
        }
       ]
      },
      {
       "id": "def70158e",
       "who": "A",
       "en": "You're welcome.",
       "text": "不客气。",
       "tokens": [
        {
         "id": "不客气|búkèqi",
         "py": "búkèqi"
        },
        {
         "p": "。"
        }
       ]
      }
     ],
     "builds": [
      {
       "id": "bdc78c050",
       "text": "我是学生。",
       "en": "I'm a student.",
       "pattern": "S V O",
       "chunks": [
        {
         "role": "S",
         "words": [
          "我|wǒ"
         ]
        },
        {
         "role": "V",
         "words": [
          "是|shì"
         ]
        },
        {
         "role": "O",
         "words": [
          "学生|xuéshēng"
         ]
        }
       ],
       "punct": [
        {
         "at": 3,
         "p": "。"
        }
       ],
       "py": [
        "wǒ",
        "shì",
        "xuéshēng"
       ]
      },
      {
       "id": "ba3b1ed30",
       "text": "我不是老师。",
       "en": "I'm not a teacher.",
       "pattern": "S A V O",
       "chunks": [
        {
         "role": "S",
         "words": [
          "我|wǒ"
         ]
        },
        {
         "role": "A",
         "words": [
          "不|bù"
         ]
        },
        {
         "role": "V",
         "words": [
          "是|shì"
         ]
        },
        {
         "role": "O",
         "words": [
          "老师|lǎoshī"
         ]
        }
       ],
       "punct": [
        {
         "at": 4,
         "p": "。"
        }
       ],
       "py": [
        "wǒ",
        "bú",
        "shì",
        "lǎoshī"
       ]
      },
      {
       "id": "b8308b881",
       "text": "大家都是学生。",
       "en": "Everyone is a student.",
       "pattern": "S A V O",
       "chunks": [
        {
         "role": "S",
         "words": [
          "大家|dàjiā"
         ]
        },
        {
         "role": "A",
         "words": [
          "都|dōu"
         ]
        },
        {
         "role": "V",
         "words": [
          "是|shì"
         ]
        },
        {
         "role": "O",
         "words": [
          "学生|xuéshēng"
         ]
        }
       ],
       "punct": [
        {
         "at": 4,
         "p": "。"
        }
       ],
       "py": [
        "dàjiā",
        "dōu",
        "shì",
        "xuéshēng"
       ]
      },
      {
       "id": "b20506bb1",
       "text": "你是老师吗？",
       "en": "Are you a teacher?",
       "pattern": "S V O X",
       "chunks": [
        {
         "role": "S",
         "words": [
          "你|nǐ"
         ]
        },
        {
         "role": "V",
         "words": [
          "是|shì"
         ]
        },
        {
         "role": "O",
         "words": [
          "老师|lǎoshī"
         ]
        },
        {
         "role": "X",
         "words": [
          "吗|ma"
         ]
        }
       ],
       "punct": [
        {
         "at": 4,
         "p": "？"
        }
       ],
       "py": [
        "nǐ",
        "shì",
        "lǎoshī",
        "ma"
       ]
      }
     ]
    }
   ]
  },
  {
   "id": "me",
   "title": "About me",
   "zh": "我",
   "topic": "Basic information: personal information (个人信息)",
   "notes": [
    "In a Chinese name the family name comes first. In 王丽 Wáng Lì, 王 is the family name and 丽 the given name. Most family names are a single character.",
    "People are often addressed by family name and title, like 李老师 (\"Teacher Li\"), rather than by their given name.",
    "你几岁？ expects a small number, so it is how you ask a child's age. With adults, 你多大？ is more usual, and elders are asked more politely still."
   ],
   "lessons": [
    {
     "id": "me-1",
     "title": "Names",
     "words": [
      "叫|jiào",
      "什么|shénme",
      "名字|míngzi",
      "这|zhè",
      "那|nà",
      "他|tā",
      "她|tā",
      "他们|tāmen",
      "我们|wǒmen",
      "你们|nǐmen"
     ],
     "dialogue": [
      {
       "id": "d26f379c0",
       "who": "A",
       "en": "Hello! What's your name?",
       "text": "你好！你叫什么名字？",
       "tokens": [
        {
         "id": "你好|nǐhǎo",
         "py": "nǐhǎo"
        },
        {
         "p": "！"
        },
        {
         "id": "你|nǐ",
         "py": "nǐ"
        },
        {
         "id": "叫|jiào",
         "py": "jiào"
        },
        {
         "id": "什么|shénme",
         "py": "shénme"
        },
        {
         "id": "名字|míngzi",
         "py": "míngzi"
        },
        {
         "p": "？"
        }
       ]
      },
      {
       "id": "d28d9b011",
       "who": "B",
       "en": "I'm David. And you?",
       "text": "我叫大卫。你呢？",
       "tokens": [
        {
         "id": "我|wǒ",
         "py": "wǒ"
        },
        {
         "id": "叫|jiào",
         "py": "jiào"
        },
        {
         "name": "大卫",
         "py": "Dàwèi"
        },
        {
         "p": "。"
        },
        {
         "id": "你|nǐ",
         "py": "nǐ"
        },
        {
         "id": "呢|ne",
         "py": "ne"
        },
        {
         "p": "？"
        }
       ]
      },
      {
       "id": "d2918b669",
       "who": "A",
       "en": "I'm Wang Li.",
       "text": "我叫王丽。",
       "tokens": [
        {
         "id": "我|wǒ",
         "py": "wǒ"
        },
        {
         "id": "叫|jiào",
         "py": "jiào"
        },
        {
         "name": "王丽",
         "py": "Wáng Lì"
        },
        {
         "p": "。"
        }
       ]
      },
      {
       "id": "d48a4fba1",
       "who": "B",
       "en": "Is this your teacher?",
       "text": "这是你们老师吗？",
       "tokens": [
        {
         "id": "这|zhè",
         "py": "zhè"
        },
        {
         "id": "是|shì",
         "py": "shì"
        },
        {
         "id": "你们|nǐmen",
         "py": "nǐmen"
        },
        {
         "id": "老师|lǎoshī",
         "py": "lǎoshī"
        },
        {
         "id": "吗|ma",
         "py": "ma"
        },
        {
         "p": "？"
        }
       ]
      },
      {
       "id": "d6922188a",
       "who": "A",
       "en": "Yes, she's our teacher. She's Teacher Li.",
       "text": "是，她是我们老师，她叫李老师。",
       "tokens": [
        {
         "id": "是|shì",
         "py": "shì"
        },
        {
         "p": "，"
        },
        {
         "id": "她|tā",
         "py": "tā"
        },
        {
         "id": "是|shì",
         "py": "shì"
        },
        {
         "id": "我们|wǒmen",
         "py": "wǒmen"
        },
        {
         "id": "老师|lǎoshī",
         "py": "lǎoshī"
        },
        {
         "p": "，"
        },
        {
         "id": "她|tā",
         "py": "tā"
        },
        {
         "id": "叫|jiào",
         "py": "jiào"
        },
        {
         "name": "李",
         "py": "Lǐ"
        },
        {
         "id": "老师|lǎoshī",
         "py": "lǎoshī"
        },
        {
         "p": "。"
        }
       ]
      },
      {
       "id": "d37a42c08",
       "who": "B",
       "en": "Is that Xiaoming?",
       "text": "那是小明吗？",
       "tokens": [
        {
         "id": "那|nà",
         "py": "nà"
        },
        {
         "id": "是|shì",
         "py": "shì"
        },
        {
         "name": "小明",
         "py": "Xiǎomíng"
        },
        {
         "id": "吗|ma",
         "py": "ma"
        },
        {
         "p": "？"
        }
       ]
      },
      {
       "id": "d77206d10",
       "who": "A",
       "en": "No. He's called Xiaohua.",
       "text": "不是。他叫小华。",
       "tokens": [
        {
         "id": "不|bù",
         "py": "bú"
        },
        {
         "id": "是|shì",
         "py": "shì"
        },
        {
         "p": "。"
        },
        {
         "id": "他|tā",
         "py": "tā"
        },
        {
         "id": "叫|jiào",
         "py": "jiào"
        },
        {
         "name": "小华",
         "py": "Xiǎohuá"
        },
        {
         "p": "。"
        }
       ]
      },
      {
       "id": "d035fbd8f",
       "who": "B",
       "en": "Are they all students?",
       "text": "他们都是学生吗？",
       "tokens": [
        {
         "id": "他们|tāmen",
         "py": "tāmen"
        },
        {
         "id": "都|dōu",
         "py": "dōu"
        },
        {
         "id": "是|shì",
         "py": "shì"
        },
        {
         "id": "学生|xuéshēng",
         "py": "xuéshēng"
        },
        {
         "id": "吗|ma",
         "py": "ma"
        },
        {
         "p": "？"
        }
       ]
      },
      {
       "id": "d6bf57ebf",
       "who": "A",
       "en": "Yes, they're all students.",
       "text": "是，他们都是学生。",
       "tokens": [
        {
         "id": "是|shì",
         "py": "shì"
        },
        {
         "p": "，"
        },
        {
         "id": "他们|tāmen",
         "py": "tāmen"
        },
        {
         "id": "都|dōu",
         "py": "dōu"
        },
        {
         "id": "是|shì",
         "py": "shì"
        },
        {
         "id": "学生|xuéshēng",
         "py": "xuéshēng"
        },
        {
         "p": "。"
        }
       ]
      }
     ],
     "builds": [
      {
       "id": "bbe97f872",
       "text": "你叫什么名字？",
       "en": "What's your name?",
       "pattern": "S V O",
       "chunks": [
        {
         "role": "S",
         "words": [
          "你|nǐ"
         ]
        },
        {
         "role": "V",
         "words": [
          "叫|jiào"
         ]
        },
        {
         "role": "O",
         "words": [
          "什么|shénme",
          "名字|míngzi"
         ]
        }
       ],
       "punct": [
        {
         "at": 3,
         "p": "？"
        }
       ],
       "py": [
        "nǐ",
        "jiào",
        "shénme",
        "míngzi"
       ]
      },
      {
       "id": "b98f4de14",
       "text": "这是我们老师。",
       "en": "This is our teacher.",
       "pattern": "S V O",
       "chunks": [
        {
         "role": "S",
         "words": [
          "这|zhè"
         ]
        },
        {
         "role": "V",
         "words": [
          "是|shì"
         ]
        },
        {
         "role": "O",
         "words": [
          "我们|wǒmen",
          "老师|lǎoshī"
         ]
        }
       ],
       "punct": [
        {
         "at": 3,
         "p": "。"
        }
       ],
       "py": [
        "zhè",
        "shì",
        "wǒmen",
        "lǎoshī"
       ]
      },
      {
       "id": "b97f702bf",
       "text": "他不是老师。",
       "en": "He isn't a teacher.",
       "pattern": "S A V O",
       "chunks": [
        {
         "role": "S",
         "words": [
          "他|tā"
         ]
        },
        {
         "role": "A",
         "words": [
          "不|bù"
         ]
        },
        {
         "role": "V",
         "words": [
          "是|shì"
         ]
        },
        {
         "role": "O",
         "words": [
          "老师|lǎoshī"
         ]
        }
       ],
       "punct": [
        {
         "at": 4,
         "p": "。"
        }
       ],
       "py": [
        "tā",
        "bú",
        "shì",
        "lǎoshī"
       ]
      },
      {
       "id": "b00cdae5f",
       "text": "他们都是学生。",
       "en": "They're all students.",
       "pattern": "S A V O",
       "chunks": [
        {
         "role": "S",
         "words": [
          "他们|tāmen"
         ]
        },
        {
         "role": "A",
         "words": [
          "都|dōu"
         ]
        },
        {
         "role": "V",
         "words": [
          "是|shì"
         ]
        },
        {
         "role": "O",
         "words": [
          "学生|xuéshēng"
         ]
        }
       ],
       "punct": [
        {
         "at": 4,
         "p": "。"
        }
       ],
       "py": [
        "tāmen",
        "dōu",
        "shì",
        "xuéshēng"
       ]
      }
     ]
    },
    {
     "id": "me-2",
     "title": "Where are you from?",
     "words": [
      "认识|rènshi",
      "高兴|gāoxìng",
      "哪|nǎ",
      "国|guó",
      "人|rén",
      "中国|Zhōngguó",
      "谁|shéi",
      "的|de",
      "朋友|péngyou",
      "同学|tóngxué"
     ],
     "dialogue": [
      {
       "id": "da9ea90d0",
       "who": "A",
       "en": "Nice to meet you!",
       "text": "认识你很高兴！",
       "tokens": [
        {
         "id": "认识|rènshi",
         "py": "rènshi"
        },
        {
         "id": "你|nǐ",
         "py": "nǐ"
        },
        {
         "id": "很|hěn",
         "py": "hěn"
        },
        {
         "id": "高兴|gāoxìng",
         "py": "gāoxìng"
        },
        {
         "p": "！"
        }
       ]
      },
      {
       "id": "d665ff3bb",
       "who": "B",
       "en": "Nice to meet you too! Where are you from?",
       "text": "我也很高兴！你是哪国人？",
       "tokens": [
        {
         "id": "我|wǒ",
         "py": "wǒ"
        },
        {
         "id": "也|yě",
         "py": "yě"
        },
        {
         "id": "很|hěn",
         "py": "hěn"
        },
        {
         "id": "高兴|gāoxìng",
         "py": "gāoxìng"
        },
        {
         "p": "！"
        },
        {
         "id": "你|nǐ",
         "py": "nǐ"
        },
        {
         "id": "是|shì",
         "py": "shì"
        },
        {
         "id": "哪|nǎ",
         "py": "nǎ"
        },
        {
         "id": "国|guó",
         "py": "guó"
        },
        {
         "id": "人|rén",
         "py": "rén"
        },
        {
         "p": "？"
        }
       ]
      },
      {
       "id": "daa75d6f3",
       "who": "A",
       "en": "I'm British. Are you Chinese?",
       "text": "我是英国人。你是中国人吗？",
       "tokens": [
        {
         "id": "我|wǒ",
         "py": "wǒ"
        },
        {
         "id": "是|shì",
         "py": "shì"
        },
        {
         "name": "英国",
         "py": "Yīngguó"
        },
        {
         "id": "人|rén",
         "py": "rén"
        },
        {
         "p": "。"
        },
        {
         "id": "你|nǐ",
         "py": "nǐ"
        },
        {
         "id": "是|shì",
         "py": "shì"
        },
        {
         "id": "中国|Zhōngguó",
         "py": "Zhōngguó"
        },
        {
         "id": "人|rén",
         "py": "rén"
        },
        {
         "id": "吗|ma",
         "py": "ma"
        },
        {
         "p": "？"
        }
       ]
      },
      {
       "id": "d74574479",
       "who": "B",
       "en": "Yes, I'm Chinese.",
       "text": "是，我是中国人。",
       "tokens": [
        {
         "id": "是|shì",
         "py": "shì"
        },
        {
         "p": "，"
        },
        {
         "id": "我|wǒ",
         "py": "wǒ"
        },
        {
         "id": "是|shì",
         "py": "shì"
        },
        {
         "id": "中国|Zhōngguó",
         "py": "Zhōngguó"
        },
        {
         "id": "人|rén",
         "py": "rén"
        },
        {
         "p": "。"
        }
       ]
      },
      {
       "id": "d7d95ed9e",
       "who": "A",
       "en": "Who's that?",
       "text": "那是谁？",
       "tokens": [
        {
         "id": "那|nà",
         "py": "nà"
        },
        {
         "id": "是|shì",
         "py": "shì"
        },
        {
         "id": "谁|shéi",
         "py": "shéi"
        },
        {
         "p": "？"
        }
       ]
      },
      {
       "id": "d44d6eb12",
       "who": "B",
       "en": "That's my friend Xiaoming.",
       "text": "那是我的朋友小明。",
       "tokens": [
        {
         "id": "那|nà",
         "py": "nà"
        },
        {
         "id": "是|shì",
         "py": "shì"
        },
        {
         "id": "我|wǒ",
         "py": "wǒ"
        },
        {
         "id": "的|de",
         "py": "de"
        },
        {
         "id": "朋友|péngyou",
         "py": "péngyou"
        },
        {
         "name": "小明",
         "py": "Xiǎomíng"
        },
        {
         "p": "。"
        }
       ]
      },
      {
       "id": "dc508a846",
       "who": "A",
       "en": "Is he Chinese too?",
       "text": "他也是中国人吗？",
       "tokens": [
        {
         "id": "他|tā",
         "py": "tā"
        },
        {
         "id": "也|yě",
         "py": "yě"
        },
        {
         "id": "是|shì",
         "py": "shì"
        },
        {
         "id": "中国|Zhōngguó",
         "py": "Zhōngguó"
        },
        {
         "id": "人|rén",
         "py": "rén"
        },
        {
         "id": "吗|ma",
         "py": "ma"
        },
        {
         "p": "？"
        }
       ]
      },
      {
       "id": "d097e1941",
       "who": "B",
       "en": "Yes. He's my classmate too.",
       "text": "是。他也是我的同学。",
       "tokens": [
        {
         "id": "是|shì",
         "py": "shì"
        },
        {
         "p": "。"
        },
        {
         "id": "他|tā",
         "py": "tā"
        },
        {
         "id": "也|yě",
         "py": "yě"
        },
        {
         "id": "是|shì",
         "py": "shì"
        },
        {
         "id": "我|wǒ",
         "py": "wǒ"
        },
        {
         "id": "的|de",
         "py": "de"
        },
        {
         "id": "同学|tóngxué",
         "py": "tóngxué"
        },
        {
         "p": "。"
        }
       ]
      }
     ],
     "builds": [
      {
       "id": "b97d2d338",
       "text": "你是哪国人？",
       "en": "Where are you from?",
       "pattern": "S V O",
       "chunks": [
        {
         "role": "S",
         "words": [
          "你|nǐ"
         ]
        },
        {
         "role": "V",
         "words": [
          "是|shì"
         ]
        },
        {
         "role": "O",
         "words": [
          "哪|nǎ",
          "国|guó",
          "人|rén"
         ]
        }
       ],
       "punct": [
        {
         "at": 3,
         "p": "？"
        }
       ],
       "py": [
        "nǐ",
        "shì",
        "nǎ",
        "guó",
        "rén"
       ]
      },
      {
       "id": "b6e38d936",
       "text": "我是中国人。",
       "en": "I'm Chinese.",
       "pattern": "S V O",
       "chunks": [
        {
         "role": "S",
         "words": [
          "我|wǒ"
         ]
        },
        {
         "role": "V",
         "words": [
          "是|shì"
         ]
        },
        {
         "role": "O",
         "words": [
          "中国|Zhōngguó",
          "人|rén"
         ]
        }
       ],
       "punct": [
        {
         "at": 3,
         "p": "。"
        }
       ],
       "py": [
        "wǒ",
        "shì",
        "Zhōngguó",
        "rén"
       ]
      },
      {
       "id": "b7d95ed9e",
       "text": "那是谁？",
       "en": "Who's that?",
       "pattern": "S V O",
       "chunks": [
        {
         "role": "S",
         "words": [
          "那|nà"
         ]
        },
        {
         "role": "V",
         "words": [
          "是|shì"
         ]
        },
        {
         "role": "O",
         "words": [
          "谁|shéi"
         ]
        }
       ],
       "punct": [
        {
         "at": 3,
         "p": "？"
        }
       ],
       "py": [
        "nà",
        "shì",
        "shéi"
       ]
      },
      {
       "id": "b811cf4a2",
       "text": "他是我的朋友。",
       "en": "He's my friend.",
       "pattern": "S V O",
       "chunks": [
        {
         "role": "S",
         "words": [
          "他|tā"
         ]
        },
        {
         "role": "V",
         "words": [
          "是|shì"
         ]
        },
        {
         "role": "O",
         "words": [
          "我|wǒ",
          "的|de",
          "朋友|péngyou"
         ]
        }
       ],
       "punct": [
        {
         "at": 3,
         "p": "。"
        }
       ],
       "py": [
        "tā",
        "shì",
        "wǒ",
        "de",
        "péngyou"
       ]
      }
     ]
    },
    {
     "id": "me-3",
     "title": "How old?",
     "words": [
      "孩子|háizi",
      "小朋友|xiǎopéngyǒu",
      "几|jǐ",
      "岁|suì",
      "八|bā",
      "小|xiǎo",
      "今年|jīnnián",
      "多|duō",
      "大|dà",
      "十|shí"
     ],
     "dialogue": [
      {
       "id": "db5fe5341",
       "who": "A",
       "en": "Teacher Li, is this your child?",
       "text": "李老师，这是您的孩子吗？",
       "tokens": [
        {
         "name": "李",
         "py": "Lǐ"
        },
        {
         "id": "老师|lǎoshī",
         "py": "lǎoshī"
        },
        {
         "p": "，"
        },
        {
         "id": "这|zhè",
         "py": "zhè"
        },
        {
         "id": "是|shì",
         "py": "shì"
        },
        {
         "id": "您|nín",
         "py": "nín"
        },
        {
         "id": "的|de",
         "py": "de"
        },
        {
         "id": "孩子|háizi",
         "py": "háizi"
        },
        {
         "id": "吗|ma",
         "py": "ma"
        },
        {
         "p": "？"
        }
       ]
      },
      {
       "id": "d0a86dca3",
       "who": "B",
       "en": "Yes, he's my child.",
       "text": "是，他是我的孩子。",
       "tokens": [
        {
         "id": "是|shì",
         "py": "shì"
        },
        {
         "p": "，"
        },
        {
         "id": "他|tā",
         "py": "tā"
        },
        {
         "id": "是|shì",
         "py": "shì"
        },
        {
         "id": "我|wǒ",
         "py": "wǒ"
        },
        {
         "id": "的|de",
         "py": "de"
        },
        {
         "id": "孩子|háizi",
         "py": "háizi"
        },
        {
         "p": "。"
        }
       ]
      },
      {
       "id": "d248622e7",
       "who": "A",
       "en": "How old are you, little one?",
       "text": "小朋友，你几岁？",
       "tokens": [
        {
         "id": "小朋友|xiǎopéngyǒu",
         "py": "xiǎopéngyǒu"
        },
        {
         "p": "，"
        },
        {
         "id": "你|nǐ",
         "py": "nǐ"
        },
        {
         "id": "几|jǐ",
         "py": "jǐ"
        },
        {
         "id": "岁|suì",
         "py": "suì"
        },
        {
         "p": "？"
        }
       ]
      },
      {
       "id": "dd5b86037",
       "who": "C",
       "en": "I'm eight!",
       "text": "我八岁！",
       "tokens": [
        {
         "id": "我|wǒ",
         "py": "wǒ"
        },
        {
         "id": "八|bā",
         "py": "bā"
        },
        {
         "id": "岁|suì",
         "py": "suì"
        },
        {
         "p": "！"
        }
       ]
      },
      {
       "id": "d9e57264f",
       "who": "B",
       "en": "He's little. And you? How old are you this year?",
       "text": "他很小。你呢？你今年多大？",
       "tokens": [
        {
         "id": "他|tā",
         "py": "tā"
        },
        {
         "id": "很|hěn",
         "py": "hěn"
        },
        {
         "id": "小|xiǎo",
         "py": "xiǎo"
        },
        {
         "p": "。"
        },
        {
         "id": "你|nǐ",
         "py": "nǐ"
        },
        {
         "id": "呢|ne",
         "py": "ne"
        },
        {
         "p": "？"
        },
        {
         "id": "你|nǐ",
         "py": "nǐ"
        },
        {
         "id": "今年|jīnnián",
         "py": "jīnnián"
        },
        {
         "id": "多|duō",
         "py": "duō"
        },
        {
         "id": "大|dà",
         "py": "dà"
        },
        {
         "p": "？"
        }
       ]
      },
      {
       "id": "d9f3ca3b0",
       "who": "A",
       "en": "I'm eighteen this year.",
       "text": "我今年十八岁。",
       "tokens": [
        {
         "id": "我|wǒ",
         "py": "wǒ"
        },
        {
         "id": "今年|jīnnián",
         "py": "jīnnián"
        },
        {
         "id": "十|shí",
         "py": "shí"
        },
        {
         "id": "八|bā",
         "py": "bā"
        },
        {
         "id": "岁|suì",
         "py": "suì"
        },
        {
         "p": "。"
        }
       ]
      },
      {
       "id": "de1ed7353",
       "who": "B",
       "en": "And David?",
       "text": "大卫呢？",
       "tokens": [
        {
         "name": "大卫",
         "py": "Dàwèi"
        },
        {
         "id": "呢|ne",
         "py": "ne"
        },
        {
         "p": "？"
        }
       ]
      },
      {
       "id": "d1a73fbc0",
       "who": "A",
       "en": "He's eighteen too.",
       "text": "他也十八岁。",
       "tokens": [
        {
         "id": "他|tā",
         "py": "tā"
        },
        {
         "id": "也|yě",
         "py": "yě"
        },
        {
         "id": "十|shí",
         "py": "shí"
        },
        {
         "id": "八|bā",
         "py": "bā"
        },
        {
         "id": "岁|suì",
         "py": "suì"
        },
        {
         "p": "。"
        }
       ]
      }
     ],
     "builds": [
      {
       "id": "b3a39f1e4",
       "text": "你几岁？",
       "en": "How old are you? (to a child)",
       "pattern": "S V",
       "chunks": [
        {
         "role": "S",
         "words": [
          "你|nǐ"
         ]
        },
        {
         "role": "V",
         "words": [
          "几|jǐ",
          "岁|suì"
         ]
        }
       ],
       "punct": [
        {
         "at": 2,
         "p": "？"
        }
       ],
       "py": [
        "nǐ",
        "jǐ",
        "suì"
       ]
      },
      {
       "id": "b7876d244",
       "text": "他很小。",
       "en": "He's little.",
       "pattern": "S A V",
       "chunks": [
        {
         "role": "S",
         "words": [
          "他|tā"
         ]
        },
        {
         "role": "A",
         "words": [
          "很|hěn"
         ]
        },
        {
         "role": "V",
         "words": [
          "小|xiǎo"
         ]
        }
       ],
       "punct": [
        {
         "at": 3,
         "p": "。"
        }
       ],
       "py": [
        "tā",
        "hěn",
        "xiǎo"
       ]
      },
      {
       "id": "b1237e4cb",
       "text": "这是我的孩子。",
       "en": "This is my child.",
       "pattern": "S V O",
       "chunks": [
        {
         "role": "S",
         "words": [
          "这|zhè"
         ]
        },
        {
         "role": "V",
         "words": [
          "是|shì"
         ]
        },
        {
         "role": "O",
         "words": [
          "我|wǒ",
          "的|de",
          "孩子|háizi"
         ]
        }
       ],
       "punct": [
        {
         "at": 3,
         "p": "。"
        }
       ],
       "py": [
        "zhè",
        "shì",
        "wǒ",
        "de",
        "háizi"
       ]
      },
      {
       "id": "b9f3ca3b0",
       "text": "我今年十八岁。",
       "en": "I'm eighteen this year.",
       "pattern": "S T V",
       "chunks": [
        {
         "role": "S",
         "words": [
          "我|wǒ"
         ]
        },
        {
         "role": "T",
         "words": [
          "今年|jīnnián"
         ]
        },
        {
         "role": "V",
         "words": [
          "十|shí",
          "八|bā",
          "岁|suì"
         ]
        }
       ],
       "punct": [
        {
         "at": 3,
         "p": "。"
        }
       ],
       "py": [
        "wǒ",
        "jīnnián",
        "shí",
        "bā",
        "suì"
       ]
      }
     ]
    }
   ]
  },
  {
   "id": "numbers",
   "title": "Numbers and dates",
   "zh": "数字",
   "topic": "Basic information: event information (事件信息)",
   "notes": [
    "Before a measure word, \"two\" is 两 liǎng, not 二 èr: 两个人, two people. 二 is for counting and for numbers like 十二.",
    "Dates run from big to small: year, month, day. Years are read digit by digit (二零二六年), and in speech the day of the month is 号."
   ],
   "lessons": [
    {
     "id": "numbers-1",
     "title": "Counting",
     "words": [
      "一|yī",
      "二|èr",
      "三|sān",
      "四|sì",
      "五|wǔ",
      "六|liù",
      "七|qī",
      "九|jiǔ",
      "两|liǎng",
      "个|gè"
     ],
     "dialogue": [
      {
       "id": "dbf4bcabc",
       "who": "A",
       "en": "How many of you are there?",
       "text": "你们几个人？",
       "tokens": [
        {
         "id": "你们|nǐmen",
         "py": "nǐmen"
        },
        {
         "id": "几|jǐ",
         "py": "jǐ"
        },
        {
         "id": "个|gè",
         "py": "gè"
        },
        {
         "id": "人|rén",
         "py": "rén"
        },
        {
         "p": "？"
        }
       ]
      },
      {
       "id": "d353df049",
       "who": "B",
       "en": "One, two, three, four. There are four of us.",
       "text": "一，二，三，四。我们四个人。",
       "tokens": [
        {
         "id": "一|yī",
         "py": "yī"
        },
        {
         "p": "，"
        },
        {
         "id": "二|èr",
         "py": "èr"
        },
        {
         "p": "，"
        },
        {
         "id": "三|sān",
         "py": "sān"
        },
        {
         "p": "，"
        },
        {
         "id": "四|sì",
         "py": "sì"
        },
        {
         "p": "。"
        },
        {
         "id": "我们|wǒmen",
         "py": "wǒmen"
        },
        {
         "id": "四|sì",
         "py": "sì"
        },
        {
         "id": "个|gè",
         "py": "gè"
        },
        {
         "id": "人|rén",
         "py": "rén"
        },
        {
         "p": "。"
        }
       ]
      },
      {
       "id": "d3630d313",
       "who": "A",
       "en": "And them?",
       "text": "他们呢？",
       "tokens": [
        {
         "id": "他们|tāmen",
         "py": "tāmen"
        },
        {
         "id": "呢|ne",
         "py": "ne"
        },
        {
         "p": "？"
        }
       ]
      },
      {
       "id": "da2409c42",
       "who": "B",
       "en": "There are two of them.",
       "text": "他们两个人。",
       "tokens": [
        {
         "id": "他们|tāmen",
         "py": "tāmen"
        },
        {
         "id": "两|liǎng",
         "py": "liǎng"
        },
        {
         "id": "个|gè",
         "py": "gè"
        },
        {
         "id": "人|rén",
         "py": "rén"
        },
        {
         "p": "。"
        }
       ]
      },
      {
       "id": "ddf817dd4",
       "who": "A",
       "en": "How old is Xiaoming?",
       "text": "小明几岁？",
       "tokens": [
        {
         "name": "小明",
         "py": "Xiǎomíng"
        },
        {
         "id": "几|jǐ",
         "py": "jǐ"
        },
        {
         "id": "岁|suì",
         "py": "suì"
        },
        {
         "p": "？"
        }
       ]
      },
      {
       "id": "dfe4e2210",
       "who": "B",
       "en": "He's seven. His friend is nine.",
       "text": "他七岁。他的朋友九岁。",
       "tokens": [
        {
         "id": "他|tā",
         "py": "tā"
        },
        {
         "id": "七|qī",
         "py": "qī"
        },
        {
         "id": "岁|suì",
         "py": "suì"
        },
        {
         "p": "。"
        },
        {
         "id": "他|tā",
         "py": "tā"
        },
        {
         "id": "的|de",
         "py": "de"
        },
        {
         "id": "朋友|péngyou",
         "py": "péngyou"
        },
        {
         "id": "九|jiǔ",
         "py": "jiǔ"
        },
        {
         "id": "岁|suì",
         "py": "suì"
        },
        {
         "p": "。"
        }
       ]
      },
      {
       "id": "d7b4c9de9",
       "who": "A",
       "en": "What number is that?",
       "text": "那是几？",
       "tokens": [
        {
         "id": "那|nà",
         "py": "nà"
        },
        {
         "id": "是|shì",
         "py": "shì"
        },
        {
         "id": "几|jǐ",
         "py": "jǐ"
        },
        {
         "p": "？"
        }
       ]
      },
      {
       "id": "d818cbba9",
       "who": "B",
       "en": "That's six, not nine!",
       "text": "那是六，不是九！",
       "tokens": [
        {
         "id": "那|nà",
         "py": "nà"
        },
        {
         "id": "是|shì",
         "py": "shì"
        },
        {
         "id": "六|liù",
         "py": "liù"
        },
        {
         "p": "，"
        },
        {
         "id": "不|bù",
         "py": "bú"
        },
        {
         "id": "是|shì",
         "py": "shì"
        },
        {
         "id": "九|jiǔ",
         "py": "jiǔ"
        },
        {
         "p": "！"
        }
       ]
      },
      {
       "id": "dd382f712",
       "who": "A",
       "en": "Five, six, seven, eight.",
       "text": "五，六，七，八。",
       "tokens": [
        {
         "id": "五|wǔ",
         "py": "wǔ"
        },
        {
         "p": "，"
        },
        {
         "id": "六|liù",
         "py": "liù"
        },
        {
         "p": "，"
        },
        {
         "id": "七|qī",
         "py": "qī"
        },
        {
         "p": "，"
        },
        {
         "id": "八|bā",
         "py": "bā"
        },
        {
         "p": "。"
        }
       ]
      }
     ],
     "builds": [
      {
       "id": "b59dc91a3",
       "text": "我们四个人。",
       "en": "There are four of us.",
       "pattern": "S V",
       "chunks": [
        {
         "role": "S",
         "words": [
          "我们|wǒmen"
         ]
        },
        {
         "role": "V",
         "words": [
          "四|sì",
          "个|gè",
          "人|rén"
         ]
        }
       ],
       "punct": [
        {
         "at": 2,
         "p": "。"
        }
       ],
       "py": [
        "wǒmen",
        "sì",
        "gè",
        "rén"
       ]
      },
      {
       "id": "bbf4bcabc",
       "text": "你们几个人？",
       "en": "How many of you are there?",
       "pattern": "S V",
       "chunks": [
        {
         "role": "S",
         "words": [
          "你们|nǐmen"
         ]
        },
        {
         "role": "V",
         "words": [
          "几|jǐ",
          "个|gè",
          "人|rén"
         ]
        }
       ],
       "punct": [
        {
         "at": 2,
         "p": "？"
        }
       ],
       "py": [
        "nǐmen",
        "jǐ",
        "gè",
        "rén"
       ]
      },
      {
       "id": "b7eed4bdc",
       "text": "他七岁。",
       "en": "He's seven.",
       "pattern": "S V",
       "chunks": [
        {
         "role": "S",
         "words": [
          "他|tā"
         ]
        },
        {
         "role": "V",
         "words": [
          "七|qī",
          "岁|suì"
         ]
        }
       ],
       "punct": [
        {
         "at": 2,
         "p": "。"
        }
       ],
       "py": [
        "tā",
        "qī",
        "suì"
       ]
      },
      {
       "id": "b6520679a",
       "text": "那是六。",
       "en": "That's six.",
       "pattern": "S V O",
       "chunks": [
        {
         "role": "S",
         "words": [
          "那|nà"
         ]
        },
        {
         "role": "V",
         "words": [
          "是|shì"
         ]
        },
        {
         "role": "O",
         "words": [
          "六|liù"
         ]
        }
       ],
       "punct": [
        {
         "at": 3,
         "p": "。"
        }
       ],
       "py": [
        "nà",
        "shì",
        "liù"
       ]
      }
     ]
    },
    {
     "id": "numbers-2",
     "title": "Dates",
     "words": [
      "今天|jīntiān",
      "明天|míngtiān",
      "昨天|zuótiān",
      "月|yuè",
      "号|hào",
      "星期|xīngqī",
      "星期天|xīngqītiān",
      "年|nián",
      "零|líng",
      "去年|qùnián",
      "明年|míngnián"
     ],
     "dialogue": [
      {
       "id": "dc361d0fa",
       "who": "A",
       "en": "What's the date today?",
       "text": "今天几月几号？",
       "tokens": [
        {
         "id": "今天|jīntiān",
         "py": "jīntiān"
        },
        {
         "id": "几|jǐ",
         "py": "jǐ"
        },
        {
         "id": "月|yuè",
         "py": "yuè"
        },
        {
         "id": "几|jǐ",
         "py": "jǐ"
        },
        {
         "id": "号|hào",
         "py": "hào"
        },
        {
         "p": "？"
        }
       ]
      },
      {
       "id": "d47803da4",
       "who": "B",
       "en": "Today is the 27th of September.",
       "text": "今天九月二十七号。",
       "tokens": [
        {
         "id": "今天|jīntiān",
         "py": "jīntiān"
        },
        {
         "id": "九|jiǔ",
         "py": "jiǔ"
        },
        {
         "id": "月|yuè",
         "py": "yuè"
        },
        {
         "id": "二|èr",
         "py": "èr"
        },
        {
         "id": "十|shí",
         "py": "shí"
        },
        {
         "id": "七|qī",
         "py": "qī"
        },
        {
         "id": "号|hào",
         "py": "hào"
        },
        {
         "p": "。"
        }
       ]
      },
      {
       "id": "d4fb1a288",
       "who": "A",
       "en": "What day is it today?",
       "text": "今天星期几？",
       "tokens": [
        {
         "id": "今天|jīntiān",
         "py": "jīntiān"
        },
        {
         "id": "星期|xīngqī",
         "py": "xīngqī"
        },
        {
         "id": "几|jǐ",
         "py": "jǐ"
        },
        {
         "p": "？"
        }
       ]
      },
      {
       "id": "d48fa101a",
       "who": "B",
       "en": "Today is Saturday, tomorrow is Sunday.",
       "text": "今天星期六，明天星期天。",
       "tokens": [
        {
         "id": "今天|jīntiān",
         "py": "jīntiān"
        },
        {
         "id": "星期|xīngqī",
         "py": "xīngqī"
        },
        {
         "id": "六|liù",
         "py": "liù"
        },
        {
         "p": "，"
        },
        {
         "id": "明天|míngtiān",
         "py": "míngtiān"
        },
        {
         "id": "星期天|xīngqītiān",
         "py": "xīngqītiān"
        },
        {
         "p": "。"
        }
       ]
      },
      {
       "id": "d9c39ee25",
       "who": "A",
       "en": "Yesterday was Friday.",
       "text": "昨天是星期五。",
       "tokens": [
        {
         "id": "昨天|zuótiān",
         "py": "zuótiān"
        },
        {
         "id": "是|shì",
         "py": "shì"
        },
        {
         "id": "星期|xīngqī",
         "py": "xīngqī"
        },
        {
         "id": "五|wǔ",
         "py": "wǔ"
        },
        {
         "p": "。"
        }
       ]
      },
      {
       "id": "db7b84a70",
       "who": "B",
       "en": "This year is 2026.",
       "text": "今年是二零二六年。",
       "tokens": [
        {
         "id": "今年|jīnnián",
         "py": "jīnnián"
        },
        {
         "id": "是|shì",
         "py": "shì"
        },
        {
         "id": "二|èr",
         "py": "èr"
        },
        {
         "id": "零|líng",
         "py": "líng"
        },
        {
         "id": "二|èr",
         "py": "èr"
        },
        {
         "id": "六|liù",
         "py": "liù"
        },
        {
         "id": "年|nián",
         "py": "nián"
        },
        {
         "p": "。"
        }
       ]
      },
      {
       "id": "d5a45b121",
       "who": "A",
       "en": "Last year was 2025, next year is 2027.",
       "text": "去年是二零二五年，明年是二零二七年。",
       "tokens": [
        {
         "id": "去年|qùnián",
         "py": "qùnián"
        },
        {
         "id": "是|shì",
         "py": "shì"
        },
        {
         "id": "二|èr",
         "py": "èr"
        },
        {
         "id": "零|líng",
         "py": "líng"
        },
        {
         "id": "二|èr",
         "py": "èr"
        },
        {
         "id": "五|wǔ",
         "py": "wǔ"
        },
        {
         "id": "年|nián",
         "py": "nián"
        },
        {
         "p": "，"
        },
        {
         "id": "明年|míngnián",
         "py": "míngnián"
        },
        {
         "id": "是|shì",
         "py": "shì"
        },
        {
         "id": "二|èr",
         "py": "èr"
        },
        {
         "id": "零|líng",
         "py": "líng"
        },
        {
         "id": "二|èr",
         "py": "èr"
        },
        {
         "id": "七|qī",
         "py": "qī"
        },
        {
         "id": "年|nián",
         "py": "nián"
        },
        {
         "p": "。"
        }
       ]
      }
     ],
     "builds": [
      {
       "id": "b6bc43d4e",
       "text": "今天星期六。",
       "en": "Today is Saturday.",
       "pattern": "S V",
       "chunks": [
        {
         "role": "S",
         "words": [
          "今天|jīntiān"
         ]
        },
        {
         "role": "V",
         "words": [
          "星期|xīngqī",
          "六|liù"
         ]
        }
       ],
       "punct": [
        {
         "at": 2,
         "p": "。"
        }
       ],
       "py": [
        "jīntiān",
        "xīngqī",
        "liù"
       ]
      },
      {
       "id": "be7240336",
       "text": "明天是星期天。",
       "en": "Tomorrow is Sunday.",
       "pattern": "S V O",
       "chunks": [
        {
         "role": "S",
         "words": [
          "明天|míngtiān"
         ]
        },
        {
         "role": "V",
         "words": [
          "是|shì"
         ]
        },
        {
         "role": "O",
         "words": [
          "星期天|xīngqītiān"
         ]
        }
       ],
       "punct": [
        {
         "at": 3,
         "p": "。"
        }
       ],
       "py": [
        "míngtiān",
        "shì",
        "xīngqītiān"
       ]
      },
      {
       "id": "bc361d0fa",
       "text": "今天几月几号？",
       "en": "What's the date today?",
       "pattern": "S V",
       "chunks": [
        {
         "role": "S",
         "words": [
          "今天|jīntiān"
         ]
        },
        {
         "role": "V",
         "words": [
          "几|jǐ",
          "月|yuè",
          "几|jǐ",
          "号|hào"
         ]
        }
       ],
       "punct": [
        {
         "at": 2,
         "p": "？"
        }
       ],
       "py": [
        "jīntiān",
        "jǐ",
        "yuè",
        "jǐ",
        "hào"
       ]
      },
      {
       "id": "bb7b84a70",
       "text": "今年是二零二六年。",
       "en": "This year is 2026.",
       "pattern": "S V O",
       "chunks": [
        {
         "role": "S",
         "words": [
          "今年|jīnnián"
         ]
        },
        {
         "role": "V",
         "words": [
          "是|shì"
         ]
        },
        {
         "role": "O",
         "words": [
          "二|èr",
          "零|líng",
          "二|èr",
          "六|liù",
          "年|nián"
         ]
        }
       ],
       "punct": [
        {
         "at": 3,
         "p": "。"
        }
       ],
       "py": [
        "jīnnián",
        "shì",
        "èr",
        "líng",
        "èr",
        "liù",
        "nián"
       ]
      }
     ]
    }
   ]
  },
  {
   "id": "family",
   "title": "Family",
   "zh": "家人",
   "topic": "Basic information: personal information, family and friends (个人信息)",
   "notes": [
    "Chinese names older and younger siblings differently: 哥哥 and 姐姐 are older brother and sister, 弟弟 and 妹妹 younger ones.",
    "个 is the everyday measure word, but animals take 只: 一只猫, a cat."
   ],
   "lessons": [
    {
     "id": "family-1",
     "title": "My family",
     "words": [
      "家|jiā",
      "有|yǒu",
      "爸爸|bàba",
      "妈妈|māma",
      "哥哥|gēge",
      "姐姐|jiějie",
      "弟弟|dìdi",
      "妹妹|mèimei",
      "和|hé",
      "没有|méiyǒu"
     ],
     "dialogue": [
      {
       "id": "d70a1dbda",
       "who": "A",
       "en": "How many people are in your family?",
       "text": "你家有几个人？",
       "tokens": [
        {
         "id": "你|nǐ",
         "py": "nǐ"
        },
        {
         "id": "家|jiā",
         "py": "jiā"
        },
        {
         "id": "有|yǒu",
         "py": "yǒu"
        },
        {
         "id": "几|jǐ",
         "py": "jǐ"
        },
        {
         "id": "个|gè",
         "py": "gè"
        },
        {
         "id": "人|rén",
         "py": "rén"
        },
        {
         "p": "？"
        }
       ]
      },
      {
       "id": "d9106fa67",
       "who": "B",
       "en": "There are five of us.",
       "text": "我家有五个人。",
       "tokens": [
        {
         "id": "我|wǒ",
         "py": "wǒ"
        },
        {
         "id": "家|jiā",
         "py": "jiā"
        },
        {
         "id": "有|yǒu",
         "py": "yǒu"
        },
        {
         "id": "五|wǔ",
         "py": "wǔ"
        },
        {
         "id": "个|gè",
         "py": "gè"
        },
        {
         "id": "人|rén",
         "py": "rén"
        },
        {
         "p": "。"
        }
       ]
      },
      {
       "id": "d9656d90d",
       "who": "B",
       "en": "Dad, Mum, my older brother, my younger sister and me.",
       "text": "爸爸，妈妈，哥哥，妹妹和我。",
       "tokens": [
        {
         "id": "爸爸|bàba",
         "py": "bàba"
        },
        {
         "p": "，"
        },
        {
         "id": "妈妈|māma",
         "py": "māma"
        },
        {
         "p": "，"
        },
        {
         "id": "哥哥|gēge",
         "py": "gēge"
        },
        {
         "p": "，"
        },
        {
         "id": "妹妹|mèimei",
         "py": "mèimei"
        },
        {
         "id": "和|hé",
         "py": "hé"
        },
        {
         "id": "我|wǒ",
         "py": "wǒ"
        },
        {
         "p": "。"
        }
       ]
      },
      {
       "id": "dfe439181",
       "who": "A",
       "en": "Do you have an older sister?",
       "text": "你有姐姐吗？",
       "tokens": [
        {
         "id": "你|nǐ",
         "py": "nǐ"
        },
        {
         "id": "有|yǒu",
         "py": "yǒu"
        },
        {
         "id": "姐姐|jiějie",
         "py": "jiějie"
        },
        {
         "id": "吗|ma",
         "py": "ma"
        },
        {
         "p": "？"
        }
       ]
      },
      {
       "id": "d7f2b575e",
       "who": "B",
       "en": "I don't have an older sister. And you?",
       "text": "我没有姐姐。你呢？",
       "tokens": [
        {
         "id": "我|wǒ",
         "py": "wǒ"
        },
        {
         "id": "没有|méiyǒu",
         "py": "méiyǒu"
        },
        {
         "id": "姐姐|jiějie",
         "py": "jiějie"
        },
        {
         "p": "。"
        },
        {
         "id": "你|nǐ",
         "py": "nǐ"
        },
        {
         "id": "呢|ne",
         "py": "ne"
        },
        {
         "p": "？"
        }
       ]
      },
      {
       "id": "d1e6d5877",
       "who": "A",
       "en": "I have a younger brother, and no older brother.",
       "text": "我有一个弟弟，没有哥哥。",
       "tokens": [
        {
         "id": "我|wǒ",
         "py": "wǒ"
        },
        {
         "id": "有|yǒu",
         "py": "yǒu"
        },
        {
         "id": "一|yī",
         "py": "yí"
        },
        {
         "id": "个|gè",
         "py": "gè"
        },
        {
         "id": "弟弟|dìdi",
         "py": "dìdi"
        },
        {
         "p": "，"
        },
        {
         "id": "没有|méiyǒu",
         "py": "méiyǒu"
        },
        {
         "id": "哥哥|gēge",
         "py": "gēge"
        },
        {
         "p": "。"
        }
       ]
      },
      {
       "id": "d2ec1a7ed",
       "who": "B",
       "en": "How old is your younger brother?",
       "text": "你的弟弟几岁？",
       "tokens": [
        {
         "id": "你|nǐ",
         "py": "nǐ"
        },
        {
         "id": "的|de",
         "py": "de"
        },
        {
         "id": "弟弟|dìdi",
         "py": "dìdi"
        },
        {
         "id": "几|jǐ",
         "py": "jǐ"
        },
        {
         "id": "岁|suì",
         "py": "suì"
        },
        {
         "p": "？"
        }
       ]
      },
      {
       "id": "d88bc360f",
       "who": "A",
       "en": "He's nine.",
       "text": "他九岁。",
       "tokens": [
        {
         "id": "他|tā",
         "py": "tā"
        },
        {
         "id": "九|jiǔ",
         "py": "jiǔ"
        },
        {
         "id": "岁|suì",
         "py": "suì"
        },
        {
         "p": "。"
        }
       ]
      }
     ],
     "builds": [
      {
       "id": "b9106fa67",
       "text": "我家有五个人。",
       "en": "There are five people in my family.",
       "pattern": "S V O",
       "chunks": [
        {
         "role": "S",
         "words": [
          "我|wǒ",
          "家|jiā"
         ]
        },
        {
         "role": "V",
         "words": [
          "有|yǒu"
         ]
        },
        {
         "role": "O",
         "words": [
          "五|wǔ",
          "个|gè",
          "人|rén"
         ]
        }
       ],
       "punct": [
        {
         "at": 3,
         "p": "。"
        }
       ],
       "py": [
        "wǒ",
        "jiā",
        "yǒu",
        "wǔ",
        "gè",
        "rén"
       ]
      },
      {
       "id": "bb02c6011",
       "text": "我没有姐姐。",
       "en": "I don't have an older sister.",
       "pattern": "S V O",
       "chunks": [
        {
         "role": "S",
         "words": [
          "我|wǒ"
         ]
        },
        {
         "role": "V",
         "words": [
          "没有|méiyǒu"
         ]
        },
        {
         "role": "O",
         "words": [
          "姐姐|jiějie"
         ]
        }
       ],
       "punct": [
        {
         "at": 3,
         "p": "。"
        }
       ],
       "py": [
        "wǒ",
        "méiyǒu",
        "jiějie"
       ]
      },
      {
       "id": "b24f732ef",
       "text": "你有弟弟吗？",
       "en": "Do you have a younger brother?",
       "pattern": "S V O X",
       "chunks": [
        {
         "role": "S",
         "words": [
          "你|nǐ"
         ]
        },
        {
         "role": "V",
         "words": [
          "有|yǒu"
         ]
        },
        {
         "role": "O",
         "words": [
          "弟弟|dìdi"
         ]
        },
        {
         "role": "X",
         "words": [
          "吗|ma"
         ]
        }
       ],
       "punct": [
        {
         "at": 4,
         "p": "？"
        }
       ],
       "py": [
        "nǐ",
        "yǒu",
        "dìdi",
        "ma"
       ]
      },
      {
       "id": "bcdff36f9",
       "text": "我有一个妹妹。",
       "en": "I have a younger sister.",
       "pattern": "S V O",
       "chunks": [
        {
         "role": "S",
         "words": [
          "我|wǒ"
         ]
        },
        {
         "role": "V",
         "words": [
          "有|yǒu"
         ]
        },
        {
         "role": "O",
         "words": [
          "一|yī",
          "个|gè",
          "妹妹|mèimei"
         ]
        }
       ],
       "punct": [
        {
         "at": 3,
         "p": "。"
        }
       ],
       "py": [
        "wǒ",
        "yǒu",
        "yí",
        "gè",
        "mèimei"
       ]
      }
     ]
    },
    {
     "id": "family-2",
     "title": "Sons, daughters and pets",
     "words": [
      "家人|jiārén",
      "儿子|érzi",
      "女儿|nǚ’ér",
      "男朋友|nánpéngyou",
      "女朋友|nǚpéngyou",
      "爱|ài",
      "猫|māo",
      "只|zhī",
      "狗|gǒu",
      "它|tā"
     ],
     "dialogue": [
      {
       "id": "d001da83d",
       "who": "A",
       "en": "Is this your family?",
       "text": "这是你的家人吗？",
       "tokens": [
        {
         "id": "这|zhè",
         "py": "zhè"
        },
        {
         "id": "是|shì",
         "py": "shì"
        },
        {
         "id": "你|nǐ",
         "py": "nǐ"
        },
        {
         "id": "的|de",
         "py": "de"
        },
        {
         "id": "家人|jiārén",
         "py": "jiārén"
        },
        {
         "id": "吗|ma",
         "py": "ma"
        },
        {
         "p": "？"
        }
       ]
      },
      {
       "id": "d53a47f3e",
       "who": "B",
       "en": "Yes. This is my son, and that's my daughter.",
       "text": "是。这是我的儿子，那是我的女儿。",
       "tokens": [
        {
         "id": "是|shì",
         "py": "shì"
        },
        {
         "p": "。"
        },
        {
         "id": "这|zhè",
         "py": "zhè"
        },
        {
         "id": "是|shì",
         "py": "shì"
        },
        {
         "id": "我|wǒ",
         "py": "wǒ"
        },
        {
         "id": "的|de",
         "py": "de"
        },
        {
         "id": "儿子|érzi",
         "py": "érzi"
        },
        {
         "p": "，"
        },
        {
         "id": "那|nà",
         "py": "nà"
        },
        {
         "id": "是|shì",
         "py": "shì"
        },
        {
         "id": "我|wǒ",
         "py": "wǒ"
        },
        {
         "id": "的|de",
         "py": "de"
        },
        {
         "id": "女儿|nǚ’ér",
         "py": "nǚ’ér"
        },
        {
         "p": "。"
        }
       ]
      },
      {
       "id": "dea48ec69",
       "who": "A",
       "en": "Does your son have a girlfriend?",
       "text": "你的儿子有女朋友吗？",
       "tokens": [
        {
         "id": "你|nǐ",
         "py": "nǐ"
        },
        {
         "id": "的|de",
         "py": "de"
        },
        {
         "id": "儿子|érzi",
         "py": "érzi"
        },
        {
         "id": "有|yǒu",
         "py": "yǒu"
        },
        {
         "id": "女朋友|nǚpéngyou",
         "py": "nǚpéngyou"
        },
        {
         "id": "吗|ma",
         "py": "ma"
        },
        {
         "p": "？"
        }
       ]
      },
      {
       "id": "dd2d2cf32",
       "who": "B",
       "en": "He does, he loves her very much.",
       "text": "有，他很爱她。",
       "tokens": [
        {
         "id": "有|yǒu",
         "py": "yǒu"
        },
        {
         "p": "，"
        },
        {
         "id": "他|tā",
         "py": "tā"
        },
        {
         "id": "很|hěn",
         "py": "hěn"
        },
        {
         "id": "爱|ài",
         "py": "ài"
        },
        {
         "id": "她|tā",
         "py": "tā"
        },
        {
         "p": "。"
        }
       ]
      },
      {
       "id": "d862797ae",
       "who": "A",
       "en": "And your daughter? Does she have a boyfriend?",
       "text": "你的女儿呢？她有男朋友吗？",
       "tokens": [
        {
         "id": "你|nǐ",
         "py": "nǐ"
        },
        {
         "id": "的|de",
         "py": "de"
        },
        {
         "id": "女儿|nǚ’ér",
         "py": "nǚ’ér"
        },
        {
         "id": "呢|ne",
         "py": "ne"
        },
        {
         "p": "？"
        },
        {
         "id": "她|tā",
         "py": "tā"
        },
        {
         "id": "有|yǒu",
         "py": "yǒu"
        },
        {
         "id": "男朋友|nánpéngyou",
         "py": "nánpéngyou"
        },
        {
         "id": "吗|ma",
         "py": "ma"
        },
        {
         "p": "？"
        }
       ]
      },
      {
       "id": "d5f53c2b5",
       "who": "B",
       "en": "She's eight! She loves our cat.",
       "text": "她八岁！她爱我们家的猫。",
       "tokens": [
        {
         "id": "她|tā",
         "py": "tā"
        },
        {
         "id": "八|bā",
         "py": "bā"
        },
        {
         "id": "岁|suì",
         "py": "suì"
        },
        {
         "p": "！"
        },
        {
         "id": "她|tā",
         "py": "tā"
        },
        {
         "id": "爱|ài",
         "py": "ài"
        },
        {
         "id": "我们|wǒmen",
         "py": "wǒmen"
        },
        {
         "id": "家|jiā",
         "py": "jiā"
        },
        {
         "id": "的|de",
         "py": "de"
        },
        {
         "id": "猫|māo",
         "py": "māo"
        },
        {
         "p": "。"
        }
       ]
      },
      {
       "id": "db49a661d",
       "who": "A",
       "en": "We have a dog. It's called Dahei.",
       "text": "我家有一只狗，它叫大黑。",
       "tokens": [
        {
         "id": "我|wǒ",
         "py": "wǒ"
        },
        {
         "id": "家|jiā",
         "py": "jiā"
        },
        {
         "id": "有|yǒu",
         "py": "yǒu"
        },
        {
         "id": "一|yī",
         "py": "yì"
        },
        {
         "id": "只|zhī",
         "py": "zhī"
        },
        {
         "id": "狗|gǒu",
         "py": "gǒu"
        },
        {
         "p": "，"
        },
        {
         "id": "它|tā",
         "py": "tā"
        },
        {
         "id": "叫|jiào",
         "py": "jiào"
        },
        {
         "name": "大黑",
         "py": "Dà Hēi"
        },
        {
         "p": "。"
        }
       ]
      }
     ],
     "builds": [
      {
       "id": "b9be2a041",
       "text": "这是我的儿子。",
       "en": "This is my son.",
       "pattern": "S V O",
       "chunks": [
        {
         "role": "S",
         "words": [
          "这|zhè"
         ]
        },
        {
         "role": "V",
         "words": [
          "是|shì"
         ]
        },
        {
         "role": "O",
         "words": [
          "我|wǒ",
          "的|de",
          "儿子|érzi"
         ]
        }
       ],
       "punct": [
        {
         "at": 3,
         "p": "。"
        }
       ],
       "py": [
        "zhè",
        "shì",
        "wǒ",
        "de",
        "érzi"
       ]
      },
      {
       "id": "baed18e95",
       "text": "他很爱她。",
       "en": "He loves her very much.",
       "pattern": "S A V O",
       "chunks": [
        {
         "role": "S",
         "words": [
          "他|tā"
         ]
        },
        {
         "role": "A",
         "words": [
          "很|hěn"
         ]
        },
        {
         "role": "V",
         "words": [
          "爱|ài"
         ]
        },
        {
         "role": "O",
         "words": [
          "她|tā"
         ]
        }
       ],
       "punct": [
        {
         "at": 4,
         "p": "。"
        }
       ],
       "py": [
        "tā",
        "hěn",
        "ài",
        "tā"
       ]
      },
      {
       "id": "b55be5c31",
       "text": "我家有一只狗。",
       "en": "We have a dog.",
       "pattern": "S V O",
       "chunks": [
        {
         "role": "S",
         "words": [
          "我|wǒ",
          "家|jiā"
         ]
        },
        {
         "role": "V",
         "words": [
          "有|yǒu"
         ]
        },
        {
         "role": "O",
         "words": [
          "一|yī",
          "只|zhī",
          "狗|gǒu"
         ]
        }
       ],
       "punct": [
        {
         "at": 3,
         "p": "。"
        }
       ],
       "py": [
        "wǒ",
        "jiā",
        "yǒu",
        "yì",
        "zhī",
        "gǒu"
       ]
      },
      {
       "id": "b008df2e6",
       "text": "她爱我们家的猫。",
       "en": "She loves our cat.",
       "pattern": "S V O",
       "chunks": [
        {
         "role": "S",
         "words": [
          "她|tā"
         ]
        },
        {
         "role": "V",
         "words": [
          "爱|ài"
         ]
        },
        {
         "role": "O",
         "words": [
          "我们|wǒmen",
          "家|jiā",
          "的|de",
          "猫|māo"
         ]
        }
       ],
       "punct": [
        {
         "at": 3,
         "p": "。"
        }
       ],
       "py": [
        "tā",
        "ài",
        "wǒmen",
        "jiā",
        "de",
        "māo"
       ]
      }
     ]
    }
   ]
  },
  {
   "id": "food",
   "title": "Eating",
   "zh": "吃饭",
   "topic": "Daily life: food and drink (饮食)",
   "notes": [
    "Rice (米饭) is the everyday staple in the south of China; noodles (面条儿) and steamed buns (包子) more so in the north.",
    "The 儿 at the end of 面条儿 is erhua, typical of Beijing speech; many speakers simply say 面条."
   ],
   "lessons": [
    {
     "id": "food-1",
     "title": "What would you like?",
     "words": [
      "吃|chī",
      "喝|hē",
      "想|xiǎng",
      "要|yào",
      "饭|fàn",
      "米饭|mǐfàn",
      "面条儿|miàntiáor",
      "茶|chá",
      "水|shuǐ",
      "牛奶|niúnǎi"
     ],
     "dialogue": [
      {
       "id": "def4b2c45",
       "who": "A",
       "en": "What would you like to eat?",
       "text": "你想吃什么？",
       "tokens": [
        {
         "id": "你|nǐ",
         "py": "nǐ"
        },
        {
         "id": "想|xiǎng",
         "py": "xiǎng"
        },
        {
         "id": "吃|chī",
         "py": "chī"
        },
        {
         "id": "什么|shénme",
         "py": "shénme"
        },
        {
         "p": "？"
        }
       ]
      },
      {
       "id": "d7fc6dbc9",
       "who": "B",
       "en": "I'd like rice. And you?",
       "text": "我想吃米饭。你呢？",
       "tokens": [
        {
         "id": "我|wǒ",
         "py": "wǒ"
        },
        {
         "id": "想|xiǎng",
         "py": "xiǎng"
        },
        {
         "id": "吃|chī",
         "py": "chī"
        },
        {
         "id": "米饭|mǐfàn",
         "py": "mǐfàn"
        },
        {
         "p": "。"
        },
        {
         "id": "你|nǐ",
         "py": "nǐ"
        },
        {
         "id": "呢|ne",
         "py": "ne"
        },
        {
         "p": "？"
        }
       ]
      },
      {
       "id": "d4c8cdec8",
       "who": "A",
       "en": "I'll have noodles.",
       "text": "我要面条儿。",
       "tokens": [
        {
         "id": "我|wǒ",
         "py": "wǒ"
        },
        {
         "id": "要|yào",
         "py": "yào"
        },
        {
         "id": "面条儿|miàntiáor",
         "py": "miàntiáor"
        },
        {
         "p": "。"
        }
       ]
      },
      {
       "id": "d0da75487",
       "who": "B",
       "en": "What would you like to drink? Tea?",
       "text": "你想喝什么？茶吗？",
       "tokens": [
        {
         "id": "你|nǐ",
         "py": "nǐ"
        },
        {
         "id": "想|xiǎng",
         "py": "xiǎng"
        },
        {
         "id": "喝|hē",
         "py": "hē"
        },
        {
         "id": "什么|shénme",
         "py": "shénme"
        },
        {
         "p": "？"
        },
        {
         "id": "茶|chá",
         "py": "chá"
        },
        {
         "id": "吗|ma",
         "py": "ma"
        },
        {
         "p": "？"
        }
       ]
      },
      {
       "id": "dbb5d4ad8",
       "who": "A",
       "en": "No, I don't drink tea. I'll have water.",
       "text": "不，我不喝茶。我要水。",
       "tokens": [
        {
         "id": "不|bù",
         "py": "bù"
        },
        {
         "p": "，"
        },
        {
         "id": "我|wǒ",
         "py": "wǒ"
        },
        {
         "id": "不|bù",
         "py": "bù"
        },
        {
         "id": "喝|hē",
         "py": "hē"
        },
        {
         "id": "茶|chá",
         "py": "chá"
        },
        {
         "p": "。"
        },
        {
         "id": "我|wǒ",
         "py": "wǒ"
        },
        {
         "id": "要|yào",
         "py": "yào"
        },
        {
         "id": "水|shuǐ",
         "py": "shuǐ"
        },
        {
         "p": "。"
        }
       ]
      },
      {
       "id": "d1b5ad0d5",
       "who": "B",
       "en": "I'll have milk. I'm really hungry!",
       "text": "我喝牛奶。我很想吃饭！",
       "tokens": [
        {
         "id": "我|wǒ",
         "py": "wǒ"
        },
        {
         "id": "喝|hē",
         "py": "hē"
        },
        {
         "id": "牛奶|niúnǎi",
         "py": "niúnǎi"
        },
        {
         "p": "。"
        },
        {
         "id": "我|wǒ",
         "py": "wǒ"
        },
        {
         "id": "很|hěn",
         "py": "hěn"
        },
        {
         "id": "想|xiǎng",
         "py": "xiǎng"
        },
        {
         "id": "吃|chī",
         "py": "chī"
        },
        {
         "id": "饭|fàn",
         "py": "fàn"
        },
        {
         "p": "！"
        }
       ]
      }
     ],
     "builds": [
      {
       "id": "b55410cae",
       "text": "我想吃米饭。",
       "en": "I'd like to eat rice.",
       "pattern": "S A V O",
       "chunks": [
        {
         "role": "S",
         "words": [
          "我|wǒ"
         ]
        },
        {
         "role": "A",
         "words": [
          "想|xiǎng"
         ]
        },
        {
         "role": "V",
         "words": [
          "吃|chī"
         ]
        },
        {
         "role": "O",
         "words": [
          "米饭|mǐfàn"
         ]
        }
       ],
       "punct": [
        {
         "at": 4,
         "p": "。"
        }
       ],
       "py": [
        "wǒ",
        "xiǎng",
        "chī",
        "mǐfàn"
       ]
      },
      {
       "id": "b70f2dcd8",
       "text": "你想喝什么？",
       "en": "What would you like to drink?",
       "pattern": "S A V O",
       "chunks": [
        {
         "role": "S",
         "words": [
          "你|nǐ"
         ]
        },
        {
         "role": "A",
         "words": [
          "想|xiǎng"
         ]
        },
        {
         "role": "V",
         "words": [
          "喝|hē"
         ]
        },
        {
         "role": "O",
         "words": [
          "什么|shénme"
         ]
        }
       ],
       "punct": [
        {
         "at": 4,
         "p": "？"
        }
       ],
       "py": [
        "nǐ",
        "xiǎng",
        "hē",
        "shénme"
       ]
      },
      {
       "id": "bde5ccdac",
       "text": "我不喝茶。",
       "en": "I don't drink tea.",
       "pattern": "S A V O",
       "chunks": [
        {
         "role": "S",
         "words": [
          "我|wǒ"
         ]
        },
        {
         "role": "A",
         "words": [
          "不|bù"
         ]
        },
        {
         "role": "V",
         "words": [
          "喝|hē"
         ]
        },
        {
         "role": "O",
         "words": [
          "茶|chá"
         ]
        }
       ],
       "punct": [
        {
         "at": 4,
         "p": "。"
        }
       ],
       "py": [
        "wǒ",
        "bù",
        "hē",
        "chá"
       ]
      },
      {
       "id": "b4c8cdec8",
       "text": "我要面条儿。",
       "en": "I'll have noodles.",
       "pattern": "S V O",
       "chunks": [
        {
         "role": "S",
         "words": [
          "我|wǒ"
         ]
        },
        {
         "role": "V",
         "words": [
          "要|yào"
         ]
        },
        {
         "role": "O",
         "words": [
          "面条儿|miàntiáor"
         ]
        }
       ],
       "punct": [
        {
         "at": 3,
         "p": "。"
        }
       ],
       "py": [
        "wǒ",
        "yào",
        "miàntiáor"
       ]
      }
     ]
    },
    {
     "id": "food-2",
     "title": "Meals",
     "words": [
      "早饭|zǎofàn",
      "午饭|wǔfàn",
      "晚饭|wǎnfàn",
      "包子|bāozi",
      "鸡蛋|jīdàn",
      "面包|miànbāo",
      "好吃|hǎochī",
      "菜|cài",
      "水果|shuǐguǒ",
      "苹果|píngguǒ"
     ],
     "dialogue": [
      {
       "id": "d3724ad3b",
       "who": "A",
       "en": "What do you have for breakfast?",
       "text": "你早饭吃什么？",
       "tokens": [
        {
         "id": "你|nǐ",
         "py": "nǐ"
        },
        {
         "id": "早饭|zǎofàn",
         "py": "zǎofàn"
        },
        {
         "id": "吃|chī",
         "py": "chī"
        },
        {
         "id": "什么|shénme",
         "py": "shénme"
        },
        {
         "p": "？"
        }
       ]
      },
      {
       "id": "d01673c82",
       "who": "B",
       "en": "I have eggs and bread, and drink milk.",
       "text": "我吃鸡蛋和面包，喝牛奶。",
       "tokens": [
        {
         "id": "我|wǒ",
         "py": "wǒ"
        },
        {
         "id": "吃|chī",
         "py": "chī"
        },
        {
         "id": "鸡蛋|jīdàn",
         "py": "jīdàn"
        },
        {
         "id": "和|hé",
         "py": "hé"
        },
        {
         "id": "面包|miànbāo",
         "py": "miànbāo"
        },
        {
         "p": "，"
        },
        {
         "id": "喝|hē",
         "py": "hē"
        },
        {
         "id": "牛奶|niúnǎi",
         "py": "niúnǎi"
        },
        {
         "p": "。"
        }
       ]
      },
      {
       "id": "d164f7cd5",
       "who": "A",
       "en": "I have steamed buns. They're delicious!",
       "text": "我早饭吃包子。包子很好吃！",
       "tokens": [
        {
         "id": "我|wǒ",
         "py": "wǒ"
        },
        {
         "id": "早饭|zǎofàn",
         "py": "zǎofàn"
        },
        {
         "id": "吃|chī",
         "py": "chī"
        },
        {
         "id": "包子|bāozi",
         "py": "bāozi"
        },
        {
         "p": "。"
        },
        {
         "id": "包子|bāozi",
         "py": "bāozi"
        },
        {
         "id": "很|hěn",
         "py": "hěn"
        },
        {
         "id": "好吃|hǎochī",
         "py": "hǎochī"
        },
        {
         "p": "！"
        }
       ]
      },
      {
       "id": "d443b576b",
       "who": "B",
       "en": "And for lunch?",
       "text": "你午饭吃什么？",
       "tokens": [
        {
         "id": "你|nǐ",
         "py": "nǐ"
        },
        {
         "id": "午饭|wǔfàn",
         "py": "wǔfàn"
        },
        {
         "id": "吃|chī",
         "py": "chī"
        },
        {
         "id": "什么|shénme",
         "py": "shénme"
        },
        {
         "p": "？"
        }
       ]
      },
      {
       "id": "d0c87e7d7",
       "who": "A",
       "en": "Rice and vegetables. For dinner I have noodles.",
       "text": "米饭和菜。晚饭我吃面条儿。",
       "tokens": [
        {
         "id": "米饭|mǐfàn",
         "py": "mǐfàn"
        },
        {
         "id": "和|hé",
         "py": "hé"
        },
        {
         "id": "菜|cài",
         "py": "cài"
        },
        {
         "p": "。"
        },
        {
         "id": "晚饭|wǎnfàn",
         "py": "wǎnfàn"
        },
        {
         "id": "我|wǒ",
         "py": "wǒ"
        },
        {
         "id": "吃|chī",
         "py": "chī"
        },
        {
         "id": "面条儿|miàntiáor",
         "py": "miàntiáor"
        },
        {
         "p": "。"
        }
       ]
      },
      {
       "id": "d75d59642",
       "who": "B",
       "en": "Do you eat fruit?",
       "text": "你吃水果吗？",
       "tokens": [
        {
         "id": "你|nǐ",
         "py": "nǐ"
        },
        {
         "id": "吃|chī",
         "py": "chī"
        },
        {
         "id": "水果|shuǐguǒ",
         "py": "shuǐguǒ"
        },
        {
         "id": "吗|ma",
         "py": "ma"
        },
        {
         "p": "？"
        }
       ]
      },
      {
       "id": "d7f8e5b1e",
       "who": "A",
       "en": "Yes, I love apples.",
       "text": "吃，我很爱吃苹果。",
       "tokens": [
        {
         "id": "吃|chī",
         "py": "chī"
        },
        {
         "p": "，"
        },
        {
         "id": "我|wǒ",
         "py": "wǒ"
        },
        {
         "id": "很|hěn",
         "py": "hěn"
        },
        {
         "id": "爱|ài",
         "py": "ài"
        },
        {
         "id": "吃|chī",
         "py": "chī"
        },
        {
         "id": "苹果|píngguǒ",
         "py": "píngguǒ"
        },
        {
         "p": "。"
        }
       ]
      }
     ],
     "builds": [
      {
       "id": "b3f19c0c6",
       "text": "我早饭吃包子。",
       "en": "I have steamed buns for breakfast.",
       "pattern": "S T V O",
       "chunks": [
        {
         "role": "S",
         "words": [
          "我|wǒ"
         ]
        },
        {
         "role": "T",
         "words": [
          "早饭|zǎofàn"
         ]
        },
        {
         "role": "V",
         "words": [
          "吃|chī"
         ]
        },
        {
         "role": "O",
         "words": [
          "包子|bāozi"
         ]
        }
       ],
       "punct": [
        {
         "at": 4,
         "p": "。"
        }
       ],
       "py": [
        "wǒ",
        "zǎofàn",
        "chī",
        "bāozi"
       ]
      },
      {
       "id": "b600fc2c8",
       "text": "包子很好吃。",
       "en": "Steamed buns are delicious.",
       "pattern": "S A V",
       "chunks": [
        {
         "role": "S",
         "words": [
          "包子|bāozi"
         ]
        },
        {
         "role": "A",
         "words": [
          "很|hěn"
         ]
        },
        {
         "role": "V",
         "words": [
          "好吃|hǎochī"
         ]
        }
       ],
       "punct": [
        {
         "at": 3,
         "p": "。"
        }
       ],
       "py": [
        "bāozi",
        "hěn",
        "hǎochī"
       ]
      },
      {
       "id": "b75d59642",
       "text": "你吃水果吗？",
       "en": "Do you eat fruit?",
       "pattern": "S V O X",
       "chunks": [
        {
         "role": "S",
         "words": [
          "你|nǐ"
         ]
        },
        {
         "role": "V",
         "words": [
          "吃|chī"
         ]
        },
        {
         "role": "O",
         "words": [
          "水果|shuǐguǒ"
         ]
        },
        {
         "role": "X",
         "words": [
          "吗|ma"
         ]
        }
       ],
       "punct": [
        {
         "at": 4,
         "p": "？"
        }
       ],
       "py": [
        "nǐ",
        "chī",
        "shuǐguǒ",
        "ma"
       ]
      },
      {
       "id": "b41c5eb62",
       "text": "我晚饭吃面条儿。",
       "en": "I have noodles for dinner.",
       "pattern": "S T V O",
       "chunks": [
        {
         "role": "S",
         "words": [
          "我|wǒ"
         ]
        },
        {
         "role": "T",
         "words": [
          "晚饭|wǎnfàn"
         ]
        },
        {
         "role": "V",
         "words": [
          "吃|chī"
         ]
        },
        {
         "role": "O",
         "words": [
          "面条儿|miàntiáor"
         ]
        }
       ],
       "punct": [
        {
         "at": 4,
         "p": "。"
        }
       ],
       "py": [
        "wǒ",
        "wǎnfàn",
        "chī",
        "miàntiáor"
       ]
      }
     ]
    }
   ]
  },
  {
   "id": "shopping",
   "title": "Shopping",
   "zh": "买东西",
   "topic": "Daily life: shopping (购物)",
   "notes": [
    "Prices are in 元 yuán on labels, but in speech people say 块 kuài: 五块 is five yuan.",
    "太…了 means \"too…\": 太贵了, too expensive. The 了 marks it as a reaction to how things are."
   ],
   "lessons": [
    {
     "id": "shopping-1",
     "title": "How much?",
     "words": [
      "买|mǎi",
      "卖|mài",
      "钱|qián",
      "多少|duōshao",
      "块|kuài",
      "元|yuán",
      "贵|guì",
      "便宜|piányi",
      "太|tài",
      "了|le",
      "还|hái"
     ],
     "dialogue": [
      {
       "id": "d7ae89218",
       "who": "A",
       "en": "Hello! How much are the apples?",
       "text": "你好！苹果多少钱？",
       "tokens": [
        {
         "id": "你好|nǐhǎo",
         "py": "nǐhǎo"
        },
        {
         "p": "！"
        },
        {
         "id": "苹果|píngguǒ",
         "py": "píngguǒ"
        },
        {
         "id": "多少|duōshao",
         "py": "duōshao"
        },
        {
         "id": "钱|qián",
         "py": "qián"
        },
        {
         "p": "？"
        }
       ]
      },
      {
       "id": "dd08675e1",
       "who": "B",
       "en": "The apples are five yuan.",
       "text": "苹果五块。",
       "tokens": [
        {
         "id": "苹果|píngguǒ",
         "py": "píngguǒ"
        },
        {
         "id": "五|wǔ",
         "py": "wǔ"
        },
        {
         "id": "块|kuài",
         "py": "kuài"
        },
        {
         "p": "。"
        }
       ]
      },
      {
       "id": "d72e649f5",
       "who": "A",
       "en": "That's too expensive!",
       "text": "太贵了！",
       "tokens": [
        {
         "id": "太|tài",
         "py": "tài"
        },
        {
         "id": "贵|guì",
         "py": "guì"
        },
        {
         "id": "了|le",
         "py": "le"
        },
        {
         "p": "！"
        }
       ]
      },
      {
       "id": "d5ad2daac",
       "who": "B",
       "en": "It's not expensive, it's cheap! How many would you like?",
       "text": "不贵，很便宜！你买几个？",
       "tokens": [
        {
         "id": "不|bù",
         "py": "bú"
        },
        {
         "id": "贵|guì",
         "py": "guì"
        },
        {
         "p": "，"
        },
        {
         "id": "很|hěn",
         "py": "hěn"
        },
        {
         "id": "便宜|piányi",
         "py": "piányi"
        },
        {
         "p": "！"
        },
        {
         "id": "你|nǐ",
         "py": "nǐ"
        },
        {
         "id": "买|mǎi",
         "py": "mǎi"
        },
        {
         "id": "几|jǐ",
         "py": "jǐ"
        },
        {
         "id": "个|gè",
         "py": "gè"
        },
        {
         "p": "？"
        }
       ]
      },
      {
       "id": "d90bf0370",
       "who": "A",
       "en": "I'll take two. What else do you sell?",
       "text": "我买两个。你还卖什么？",
       "tokens": [
        {
         "id": "我|wǒ",
         "py": "wǒ"
        },
        {
         "id": "买|mǎi",
         "py": "mǎi"
        },
        {
         "id": "两|liǎng",
         "py": "liǎng"
        },
        {
         "id": "个|gè",
         "py": "gè"
        },
        {
         "p": "。"
        },
        {
         "id": "你|nǐ",
         "py": "nǐ"
        },
        {
         "id": "还|hái",
         "py": "hái"
        },
        {
         "id": "卖|mài",
         "py": "mài"
        },
        {
         "id": "什么|shénme",
         "py": "shénme"
        },
        {
         "p": "？"
        }
       ]
      },
      {
       "id": "d7f14abad",
       "who": "B",
       "en": "I also sell milk and bread.",
       "text": "我还卖牛奶和面包。",
       "tokens": [
        {
         "id": "我|wǒ",
         "py": "wǒ"
        },
        {
         "id": "还|hái",
         "py": "hái"
        },
        {
         "id": "卖|mài",
         "py": "mài"
        },
        {
         "id": "牛奶|niúnǎi",
         "py": "niúnǎi"
        },
        {
         "id": "和|hé",
         "py": "hé"
        },
        {
         "id": "面包|miànbāo",
         "py": "miànbāo"
        },
        {
         "p": "。"
        }
       ]
      },
      {
       "id": "d5506b104",
       "who": "A",
       "en": "How much is the milk?",
       "text": "牛奶多少钱？",
       "tokens": [
        {
         "id": "牛奶|niúnǎi",
         "py": "niúnǎi"
        },
        {
         "id": "多少|duōshao",
         "py": "duōshao"
        },
        {
         "id": "钱|qián",
         "py": "qián"
        },
        {
         "p": "？"
        }
       ]
      },
      {
       "id": "d972de700",
       "who": "B",
       "en": "Three yuan.",
       "text": "三元。",
       "tokens": [
        {
         "id": "三|sān",
         "py": "sān"
        },
        {
         "id": "元|yuán",
         "py": "yuán"
        },
        {
         "p": "。"
        }
       ]
      }
     ],
     "builds": [
      {
       "id": "b5e866e5f",
       "text": "苹果多少钱？",
       "en": "How much are the apples?",
       "pattern": "S V",
       "chunks": [
        {
         "role": "S",
         "words": [
          "苹果|píngguǒ"
         ]
        },
        {
         "role": "V",
         "words": [
          "多少|duōshao",
          "钱|qián"
         ]
        }
       ],
       "punct": [
        {
         "at": 2,
         "p": "？"
        }
       ],
       "py": [
        "píngguǒ",
        "duōshao",
        "qián"
       ]
      },
      {
       "id": "b172a9253",
       "text": "这太贵了。",
       "en": "That's too expensive.",
       "pattern": "S A V X",
       "chunks": [
        {
         "role": "S",
         "words": [
          "这|zhè"
         ]
        },
        {
         "role": "A",
         "words": [
          "太|tài"
         ]
        },
        {
         "role": "V",
         "words": [
          "贵|guì"
         ]
        },
        {
         "role": "X",
         "words": [
          "了|le"
         ]
        }
       ],
       "punct": [
        {
         "at": 4,
         "p": "。"
        }
       ],
       "py": [
        "zhè",
        "tài",
        "guì",
        "le"
       ]
      },
      {
       "id": "b8cc96292",
       "text": "我买两个。",
       "en": "I'll take two.",
       "pattern": "S V O",
       "chunks": [
        {
         "role": "S",
         "words": [
          "我|wǒ"
         ]
        },
        {
         "role": "V",
         "words": [
          "买|mǎi"
         ]
        },
        {
         "role": "O",
         "words": [
          "两|liǎng",
          "个|gè"
         ]
        }
       ],
       "punct": [
        {
         "at": 3,
         "p": "。"
        }
       ],
       "py": [
        "wǒ",
        "mǎi",
        "liǎng",
        "gè"
       ]
      },
      {
       "id": "bd3788ebc",
       "text": "我还卖牛奶。",
       "en": "I also sell milk.",
       "pattern": "S A V O",
       "chunks": [
        {
         "role": "S",
         "words": [
          "我|wǒ"
         ]
        },
        {
         "role": "A",
         "words": [
          "还|hái"
         ]
        },
        {
         "role": "V",
         "words": [
          "卖|mài"
         ]
        },
        {
         "role": "O",
         "words": [
          "牛奶|niúnǎi"
         ]
        }
       ],
       "punct": [
        {
         "at": 4,
         "p": "。"
        }
       ],
       "py": [
        "wǒ",
        "hái",
        "mài",
        "niúnǎi"
       ]
      }
     ]
    },
    {
     "id": "shopping-2",
     "title": "Clothes and shops",
     "words": [
      "衣服|yīfu",
      "件|jiàn",
      "穿|chuān",
      "喜欢|xǐhuan",
      "好看|hǎokàn",
      "漂亮|piàoliang",
      "这个|zhège",
      "那个|nàge",
      "商店|shāngdiàn",
      "东西|dōngxi",
      "超市|chāoshì"
     ],
     "dialogue": [
      {
       "id": "da12d9ea6",
       "who": "A",
       "en": "Do you like this top?",
       "text": "你喜欢这件衣服吗？",
       "tokens": [
        {
         "id": "你|nǐ",
         "py": "nǐ"
        },
        {
         "id": "喜欢|xǐhuan",
         "py": "xǐhuan"
        },
        {
         "id": "这|zhè",
         "py": "zhè"
        },
        {
         "id": "件|jiàn",
         "py": "jiàn"
        },
        {
         "id": "衣服|yīfu",
         "py": "yīfu"
        },
        {
         "id": "吗|ma",
         "py": "ma"
        },
        {
         "p": "？"
        }
       ]
      },
      {
       "id": "d4c45d01b",
       "who": "B",
       "en": "I love it! It's lovely.",
       "text": "很喜欢！很好看。",
       "tokens": [
        {
         "id": "很|hěn",
         "py": "hěn"
        },
        {
         "id": "喜欢|xǐhuan",
         "py": "xǐhuan"
        },
        {
         "p": "！"
        },
        {
         "id": "很|hěn",
         "py": "hěn"
        },
        {
         "id": "好看|hǎokàn",
         "py": "hǎokàn"
        },
        {
         "p": "。"
        }
       ]
      },
      {
       "id": "dc19ea5f9",
       "who": "A",
       "en": "You look pretty in this one.",
       "text": "你穿这件很漂亮。",
       "tokens": [
        {
         "id": "你|nǐ",
         "py": "nǐ"
        },
        {
         "id": "穿|chuān",
         "py": "chuān"
        },
        {
         "id": "这|zhè",
         "py": "zhè"
        },
        {
         "id": "件|jiàn",
         "py": "jiàn"
        },
        {
         "id": "很|hěn",
         "py": "hěn"
        },
        {
         "id": "漂亮|piàoliang",
         "py": "piàoliang"
        },
        {
         "p": "。"
        }
       ]
      },
      {
       "id": "d9827fb17",
       "who": "B",
       "en": "What about that one? That one's nice too.",
       "text": "那个呢？那个也很好看。",
       "tokens": [
        {
         "id": "那个|nàge",
         "py": "nàge"
        },
        {
         "id": "呢|ne",
         "py": "ne"
        },
        {
         "p": "？"
        },
        {
         "id": "那个|nàge",
         "py": "nàge"
        },
        {
         "id": "也|yě",
         "py": "yě"
        },
        {
         "id": "很|hěn",
         "py": "hěn"
        },
        {
         "id": "好看|hǎokàn",
         "py": "hǎokàn"
        },
        {
         "p": "。"
        }
       ]
      },
      {
       "id": "dc11da5b2",
       "who": "A",
       "en": "Things in this shop are expensive.",
       "text": "这个商店的东西很贵。",
       "tokens": [
        {
         "id": "这个|zhège",
         "py": "zhège"
        },
        {
         "id": "商店|shāngdiàn",
         "py": "shāngdiàn"
        },
        {
         "id": "的|de",
         "py": "de"
        },
        {
         "id": "东西|dōngxi",
         "py": "dōngxi"
        },
        {
         "id": "很|hěn",
         "py": "hěn"
        },
        {
         "id": "贵|guì",
         "py": "guì"
        },
        {
         "p": "。"
        }
       ]
      },
      {
       "id": "dbc8dab30",
       "who": "B",
       "en": "Things at the supermarket are cheap.",
       "text": "超市的东西很便宜。",
       "tokens": [
        {
         "id": "超市|chāoshì",
         "py": "chāoshì"
        },
        {
         "id": "的|de",
         "py": "de"
        },
        {
         "id": "东西|dōngxi",
         "py": "dōngxi"
        },
        {
         "id": "很|hěn",
         "py": "hěn"
        },
        {
         "id": "便宜|piányi",
         "py": "piányi"
        },
        {
         "p": "。"
        }
       ]
      },
      {
       "id": "d99595049",
       "who": "A",
       "en": "I like the supermarket too!",
       "text": "我也喜欢超市！",
       "tokens": [
        {
         "id": "我|wǒ",
         "py": "wǒ"
        },
        {
         "id": "也|yě",
         "py": "yě"
        },
        {
         "id": "喜欢|xǐhuan",
         "py": "xǐhuan"
        },
        {
         "id": "超市|chāoshì",
         "py": "chāoshì"
        },
        {
         "p": "！"
        }
       ]
      }
     ],
     "builds": [
      {
       "id": "b222b39a7",
       "text": "我很喜欢这件衣服。",
       "en": "I really like this top.",
       "pattern": "S A V O",
       "chunks": [
        {
         "role": "S",
         "words": [
          "我|wǒ"
         ]
        },
        {
         "role": "A",
         "words": [
          "很|hěn"
         ]
        },
        {
         "role": "V",
         "words": [
          "喜欢|xǐhuan"
         ]
        },
        {
         "role": "O",
         "words": [
          "这|zhè",
          "件|jiàn",
          "衣服|yīfu"
         ]
        }
       ],
       "punct": [
        {
         "at": 4,
         "p": "。"
        }
       ],
       "py": [
        "wǒ",
        "hěn",
        "xǐhuan",
        "zhè",
        "jiàn",
        "yīfu"
       ]
      },
      {
       "id": "bb8b7efb0",
       "text": "这件衣服很好看。",
       "en": "This top looks nice.",
       "pattern": "S A V",
       "chunks": [
        {
         "role": "S",
         "words": [
          "这|zhè",
          "件|jiàn",
          "衣服|yīfu"
         ]
        },
        {
         "role": "A",
         "words": [
          "很|hěn"
         ]
        },
        {
         "role": "V",
         "words": [
          "好看|hǎokàn"
         ]
        }
       ],
       "punct": [
        {
         "at": 3,
         "p": "。"
        }
       ],
       "py": [
        "zhè",
        "jiàn",
        "yīfu",
        "hěn",
        "hǎokàn"
       ]
      },
      {
       "id": "bbc8dab30",
       "text": "超市的东西很便宜。",
       "en": "Things at the supermarket are cheap.",
       "pattern": "S A V",
       "chunks": [
        {
         "role": "S",
         "words": [
          "超市|chāoshì",
          "的|de",
          "东西|dōngxi"
         ]
        },
        {
         "role": "A",
         "words": [
          "很|hěn"
         ]
        },
        {
         "role": "V",
         "words": [
          "便宜|piányi"
         ]
        }
       ],
       "punct": [
        {
         "at": 3,
         "p": "。"
        }
       ],
       "py": [
        "chāoshì",
        "de",
        "dōngxi",
        "hěn",
        "piányi"
       ]
      },
      {
       "id": "b16f553ce",
       "text": "你喜欢那个吗？",
       "en": "Do you like that one?",
       "pattern": "S V O X",
       "chunks": [
        {
         "role": "S",
         "words": [
          "你|nǐ"
         ]
        },
        {
         "role": "V",
         "words": [
          "喜欢|xǐhuan"
         ]
        },
        {
         "role": "O",
         "words": [
          "那个|nàge"
         ]
        },
        {
         "role": "X",
         "words": [
          "吗|ma"
         ]
        }
       ],
       "punct": [
        {
         "at": 4,
         "p": "？"
        }
       ],
       "py": [
        "nǐ",
        "xǐhuan",
        "nàge",
        "ma"
       ]
      }
     ]
    }
   ]
  },
  {
   "id": "travel",
   "title": "Getting around",
   "zh": "去哪儿",
   "topic": "Daily life: transport (交通出行)",
   "notes": [
    "To ask a stranger anything, start with 请问, \"may I ask\": it is the polite way in.",
    "坐 means \"to sit\", and it is also how you take a vehicle: 坐出租车, 坐火车, 坐飞机."
   ],
   "lessons": [
    {
     "id": "travel-1",
     "title": "Where are you going?",
     "words": [
      "去|qù",
      "回|huí",
      "在|zài",
      "哪儿|nǎr",
      "哪里|nǎlǐ",
      "这儿|zhèr",
      "那儿|nàr",
      "来|lái",
      "到|dào"
     ],
     "dialogue": [
      {
       "id": "d10bdeb61",
       "who": "A",
       "en": "Where are you going?",
       "text": "你去哪儿？",
       "tokens": [
        {
         "id": "你|nǐ",
         "py": "nǐ"
        },
        {
         "id": "去|qù",
         "py": "qù"
        },
        {
         "id": "哪儿|nǎr",
         "py": "nǎr"
        },
        {
         "p": "？"
        }
       ]
      },
      {
       "id": "db04e8d7e",
       "who": "B",
       "en": "To the supermarket. And you?",
       "text": "我去超市。你呢？",
       "tokens": [
        {
         "id": "我|wǒ",
         "py": "wǒ"
        },
        {
         "id": "去|qù",
         "py": "qù"
        },
        {
         "id": "超市|chāoshì",
         "py": "chāoshì"
        },
        {
         "p": "。"
        },
        {
         "id": "你|nǐ",
         "py": "nǐ"
        },
        {
         "id": "呢|ne",
         "py": "ne"
        },
        {
         "p": "？"
        }
       ]
      },
      {
       "id": "d010552b3",
       "who": "A",
       "en": "I'm going home.",
       "text": "我回家。",
       "tokens": [
        {
         "id": "我|wǒ",
         "py": "wǒ"
        },
        {
         "id": "回|huí",
         "py": "huí"
        },
        {
         "id": "家|jiā",
         "py": "jiā"
        },
        {
         "p": "。"
        }
       ]
      },
      {
       "id": "d59fecbbe",
       "who": "B",
       "en": "Where do you live?",
       "text": "你家在哪里？",
       "tokens": [
        {
         "id": "你|nǐ",
         "py": "nǐ"
        },
        {
         "id": "家|jiā",
         "py": "jiā"
        },
        {
         "id": "在|zài",
         "py": "zài"
        },
        {
         "id": "哪里|nǎlǐ",
         "py": "nǎlǐ"
        },
        {
         "p": "？"
        }
       ]
      },
      {
       "id": "d438921ab",
       "who": "A",
       "en": "My home is over there.",
       "text": "我家在那儿。",
       "tokens": [
        {
         "id": "我|wǒ",
         "py": "wǒ"
        },
        {
         "id": "家|jiā",
         "py": "jiā"
        },
        {
         "id": "在|zài",
         "py": "zài"
        },
        {
         "id": "那儿|nàr",
         "py": "nàr"
        },
        {
         "p": "。"
        }
       ]
      },
      {
       "id": "da565f40e",
       "who": "B",
       "en": "Is Xiaoming here?",
       "text": "小明在这儿吗？",
       "tokens": [
        {
         "name": "小明",
         "py": "Xiǎomíng"
        },
        {
         "id": "在|zài",
         "py": "zài"
        },
        {
         "id": "这儿|zhèr",
         "py": "zhèr"
        },
        {
         "id": "吗|ma",
         "py": "ma"
        },
        {
         "p": "？"
        }
       ]
      },
      {
       "id": "df1df0e6b",
       "who": "A",
       "en": "He isn't. He's coming tomorrow.",
       "text": "他不在。他明天来。",
       "tokens": [
        {
         "id": "他|tā",
         "py": "tā"
        },
        {
         "id": "不|bù",
         "py": "bú"
        },
        {
         "id": "在|zài",
         "py": "zài"
        },
        {
         "p": "。"
        },
        {
         "id": "他|tā",
         "py": "tā"
        },
        {
         "id": "明天|míngtiān",
         "py": "míngtiān"
        },
        {
         "id": "来|lái",
         "py": "lái"
        },
        {
         "p": "。"
        }
       ]
      },
      {
       "id": "dbc732662",
       "who": "B",
       "en": "He arrives tomorrow?",
       "text": "他明天到？",
       "tokens": [
        {
         "id": "他|tā",
         "py": "tā"
        },
        {
         "id": "明天|míngtiān",
         "py": "míngtiān"
        },
        {
         "id": "到|dào",
         "py": "dào"
        },
        {
         "p": "？"
        }
       ]
      },
      {
       "id": "d628ab0c1",
       "who": "A",
       "en": "Yes, tomorrow.",
       "text": "是，明天到。",
       "tokens": [
        {
         "id": "是|shì",
         "py": "shì"
        },
        {
         "p": "，"
        },
        {
         "id": "明天|míngtiān",
         "py": "míngtiān"
        },
        {
         "id": "到|dào",
         "py": "dào"
        },
        {
         "p": "。"
        }
       ]
      }
     ],
     "builds": [
      {
       "id": "b10bdeb61",
       "text": "你去哪儿？",
       "en": "Where are you going?",
       "pattern": "S V O",
       "chunks": [
        {
         "role": "S",
         "words": [
          "你|nǐ"
         ]
        },
        {
         "role": "V",
         "words": [
          "去|qù"
         ]
        },
        {
         "role": "O",
         "words": [
          "哪儿|nǎr"
         ]
        }
       ],
       "punct": [
        {
         "at": 3,
         "p": "？"
        }
       ],
       "py": [
        "nǐ",
        "qù",
        "nǎr"
       ]
      },
      {
       "id": "b010552b3",
       "text": "我回家。",
       "en": "I'm going home.",
       "pattern": "S V O",
       "chunks": [
        {
         "role": "S",
         "words": [
          "我|wǒ"
         ]
        },
        {
         "role": "V",
         "words": [
          "回|huí"
         ]
        },
        {
         "role": "O",
         "words": [
          "家|jiā"
         ]
        }
       ],
       "punct": [
        {
         "at": 3,
         "p": "。"
        }
       ],
       "py": [
        "wǒ",
        "huí",
        "jiā"
       ]
      },
      {
       "id": "b438921ab",
       "text": "我家在那儿。",
       "en": "My home is over there.",
       "pattern": "S V O",
       "chunks": [
        {
         "role": "S",
         "words": [
          "我|wǒ",
          "家|jiā"
         ]
        },
        {
         "role": "V",
         "words": [
          "在|zài"
         ]
        },
        {
         "role": "O",
         "words": [
          "那儿|nàr"
         ]
        }
       ],
       "punct": [
        {
         "at": 3,
         "p": "。"
        }
       ],
       "py": [
        "wǒ",
        "jiā",
        "zài",
        "nàr"
       ]
      },
      {
       "id": "be6de6dc0",
       "text": "他明天来。",
       "en": "He's coming tomorrow.",
       "pattern": "S T V",
       "chunks": [
        {
         "role": "S",
         "words": [
          "他|tā"
         ]
        },
        {
         "role": "T",
         "words": [
          "明天|míngtiān"
         ]
        },
        {
         "role": "V",
         "words": [
          "来|lái"
         ]
        }
       ],
       "punct": [
        {
         "at": 3,
         "p": "。"
        }
       ],
       "py": [
        "tā",
        "míngtiān",
        "lái"
       ]
      }
     ]
    },
    {
     "id": "travel-2",
     "title": "Taxi, train and plane",
     "words": [
      "怎么|zěnme",
      "坐|zuò",
      "火车|huǒchē",
      "飞机|fēijī",
      "开车|kāichē",
      "出租车|chūzūchē",
      "请问|qǐngwèn",
      "车|chē",
      "请|qǐng",
      "可以|kěyǐ"
     ],
     "dialogue": [
      {
       "id": "d2ab0e31a",
       "who": "A",
       "en": "How are you getting to Shanghai tomorrow?",
       "text": "明天你怎么去上海？",
       "tokens": [
        {
         "id": "明天|míngtiān",
         "py": "míngtiān"
        },
        {
         "id": "你|nǐ",
         "py": "nǐ"
        },
        {
         "id": "怎么|zěnme",
         "py": "zěnme"
        },
        {
         "id": "去|qù",
         "py": "qù"
        },
        {
         "name": "上海",
         "py": "Shànghǎi"
        },
        {
         "p": "？"
        }
       ]
      },
      {
       "id": "d0160efde",
       "who": "B",
       "en": "By train. And you?",
       "text": "我坐火车去。你呢？",
       "tokens": [
        {
         "id": "我|wǒ",
         "py": "wǒ"
        },
        {
         "id": "坐|zuò",
         "py": "zuò"
        },
        {
         "id": "火车|huǒchē",
         "py": "huǒchē"
        },
        {
         "id": "去|qù",
         "py": "qù"
        },
        {
         "p": "。"
        },
        {
         "id": "你|nǐ",
         "py": "nǐ"
        },
        {
         "id": "呢|ne",
         "py": "ne"
        },
        {
         "p": "？"
        }
       ]
      },
      {
       "id": "dd8525017",
       "who": "A",
       "en": "I'm flying.",
       "text": "我坐飞机。",
       "tokens": [
        {
         "id": "我|wǒ",
         "py": "wǒ"
        },
        {
         "id": "坐|zuò",
         "py": "zuò"
        },
        {
         "id": "飞机|fēijī",
         "py": "fēijī"
        },
        {
         "p": "。"
        }
       ]
      },
      {
       "id": "d448a2186",
       "who": "B",
       "en": "Does your dad drive?",
       "text": "你爸爸开车吗？",
       "tokens": [
        {
         "id": "你|nǐ",
         "py": "nǐ"
        },
        {
         "id": "爸爸|bàba",
         "py": "bàba"
        },
        {
         "id": "开车|kāichē",
         "py": "kāichē"
        },
        {
         "id": "吗|ma",
         "py": "ma"
        },
        {
         "p": "？"
        }
       ]
      },
      {
       "id": "d872a4d6c",
       "who": "A",
       "en": "He doesn't drive. We take taxis.",
       "text": "他不开车。我们坐出租车。",
       "tokens": [
        {
         "id": "他|tā",
         "py": "tā"
        },
        {
         "id": "不|bù",
         "py": "bù"
        },
        {
         "id": "开车|kāichē",
         "py": "kāichē"
        },
        {
         "p": "。"
        },
        {
         "id": "我们|wǒmen",
         "py": "wǒmen"
        },
        {
         "id": "坐|zuò",
         "py": "zuò"
        },
        {
         "id": "出租车|chūzūchē",
         "py": "chūzūchē"
        },
        {
         "p": "。"
        }
       ]
      },
      {
       "id": "d31b41603",
       "who": "A",
       "en": "Excuse me, is this a taxi?",
       "text": "请问，这是出租车吗？",
       "tokens": [
        {
         "id": "请问|qǐngwèn",
         "py": "qǐngwèn"
        },
        {
         "p": "，"
        },
        {
         "id": "这|zhè",
         "py": "zhè"
        },
        {
         "id": "是|shì",
         "py": "shì"
        },
        {
         "id": "出租车|chūzūchē",
         "py": "chūzūchē"
        },
        {
         "id": "吗|ma",
         "py": "ma"
        },
        {
         "p": "？"
        }
       ]
      },
      {
       "id": "d7af18ef8",
       "who": "C",
       "en": "Yes, this is my car. Please, have a seat!",
       "text": "是，这是我的车。请坐！",
       "tokens": [
        {
         "id": "是|shì",
         "py": "shì"
        },
        {
         "p": "，"
        },
        {
         "id": "这|zhè",
         "py": "zhè"
        },
        {
         "id": "是|shì",
         "py": "shì"
        },
        {
         "id": "我|wǒ",
         "py": "wǒ"
        },
        {
         "id": "的|de",
         "py": "de"
        },
        {
         "id": "车|chē",
         "py": "chē"
        },
        {
         "p": "。"
        },
        {
         "id": "请|qǐng",
         "py": "qǐng"
        },
        {
         "id": "坐|zuò",
         "py": "zuò"
        },
        {
         "p": "！"
        }
       ]
      },
      {
       "id": "d07dd2bce",
       "who": "A",
       "en": "We're going to the supermarket, is that all right?",
       "text": "我们去超市，可以吗？",
       "tokens": [
        {
         "id": "我们|wǒmen",
         "py": "wǒmen"
        },
        {
         "id": "去|qù",
         "py": "qù"
        },
        {
         "id": "超市|chāoshì",
         "py": "chāoshì"
        },
        {
         "p": "，"
        },
        {
         "id": "可以|kěyǐ",
         "py": "kěyǐ"
        },
        {
         "id": "吗|ma",
         "py": "ma"
        },
        {
         "p": "？"
        }
       ]
      },
      {
       "id": "d97291bd3",
       "who": "C",
       "en": "Of course!",
       "text": "可以！",
       "tokens": [
        {
         "id": "可以|kěyǐ",
         "py": "kěyǐ"
        },
        {
         "p": "！"
        }
       ]
      }
     ],
     "builds": [
      {
       "id": "bd8525017",
       "text": "我坐飞机。",
       "en": "I'm flying.",
       "pattern": "S V O",
       "chunks": [
        {
         "role": "S",
         "words": [
          "我|wǒ"
         ]
        },
        {
         "role": "V",
         "words": [
          "坐|zuò"
         ]
        },
        {
         "role": "O",
         "words": [
          "飞机|fēijī"
         ]
        }
       ],
       "punct": [
        {
         "at": 3,
         "p": "。"
        }
       ],
       "py": [
        "wǒ",
        "zuò",
        "fēijī"
       ]
      },
      {
       "id": "b2b73dc7e",
       "text": "你怎么去？",
       "en": "How are you getting there?",
       "pattern": "S A V",
       "chunks": [
        {
         "role": "S",
         "words": [
          "你|nǐ"
         ]
        },
        {
         "role": "A",
         "words": [
          "怎么|zěnme"
         ]
        },
        {
         "role": "V",
         "words": [
          "去|qù"
         ]
        }
       ],
       "punct": [
        {
         "at": 3,
         "p": "？"
        }
       ],
       "py": [
        "nǐ",
        "zěnme",
        "qù"
       ]
      },
      {
       "id": "b7afc7378",
       "text": "他不开车。",
       "en": "He doesn't drive.",
       "pattern": "S A V",
       "chunks": [
        {
         "role": "S",
         "words": [
          "他|tā"
         ]
        },
        {
         "role": "A",
         "words": [
          "不|bù"
         ]
        },
        {
         "role": "V",
         "words": [
          "开车|kāichē"
         ]
        }
       ],
       "punct": [
        {
         "at": 3,
         "p": "。"
        }
       ],
       "py": [
        "tā",
        "bù",
        "kāichē"
       ]
      },
      {
       "id": "be333dae4",
       "text": "我们可以坐出租车。",
       "en": "We can take a taxi.",
       "pattern": "S A V O",
       "chunks": [
        {
         "role": "S",
         "words": [
          "我们|wǒmen"
         ]
        },
        {
         "role": "A",
         "words": [
          "可以|kěyǐ"
         ]
        },
        {
         "role": "V",
         "words": [
          "坐|zuò"
         ]
        },
        {
         "role": "O",
         "words": [
          "出租车|chūzūchē"
         ]
        }
       ],
       "punct": [
        {
         "at": 4,
         "p": "。"
        }
       ],
       "py": [
        "wǒmen",
        "kěyǐ",
        "zuò",
        "chūzūchē"
       ]
      }
     ]
    }
   ]
  },
  {
   "id": "weather",
   "title": "Weather and time",
   "zh": "天气",
   "topic": "Basic information: environment, weather (环境信息)",
   "notes": [
    "有点儿 means \"a bit\", and usually a bit too much of something unwelcome: 有点儿冷, a bit cold.",
    "Clock times: 点 is o'clock, 分 minutes and 半 half past: 九点半 is half past nine."
   ],
   "lessons": [
    {
     "id": "weather-1",
     "title": "The weather",
     "words": [
      "天气|tiānqì",
      "怎么样|zěnmeyàng",
      "冷|lěng",
      "热|rè",
      "有点儿|yǒudiǎnr",
      "天|tiān",
      "真|zhēn",
      "下雨|xiàyǔ",
      "雨|yǔ",
      "雪|xuě"
     ],
     "dialogue": [
      {
       "id": "d3214b65a",
       "who": "A",
       "en": "What's the weather like today?",
       "text": "今天天气怎么样？",
       "tokens": [
        {
         "id": "今天|jīntiān",
         "py": "jīntiān"
        },
        {
         "id": "天气|tiānqì",
         "py": "tiānqì"
        },
        {
         "id": "怎么样|zěnmeyàng",
         "py": "zěnmeyàng"
        },
        {
         "p": "？"
        }
       ]
      },
      {
       "id": "ddf306356",
       "who": "B",
       "en": "A bit cold. It's been really hot these last few days!",
       "text": "有点儿冷。这几天真热！",
       "tokens": [
        {
         "id": "有点儿|yǒudiǎnr",
         "py": "yǒudiǎnr"
        },
        {
         "id": "冷|lěng",
         "py": "lěng"
        },
        {
         "p": "。"
        },
        {
         "id": "这|zhè",
         "py": "zhè"
        },
        {
         "id": "几|jǐ",
         "py": "jǐ"
        },
        {
         "id": "天|tiān",
         "py": "tiān"
        },
        {
         "id": "真|zhēn",
         "py": "zhēn"
        },
        {
         "id": "热|rè",
         "py": "rè"
        },
        {
         "p": "！"
        }
       ]
      },
      {
       "id": "d2327aa45",
       "who": "A",
       "en": "And tomorrow? Will it rain?",
       "text": "明天呢？明天下雨吗？",
       "tokens": [
        {
         "id": "明天|míngtiān",
         "py": "míngtiān"
        },
        {
         "id": "呢|ne",
         "py": "ne"
        },
        {
         "p": "？"
        },
        {
         "id": "明天|míngtiān",
         "py": "míngtiān"
        },
        {
         "id": "下雨|xiàyǔ",
         "py": "xiàyǔ"
        },
        {
         "id": "吗|ma",
         "py": "ma"
        },
        {
         "p": "？"
        }
       ]
      },
      {
       "id": "d86b79fab",
       "who": "B",
       "en": "It'll rain tomorrow.",
       "text": "明天下雨。",
       "tokens": [
        {
         "id": "明天|míngtiān",
         "py": "míngtiān"
        },
        {
         "id": "下雨|xiàyǔ",
         "py": "xiàyǔ"
        },
        {
         "p": "。"
        }
       ]
      },
      {
       "id": "d7b72becd",
       "who": "A",
       "en": "I don't like rain. I like snow!",
       "text": "我不喜欢雨。我喜欢雪！",
       "tokens": [
        {
         "id": "我|wǒ",
         "py": "wǒ"
        },
        {
         "id": "不|bù",
         "py": "bù"
        },
        {
         "id": "喜欢|xǐhuan",
         "py": "xǐhuan"
        },
        {
         "id": "雨|yǔ",
         "py": "yǔ"
        },
        {
         "p": "。"
        },
        {
         "id": "我|wǒ",
         "py": "wǒ"
        },
        {
         "id": "喜欢|xǐhuan",
         "py": "xǐhuan"
        },
        {
         "id": "雪|xuě",
         "py": "xuě"
        },
        {
         "p": "！"
        }
       ]
      },
      {
       "id": "ddfefd961",
       "who": "B",
       "en": "I like snow too, it's beautiful.",
       "text": "我也喜欢雪，雪很漂亮。",
       "tokens": [
        {
         "id": "我|wǒ",
         "py": "wǒ"
        },
        {
         "id": "也|yě",
         "py": "yě"
        },
        {
         "id": "喜欢|xǐhuan",
         "py": "xǐhuan"
        },
        {
         "id": "雪|xuě",
         "py": "xuě"
        },
        {
         "p": "，"
        },
        {
         "id": "雪|xuě",
         "py": "xuě"
        },
        {
         "id": "很|hěn",
         "py": "hěn"
        },
        {
         "id": "漂亮|piàoliang",
         "py": "piàoliang"
        },
        {
         "p": "。"
        }
       ]
      }
     ],
     "builds": [
      {
       "id": "b3214b65a",
       "text": "今天天气怎么样？",
       "en": "What's the weather like today?",
       "pattern": "T S V",
       "chunks": [
        {
         "role": "T",
         "words": [
          "今天|jīntiān"
         ]
        },
        {
         "role": "S",
         "words": [
          "天气|tiānqì"
         ]
        },
        {
         "role": "V",
         "words": [
          "怎么样|zěnmeyàng"
         ]
        }
       ],
       "punct": [
        {
         "at": 3,
         "p": "？"
        }
       ],
       "py": [
        "jīntiān",
        "tiānqì",
        "zěnmeyàng"
       ]
      },
      {
       "id": "b7364a531",
       "text": "今天有点儿冷。",
       "en": "It's a bit cold today.",
       "pattern": "S A V",
       "chunks": [
        {
         "role": "S",
         "words": [
          "今天|jīntiān"
         ]
        },
        {
         "role": "A",
         "words": [
          "有点儿|yǒudiǎnr"
         ]
        },
        {
         "role": "V",
         "words": [
          "冷|lěng"
         ]
        }
       ],
       "punct": [
        {
         "at": 3,
         "p": "。"
        }
       ],
       "py": [
        "jīntiān",
        "yǒudiǎnr",
        "lěng"
       ]
      },
      {
       "id": "b86b79fab",
       "text": "明天下雨。",
       "en": "It'll rain tomorrow.",
       "pattern": "T V",
       "chunks": [
        {
         "role": "T",
         "words": [
          "明天|míngtiān"
         ]
        },
        {
         "role": "V",
         "words": [
          "下雨|xiàyǔ"
         ]
        }
       ],
       "punct": [
        {
         "at": 2,
         "p": "。"
        }
       ],
       "py": [
        "míngtiān",
        "xiàyǔ"
       ]
      },
      {
       "id": "b06fdbf0a",
       "text": "我喜欢雪。",
       "en": "I like snow.",
       "pattern": "S V O",
       "chunks": [
        {
         "role": "S",
         "words": [
          "我|wǒ"
         ]
        },
        {
         "role": "V",
         "words": [
          "喜欢|xǐhuan"
         ]
        },
        {
         "role": "O",
         "words": [
          "雪|xuě"
         ]
        }
       ],
       "punct": [
        {
         "at": 3,
         "p": "。"
        }
       ],
       "py": [
        "wǒ",
        "xǐhuan",
        "xuě"
       ]
      }
     ]
    },
    {
     "id": "weather-2",
     "title": "What time is it?",
     "words": [
      "现在|xiànzài",
      "点|diǎn",
      "半|bàn",
      "早上|zǎoshang",
      "分|fēn",
      "早|zǎo",
      "上午|shàngwǔ",
      "中午|zhōngwǔ",
      "下午|xiàwǔ",
      "晚上|wǎnshang"
     ],
     "dialogue": [
      {
       "id": "d7af2e1a0",
       "who": "A",
       "en": "What time is it now?",
       "text": "现在几点？",
       "tokens": [
        {
         "id": "现在|xiànzài",
         "py": "xiànzài"
        },
        {
         "id": "几|jǐ",
         "py": "jǐ"
        },
        {
         "id": "点|diǎn",
         "py": "diǎn"
        },
        {
         "p": "？"
        }
       ]
      },
      {
       "id": "d12bc2f84",
       "who": "B",
       "en": "Half past nine.",
       "text": "九点半。",
       "tokens": [
        {
         "id": "九|jiǔ",
         "py": "jiǔ"
        },
        {
         "id": "点|diǎn",
         "py": "diǎn"
        },
        {
         "id": "半|bàn",
         "py": "bàn"
        },
        {
         "p": "。"
        }
       ]
      },
      {
       "id": "d006824b0",
       "who": "A",
       "en": "What time do you have breakfast?",
       "text": "你早上几点吃早饭？",
       "tokens": [
        {
         "id": "你|nǐ",
         "py": "nǐ"
        },
        {
         "id": "早上|zǎoshang",
         "py": "zǎoshang"
        },
        {
         "id": "几|jǐ",
         "py": "jǐ"
        },
        {
         "id": "点|diǎn",
         "py": "diǎn"
        },
        {
         "id": "吃|chī",
         "py": "chī"
        },
        {
         "id": "早饭|zǎofàn",
         "py": "zǎofàn"
        },
        {
         "p": "？"
        }
       ]
      },
      {
       "id": "df5fc2a2a",
       "who": "B",
       "en": "At seven.",
       "text": "七点。",
       "tokens": [
        {
         "id": "七|qī",
         "py": "qī"
        },
        {
         "id": "点|diǎn",
         "py": "diǎn"
        },
        {
         "p": "。"
        }
       ]
      },
      {
       "id": "de643d368",
       "who": "A",
       "en": "You're early! I eat at ten past eight.",
       "text": "你真早！我八点十分吃。",
       "tokens": [
        {
         "id": "你|nǐ",
         "py": "nǐ"
        },
        {
         "id": "真|zhēn",
         "py": "zhēn"
        },
        {
         "id": "早|zǎo",
         "py": "zǎo"
        },
        {
         "p": "！"
        },
        {
         "id": "我|wǒ",
         "py": "wǒ"
        },
        {
         "id": "八|bā",
         "py": "bā"
        },
        {
         "id": "点|diǎn",
         "py": "diǎn"
        },
        {
         "id": "十|shí",
         "py": "shí"
        },
        {
         "id": "分|fēn",
         "py": "fēn"
        },
        {
         "id": "吃|chī",
         "py": "chī"
        },
        {
         "p": "。"
        }
       ]
      },
      {
       "id": "d419e8540",
       "who": "B",
       "en": "Are you at home in the morning?",
       "text": "你上午在家吗？",
       "tokens": [
        {
         "id": "你|nǐ",
         "py": "nǐ"
        },
        {
         "id": "上午|shàngwǔ",
         "py": "shàngwǔ"
        },
        {
         "id": "在|zài",
         "py": "zài"
        },
        {
         "id": "家|jiā",
         "py": "jiā"
        },
        {
         "id": "吗|ma",
         "py": "ma"
        },
        {
         "p": "？"
        }
       ]
      },
      {
       "id": "dfb11a4fe",
       "who": "A",
       "en": "In the morning, yes; at noon and in the afternoon, no.",
       "text": "上午在家，中午和下午不在。",
       "tokens": [
        {
         "id": "上午|shàngwǔ",
         "py": "shàngwǔ"
        },
        {
         "id": "在|zài",
         "py": "zài"
        },
        {
         "id": "家|jiā",
         "py": "jiā"
        },
        {
         "p": "，"
        },
        {
         "id": "中午|zhōngwǔ",
         "py": "zhōngwǔ"
        },
        {
         "id": "和|hé",
         "py": "hé"
        },
        {
         "id": "下午|xiàwǔ",
         "py": "xiàwǔ"
        },
        {
         "id": "不|bù",
         "py": "bú"
        },
        {
         "id": "在|zài",
         "py": "zài"
        },
        {
         "p": "。"
        }
       ]
      },
      {
       "id": "d4b5d96bf",
       "who": "B",
       "en": "And in the evening?",
       "text": "晚上呢？",
       "tokens": [
        {
         "id": "晚上|wǎnshang",
         "py": "wǎnshang"
        },
        {
         "id": "呢|ne",
         "py": "ne"
        },
        {
         "p": "？"
        }
       ]
      },
      {
       "id": "d8e9c9b5b",
       "who": "A",
       "en": "In the evening I'm at home.",
       "text": "晚上在家。",
       "tokens": [
        {
         "id": "晚上|wǎnshang",
         "py": "wǎnshang"
        },
        {
         "id": "在|zài",
         "py": "zài"
        },
        {
         "id": "家|jiā",
         "py": "jiā"
        },
        {
         "p": "。"
        }
       ]
      }
     ],
     "builds": [
      {
       "id": "bbadd38ed",
       "text": "现在九点半。",
       "en": "It's half past nine.",
       "pattern": "S V",
       "chunks": [
        {
         "role": "S",
         "words": [
          "现在|xiànzài"
         ]
        },
        {
         "role": "V",
         "words": [
          "九|jiǔ",
          "点|diǎn",
          "半|bàn"
         ]
        }
       ],
       "punct": [
        {
         "at": 2,
         "p": "。"
        }
       ],
       "py": [
        "xiànzài",
        "jiǔ",
        "diǎn",
        "bàn"
       ]
      },
      {
       "id": "b08059373",
       "text": "我早上七点吃早饭。",
       "en": "I have breakfast at seven.",
       "pattern": "S T V O",
       "chunks": [
        {
         "role": "S",
         "words": [
          "我|wǒ"
         ]
        },
        {
         "role": "T",
         "words": [
          "早上|zǎoshang",
          "七|qī",
          "点|diǎn"
         ]
        },
        {
         "role": "V",
         "words": [
          "吃|chī"
         ]
        },
        {
         "role": "O",
         "words": [
          "早饭|zǎofàn"
         ]
        }
       ],
       "punct": [
        {
         "at": 4,
         "p": "。"
        }
       ],
       "py": [
        "wǒ",
        "zǎoshang",
        "qī",
        "diǎn",
        "chī",
        "zǎofàn"
       ]
      },
      {
       "id": "b419e8540",
       "text": "你上午在家吗？",
       "en": "Are you at home in the morning?",
       "pattern": "S T V O X",
       "chunks": [
        {
         "role": "S",
         "words": [
          "你|nǐ"
         ]
        },
        {
         "role": "T",
         "words": [
          "上午|shàngwǔ"
         ]
        },
        {
         "role": "V",
         "words": [
          "在|zài"
         ]
        },
        {
         "role": "O",
         "words": [
          "家|jiā"
         ]
        },
        {
         "role": "X",
         "words": [
          "吗|ma"
         ]
        }
       ],
       "punct": [
        {
         "at": 5,
         "p": "？"
        }
       ],
       "py": [
        "nǐ",
        "shàngwǔ",
        "zài",
        "jiā",
        "ma"
       ]
      },
      {
       "id": "b1beabfe3",
       "text": "你真早！",
       "en": "You're early!",
       "pattern": "S A V",
       "chunks": [
        {
         "role": "S",
         "words": [
          "你|nǐ"
         ]
        },
        {
         "role": "A",
         "words": [
          "真|zhēn"
         ]
        },
        {
         "role": "V",
         "words": [
          "早|zǎo"
         ]
        }
       ],
       "punct": [
        {
         "at": 3,
         "p": "！"
        }
       ],
       "py": [
        "nǐ",
        "zhēn",
        "zǎo"
       ]
      }
     ]
    }
   ]
  },
  {
   "id": "school",
   "title": "School",
   "zh": "学校",
   "topic": "Education: study and campus life (学习情况, 校园生活)",
   "notes": [
    "汉语 and 中文 both mean Chinese. 汉语 is the usual word for the language you study; 中文 is common for written Chinese, as in 中文书, a Chinese book.",
    "Lessons begin with 上课 and end with 下课. Starting and finishing work are 上班 and 下班: 上 for going to, 下 for leaving."
   ],
   "lessons": [
    {
     "id": "school-1",
     "title": "Studying Chinese",
     "words": [
      "学习|xuéxí",
      "学校|xuéxiào",
      "汉语|Hànyǔ",
      "学|xué",
      "汉字|Hànzì",
      "上课|shàngkè",
      "下课|xiàkè",
      "书|shū",
      "中文|Zhōngwén",
      "课|kè"
     ],
     "dialogue": [
      {
       "id": "dc28b8446",
       "who": "A",
       "en": "Where do you study?",
       "text": "你在哪儿学习？",
       "tokens": [
        {
         "id": "你|nǐ",
         "py": "nǐ"
        },
        {
         "id": "在|zài",
         "py": "zài"
        },
        {
         "id": "哪儿|nǎr",
         "py": "nǎr"
        },
        {
         "id": "学习|xuéxí",
         "py": "xuéxí"
        },
        {
         "p": "？"
        }
       ]
      },
      {
       "id": "d28823850",
       "who": "B",
       "en": "I study Chinese at a school in Beijing.",
       "text": "我在北京的一个学校学习汉语。",
       "tokens": [
        {
         "id": "我|wǒ",
         "py": "wǒ"
        },
        {
         "id": "在|zài",
         "py": "zài"
        },
        {
         "name": "北京",
         "py": "Běijīng"
        },
        {
         "id": "的|de",
         "py": "de"
        },
        {
         "id": "一|yī",
         "py": "yí"
        },
        {
         "id": "个|gè",
         "py": "gè"
        },
        {
         "id": "学校|xuéxiào",
         "py": "xuéxiào"
        },
        {
         "id": "学习|xuéxí",
         "py": "xuéxí"
        },
        {
         "id": "汉语|Hànyǔ",
         "py": "Hànyǔ"
        },
        {
         "p": "。"
        }
       ]
      },
      {
       "id": "da67ff6d1",
       "who": "A",
       "en": "Do you like learning characters?",
       "text": "你喜欢学汉字吗？",
       "tokens": [
        {
         "id": "你|nǐ",
         "py": "nǐ"
        },
        {
         "id": "喜欢|xǐhuan",
         "py": "xǐhuan"
        },
        {
         "id": "学|xué",
         "py": "xué"
        },
        {
         "id": "汉字|Hànzì",
         "py": "Hànzì"
        },
        {
         "id": "吗|ma",
         "py": "ma"
        },
        {
         "p": "？"
        }
       ]
      },
      {
       "id": "d6afbbb5a",
       "who": "B",
       "en": "Very much! Characters are beautiful.",
       "text": "很喜欢！汉字很漂亮。",
       "tokens": [
        {
         "id": "很|hěn",
         "py": "hěn"
        },
        {
         "id": "喜欢|xǐhuan",
         "py": "xǐhuan"
        },
        {
         "p": "！"
        },
        {
         "id": "汉字|Hànzì",
         "py": "Hànzì"
        },
        {
         "id": "很|hěn",
         "py": "hěn"
        },
        {
         "id": "漂亮|piàoliang",
         "py": "piàoliang"
        },
        {
         "p": "。"
        }
       ]
      },
      {
       "id": "d093696c4",
       "who": "A",
       "en": "What time do your classes start?",
       "text": "你几点上课？",
       "tokens": [
        {
         "id": "你|nǐ",
         "py": "nǐ"
        },
        {
         "id": "几|jǐ",
         "py": "jǐ"
        },
        {
         "id": "点|diǎn",
         "py": "diǎn"
        },
        {
         "id": "上课|shàngkè",
         "py": "shàngkè"
        },
        {
         "p": "？"
        }
       ]
      },
      {
       "id": "d40b4e435",
       "who": "B",
       "en": "They start at eight and finish at twelve.",
       "text": "八点上课，十二点下课。",
       "tokens": [
        {
         "id": "八|bā",
         "py": "bā"
        },
        {
         "id": "点|diǎn",
         "py": "diǎn"
        },
        {
         "id": "上课|shàngkè",
         "py": "shàngkè"
        },
        {
         "p": "，"
        },
        {
         "id": "十|shí",
         "py": "shí"
        },
        {
         "id": "二|èr",
         "py": "èr"
        },
        {
         "id": "点|diǎn",
         "py": "diǎn"
        },
        {
         "id": "下课|xiàkè",
         "py": "xiàkè"
        },
        {
         "p": "。"
        }
       ]
      },
      {
       "id": "d688fb208",
       "who": "A",
       "en": "Is this your book?",
       "text": "这是你的书吗？",
       "tokens": [
        {
         "id": "这|zhè",
         "py": "zhè"
        },
        {
         "id": "是|shì",
         "py": "shì"
        },
        {
         "id": "你|nǐ",
         "py": "nǐ"
        },
        {
         "id": "的|de",
         "py": "de"
        },
        {
         "id": "书|shū",
         "py": "shū"
        },
        {
         "id": "吗|ma",
         "py": "ma"
        },
        {
         "p": "？"
        }
       ]
      },
      {
       "id": "d418247b6",
       "who": "B",
       "en": "Yes, it's my Chinese book. I have no classes this afternoon.",
       "text": "是，这是我的中文书。今天下午没有课。",
       "tokens": [
        {
         "id": "是|shì",
         "py": "shì"
        },
        {
         "p": "，"
        },
        {
         "id": "这|zhè",
         "py": "zhè"
        },
        {
         "id": "是|shì",
         "py": "shì"
        },
        {
         "id": "我|wǒ",
         "py": "wǒ"
        },
        {
         "id": "的|de",
         "py": "de"
        },
        {
         "id": "中文|Zhōngwén",
         "py": "Zhōngwén"
        },
        {
         "id": "书|shū",
         "py": "shū"
        },
        {
         "p": "。"
        },
        {
         "id": "今天|jīntiān",
         "py": "jīntiān"
        },
        {
         "id": "下午|xiàwǔ",
         "py": "xiàwǔ"
        },
        {
         "id": "没有|méiyǒu",
         "py": "méiyǒu"
        },
        {
         "id": "课|kè",
         "py": "kè"
        },
        {
         "p": "。"
        }
       ]
      }
     ],
     "builds": [
      {
       "id": "bb6ba2441",
       "text": "我学习汉语。",
       "en": "I study Chinese.",
       "pattern": "S V O",
       "chunks": [
        {
         "role": "S",
         "words": [
          "我|wǒ"
         ]
        },
        {
         "role": "V",
         "words": [
          "学习|xuéxí"
         ]
        },
        {
         "role": "O",
         "words": [
          "汉语|Hànyǔ"
         ]
        }
       ],
       "punct": [
        {
         "at": 3,
         "p": "。"
        }
       ],
       "py": [
        "wǒ",
        "xuéxí",
        "Hànyǔ"
       ]
      },
      {
       "id": "b47b578d4",
       "text": "我喜欢学汉字。",
       "en": "I like learning characters.",
       "pattern": "S A V O",
       "chunks": [
        {
         "role": "S",
         "words": [
          "我|wǒ"
         ]
        },
        {
         "role": "A",
         "words": [
          "喜欢|xǐhuan"
         ]
        },
        {
         "role": "V",
         "words": [
          "学|xué"
         ]
        },
        {
         "role": "O",
         "words": [
          "汉字|Hànzì"
         ]
        }
       ],
       "punct": [
        {
         "at": 4,
         "p": "。"
        }
       ],
       "py": [
        "wǒ",
        "xǐhuan",
        "xué",
        "Hànzì"
       ]
      },
      {
       "id": "bda35c6bf",
       "text": "我们八点上课。",
       "en": "Our classes start at eight.",
       "pattern": "S T V",
       "chunks": [
        {
         "role": "S",
         "words": [
          "我们|wǒmen"
         ]
        },
        {
         "role": "T",
         "words": [
          "八|bā",
          "点|diǎn"
         ]
        },
        {
         "role": "V",
         "words": [
          "上课|shàngkè"
         ]
        }
       ],
       "punct": [
        {
         "at": 3,
         "p": "。"
        }
       ],
       "py": [
        "wǒmen",
        "bā",
        "diǎn",
        "shàngkè"
       ]
      },
      {
       "id": "b90e02c8e",
       "text": "这是我的中文书。",
       "en": "This is my Chinese book.",
       "pattern": "S V O",
       "chunks": [
        {
         "role": "S",
         "words": [
          "这|zhè"
         ]
        },
        {
         "role": "V",
         "words": [
          "是|shì"
         ]
        },
        {
         "role": "O",
         "words": [
          "我|wǒ",
          "的|de",
          "中文|Zhōngwén",
          "书|shū"
         ]
        }
       ],
       "punct": [
        {
         "at": 3,
         "p": "。"
        }
       ],
       "py": [
        "zhè",
        "shì",
        "wǒ",
        "de",
        "Zhōngwén",
        "shū"
       ]
      }
     ]
    },
    {
     "id": "school-2",
     "title": "From primary school to university",
     "words": [
      "们|men",
      "大学生|dàxuéshēng",
      "大学|dàxué",
      "中学生|zhōngxuéshēng",
      "中学|zhōngxué",
      "小学生|xiǎoxuéshēng",
      "上学|shàngxué",
      "小学|xiǎoxué",
      "写|xiě",
      "字|zì"
     ],
     "dialogue": [
      {
       "id": "d4f798384",
       "who": "A",
       "en": "Hello, everyone!",
       "text": "同学们好！",
       "tokens": [
        {
         "id": "同学|tóngxué",
         "py": "tóngxué"
        },
        {
         "id": "们|men",
         "py": "men"
        },
        {
         "id": "好|hǎo",
         "py": "hǎo"
        },
        {
         "p": "！"
        }
       ]
      },
      {
       "id": "d2448ea00",
       "who": "B",
       "en": "Hello, teacher!",
       "text": "老师好！",
       "tokens": [
        {
         "id": "老师|lǎoshī",
         "py": "lǎoshī"
        },
        {
         "id": "好|hǎo",
         "py": "hǎo"
        },
        {
         "p": "！"
        }
       ]
      },
      {
       "id": "d264494db",
       "who": "A",
       "en": "Are you all university students?",
       "text": "你们都是大学生吗？",
       "tokens": [
        {
         "id": "你们|nǐmen",
         "py": "nǐmen"
        },
        {
         "id": "都|dōu",
         "py": "dōu"
        },
        {
         "id": "是|shì",
         "py": "shì"
        },
        {
         "id": "大学生|dàxuéshēng",
         "py": "dàxuéshēng"
        },
        {
         "id": "吗|ma",
         "py": "ma"
        },
        {
         "p": "？"
        }
       ]
      },
      {
       "id": "d12c41fe6",
       "who": "B",
       "en": "Yes, we're university students. Our university is big. My younger sister is at secondary school.",
       "text": "是，我们是大学生。我们的大学很大。我妹妹是中学生。",
       "tokens": [
        {
         "id": "是|shì",
         "py": "shì"
        },
        {
         "p": "，"
        },
        {
         "id": "我们|wǒmen",
         "py": "wǒmen"
        },
        {
         "id": "是|shì",
         "py": "shì"
        },
        {
         "id": "大学生|dàxuéshēng",
         "py": "dàxuéshēng"
        },
        {
         "p": "。"
        },
        {
         "id": "我们|wǒmen",
         "py": "wǒmen"
        },
        {
         "id": "的|de",
         "py": "de"
        },
        {
         "id": "大学|dàxué",
         "py": "dàxué"
        },
        {
         "id": "很|hěn",
         "py": "hěn"
        },
        {
         "id": "大|dà",
         "py": "dà"
        },
        {
         "p": "。"
        },
        {
         "id": "我|wǒ",
         "py": "wǒ"
        },
        {
         "id": "妹妹|mèimei",
         "py": "mèimei"
        },
        {
         "id": "是|shì",
         "py": "shì"
        },
        {
         "id": "中学生|zhōngxuéshēng",
         "py": "zhōngxuéshēng"
        },
        {
         "p": "。"
        }
       ]
      },
      {
       "id": "d9c3c6527",
       "who": "C",
       "en": "My younger brother is at primary school. He's seven and started school this year.",
       "text": "我弟弟是小学生。他七岁，今年上学。",
       "tokens": [
        {
         "id": "我|wǒ",
         "py": "wǒ"
        },
        {
         "id": "弟弟|dìdi",
         "py": "dìdi"
        },
        {
         "id": "是|shì",
         "py": "shì"
        },
        {
         "id": "小学生|xiǎoxuéshēng",
         "py": "xiǎoxuéshēng"
        },
        {
         "p": "。"
        },
        {
         "id": "他|tā",
         "py": "tā"
        },
        {
         "id": "七|qī",
         "py": "qī"
        },
        {
         "id": "岁|suì",
         "py": "suì"
        },
        {
         "p": "，"
        },
        {
         "id": "今年|jīnnián",
         "py": "jīnnián"
        },
        {
         "id": "上学|shàngxué",
         "py": "shàngxué"
        },
        {
         "p": "。"
        }
       ]
      },
      {
       "id": "d5990423d",
       "who": "A",
       "en": "Where's his primary school?",
       "text": "他的小学在哪儿？",
       "tokens": [
        {
         "id": "他|tā",
         "py": "tā"
        },
        {
         "id": "的|de",
         "py": "de"
        },
        {
         "id": "小学|xiǎoxué",
         "py": "xiǎoxué"
        },
        {
         "id": "在|zài",
         "py": "zài"
        },
        {
         "id": "哪儿|nǎr",
         "py": "nǎr"
        },
        {
         "p": "？"
        }
       ]
      },
      {
       "id": "d88e47414",
       "who": "C",
       "en": "His primary school is over there, and my secondary school was there too.",
       "text": "他的小学在那儿，我的中学也在那儿。",
       "tokens": [
        {
         "id": "他|tā",
         "py": "tā"
        },
        {
         "id": "的|de",
         "py": "de"
        },
        {
         "id": "小学|xiǎoxué",
         "py": "xiǎoxué"
        },
        {
         "id": "在|zài",
         "py": "zài"
        },
        {
         "id": "那儿|nàr",
         "py": "nàr"
        },
        {
         "p": "，"
        },
        {
         "id": "我|wǒ",
         "py": "wǒ"
        },
        {
         "id": "的|de",
         "py": "de"
        },
        {
         "id": "中学|zhōngxué",
         "py": "zhōngxué"
        },
        {
         "id": "也|yě",
         "py": "yě"
        },
        {
         "id": "在|zài",
         "py": "zài"
        },
        {
         "id": "那儿|nàr",
         "py": "nàr"
        },
        {
         "p": "。"
        }
       ]
      },
      {
       "id": "d6c3c63c3",
       "who": "A",
       "en": "Xiaoming, what are you writing?",
       "text": "小明，你写什么？",
       "tokens": [
        {
         "name": "小明",
         "py": "Xiǎomíng"
        },
        {
         "p": "，"
        },
        {
         "id": "你|nǐ",
         "py": "nǐ"
        },
        {
         "id": "写|xiě",
         "py": "xiě"
        },
        {
         "id": "什么|shénme",
         "py": "shénme"
        },
        {
         "p": "？"
        }
       ]
      },
      {
       "id": "da4c26bad",
       "who": "D",
       "en": "Characters. Does this one look right?",
       "text": "我写汉字。这个字好看吗？",
       "tokens": [
        {
         "id": "我|wǒ",
         "py": "wǒ"
        },
        {
         "id": "写|xiě",
         "py": "xiě"
        },
        {
         "id": "汉字|Hànzì",
         "py": "Hànzì"
        },
        {
         "p": "。"
        },
        {
         "id": "这个|zhège",
         "py": "zhège"
        },
        {
         "id": "字|zì",
         "py": "zì"
        },
        {
         "id": "好看|hǎokàn",
         "py": "hǎokàn"
        },
        {
         "id": "吗|ma",
         "py": "ma"
        },
        {
         "p": "？"
        }
       ]
      },
      {
       "id": "dfc2b15b0",
       "who": "A",
       "en": "It looks great!",
       "text": "很好看！",
       "tokens": [
        {
         "id": "很|hěn",
         "py": "hěn"
        },
        {
         "id": "好看|hǎokàn",
         "py": "hǎokàn"
        },
        {
         "p": "！"
        }
       ]
      }
     ],
     "builds": [
      {
       "id": "b1896c2da",
       "text": "我是大学生。",
       "en": "I'm a university student.",
       "pattern": "S V O",
       "chunks": [
        {
         "role": "S",
         "words": [
          "我|wǒ"
         ]
        },
        {
         "role": "V",
         "words": [
          "是|shì"
         ]
        },
        {
         "role": "O",
         "words": [
          "大学生|dàxuéshēng"
         ]
        }
       ],
       "punct": [
        {
         "at": 3,
         "p": "。"
        }
       ],
       "py": [
        "wǒ",
        "shì",
        "dàxuéshēng"
       ]
      },
      {
       "id": "bd30763a3",
       "text": "我的弟弟是小学生。",
       "en": "My younger brother is at primary school.",
       "pattern": "S V O",
       "chunks": [
        {
         "role": "S",
         "words": [
          "我|wǒ",
          "的|de",
          "弟弟|dìdi"
         ]
        },
        {
         "role": "V",
         "words": [
          "是|shì"
         ]
        },
        {
         "role": "O",
         "words": [
          "小学生|xiǎoxuéshēng"
         ]
        }
       ],
       "punct": [
        {
         "at": 3,
         "p": "。"
        }
       ],
       "py": [
        "wǒ",
        "de",
        "dìdi",
        "shì",
        "xiǎoxuéshēng"
       ]
      },
      {
       "id": "b4ff1fd49",
       "text": "他今年上学。",
       "en": "He started school this year.",
       "pattern": "S T V",
       "chunks": [
        {
         "role": "S",
         "words": [
          "他|tā"
         ]
        },
        {
         "role": "T",
         "words": [
          "今年|jīnnián"
         ]
        },
        {
         "role": "V",
         "words": [
          "上学|shàngxué"
         ]
        }
       ],
       "punct": [
        {
         "at": 3,
         "p": "。"
        }
       ],
       "py": [
        "tā",
        "jīnnián",
        "shàngxué"
       ]
      },
      {
       "id": "b5765f785",
       "text": "我写汉字。",
       "en": "I'm writing characters.",
       "pattern": "S V O",
       "chunks": [
        {
         "role": "S",
         "words": [
          "我|wǒ"
         ]
        },
        {
         "role": "V",
         "words": [
          "写|xiě"
         ]
        },
        {
         "role": "O",
         "words": [
          "汉字|Hànzì"
         ]
        }
       ],
       "punct": [
        {
         "at": 3,
         "p": "。"
        }
       ],
       "py": [
        "wǒ",
        "xiě",
        "Hànzì"
       ]
      }
     ]
    }
   ]
  },
  {
   "id": "work",
   "title": "Work",
   "zh": "工作",
   "topic": "Work: work and occupations (工作情况, 职业)",
   "notes": [
    "先生 and 女士 are polite titles after a family name: 王先生, Mr Wang; 李女士, Ms Li.",
    "Answering the phone, people say 喂, \"hello?\", often with a rising tone."
   ],
   "lessons": [
    {
     "id": "work-1",
     "title": "What do you do?",
     "words": [
      "做|zuò",
      "工作|gōngzuò",
      "医生|yīshēng",
      "公司|gōngsī",
      "忙|máng",
      "上班|shàngbān",
      "下班|xiàbān",
      "先生|xiānsheng",
      "女士|nǚshì",
      "事|shì"
     ],
     "dialogue": [
      {
       "id": "dcd28c06a",
       "who": "A",
       "en": "What do you do?",
       "text": "你做什么工作？",
       "tokens": [
        {
         "id": "你|nǐ",
         "py": "nǐ"
        },
        {
         "id": "做|zuò",
         "py": "zuò"
        },
        {
         "id": "什么|shénme",
         "py": "shénme"
        },
        {
         "id": "工作|gōngzuò",
         "py": "gōngzuò"
        },
        {
         "p": "？"
        }
       ]
      },
      {
       "id": "d2bba4e78",
       "who": "B",
       "en": "I'm a doctor. And you?",
       "text": "我是医生。你呢？",
       "tokens": [
        {
         "id": "我|wǒ",
         "py": "wǒ"
        },
        {
         "id": "是|shì",
         "py": "shì"
        },
        {
         "id": "医生|yīshēng",
         "py": "yīshēng"
        },
        {
         "p": "。"
        },
        {
         "id": "你|nǐ",
         "py": "nǐ"
        },
        {
         "id": "呢|ne",
         "py": "ne"
        },
        {
         "p": "？"
        }
       ]
      },
      {
       "id": "d5880738f",
       "who": "A",
       "en": "I work at a company.",
       "text": "我在一个公司工作。",
       "tokens": [
        {
         "id": "我|wǒ",
         "py": "wǒ"
        },
        {
         "id": "在|zài",
         "py": "zài"
        },
        {
         "id": "一|yī",
         "py": "yí"
        },
        {
         "id": "个|gè",
         "py": "gè"
        },
        {
         "id": "公司|gōngsī",
         "py": "gōngsī"
        },
        {
         "id": "工作|gōngzuò",
         "py": "gōngzuò"
        },
        {
         "p": "。"
        }
       ]
      },
      {
       "id": "dac0d98c9",
       "who": "B",
       "en": "Are you busy?",
       "text": "你忙吗？",
       "tokens": [
        {
         "id": "你|nǐ",
         "py": "nǐ"
        },
        {
         "id": "忙|máng",
         "py": "máng"
        },
        {
         "id": "吗|ma",
         "py": "ma"
        },
        {
         "p": "？"
        }
       ]
      },
      {
       "id": "dff4f50ca",
       "who": "A",
       "en": "Very. I start at eight and finish at seven in the evening.",
       "text": "很忙。我八点上班，晚上七点下班。",
       "tokens": [
        {
         "id": "很|hěn",
         "py": "hěn"
        },
        {
         "id": "忙|máng",
         "py": "máng"
        },
        {
         "p": "。"
        },
        {
         "id": "我|wǒ",
         "py": "wǒ"
        },
        {
         "id": "八|bā",
         "py": "bā"
        },
        {
         "id": "点|diǎn",
         "py": "diǎn"
        },
        {
         "id": "上班|shàngbān",
         "py": "shàngbān"
        },
        {
         "p": "，"
        },
        {
         "id": "晚上|wǎnshang",
         "py": "wǎnshang"
        },
        {
         "id": "七|qī",
         "py": "qī"
        },
        {
         "id": "点|diǎn",
         "py": "diǎn"
        },
        {
         "id": "下班|xiàbān",
         "py": "xiàbān"
        },
        {
         "p": "。"
        }
       ]
      },
      {
       "id": "d8e0ebcec",
       "who": "B",
       "en": "Are Mr Wang and Ms Li at your company too?",
       "text": "王先生和李女士也在你们公司吗？",
       "tokens": [
        {
         "name": "王",
         "py": "Wáng"
        },
        {
         "id": "先生|xiānsheng",
         "py": "xiānsheng"
        },
        {
         "id": "和|hé",
         "py": "hé"
        },
        {
         "name": "李",
         "py": "Lǐ"
        },
        {
         "id": "女士|nǚshì",
         "py": "nǚshì"
        },
        {
         "id": "也|yě",
         "py": "yě"
        },
        {
         "id": "在|zài",
         "py": "zài"
        },
        {
         "id": "你们|nǐmen",
         "py": "nǐmen"
        },
        {
         "id": "公司|gōngsī",
         "py": "gōngsī"
        },
        {
         "id": "吗|ma",
         "py": "ma"
        },
        {
         "p": "？"
        }
       ]
      },
      {
       "id": "d2f101f18",
       "who": "A",
       "en": "Yes. They have something on today, so they're not at work.",
       "text": "是。他们今天有事，不上班。",
       "tokens": [
        {
         "id": "是|shì",
         "py": "shì"
        },
        {
         "p": "。"
        },
        {
         "id": "他们|tāmen",
         "py": "tāmen"
        },
        {
         "id": "今天|jīntiān",
         "py": "jīntiān"
        },
        {
         "id": "有|yǒu",
         "py": "yǒu"
        },
        {
         "id": "事|shì",
         "py": "shì"
        },
        {
         "p": "，"
        },
        {
         "id": "不|bù",
         "py": "bú"
        },
        {
         "id": "上班|shàngbān",
         "py": "shàngbān"
        },
        {
         "p": "。"
        }
       ]
      }
     ],
     "builds": [
      {
       "id": "bcd28c06a",
       "text": "你做什么工作？",
       "en": "What do you do?",
       "pattern": "S V O",
       "chunks": [
        {
         "role": "S",
         "words": [
          "你|nǐ"
         ]
        },
        {
         "role": "V",
         "words": [
          "做|zuò"
         ]
        },
        {
         "role": "O",
         "words": [
          "什么|shénme",
          "工作|gōngzuò"
         ]
        }
       ],
       "punct": [
        {
         "at": 3,
         "p": "？"
        }
       ],
       "py": [
        "nǐ",
        "zuò",
        "shénme",
        "gōngzuò"
       ]
      },
      {
       "id": "b5880738f",
       "text": "我在一个公司工作。",
       "en": "I work at a company.",
       "pattern": "S P V",
       "chunks": [
        {
         "role": "S",
         "words": [
          "我|wǒ"
         ]
        },
        {
         "role": "P",
         "words": [
          "在|zài",
          "一|yī",
          "个|gè",
          "公司|gōngsī"
         ]
        },
        {
         "role": "V",
         "words": [
          "工作|gōngzuò"
         ]
        }
       ],
       "punct": [
        {
         "at": 3,
         "p": "。"
        }
       ],
       "py": [
        "wǒ",
        "zài",
        "yí",
        "gè",
        "gōngsī",
        "gōngzuò"
       ]
      },
      {
       "id": "b8ea4c6bb",
       "text": "我八点上班。",
       "en": "I start work at eight.",
       "pattern": "S T V",
       "chunks": [
        {
         "role": "S",
         "words": [
          "我|wǒ"
         ]
        },
        {
         "role": "T",
         "words": [
          "八|bā",
          "点|diǎn"
         ]
        },
        {
         "role": "V",
         "words": [
          "上班|shàngbān"
         ]
        }
       ],
       "punct": [
        {
         "at": 3,
         "p": "。"
        }
       ],
       "py": [
        "wǒ",
        "bā",
        "diǎn",
        "shàngbān"
       ]
      },
      {
       "id": "b41013588",
       "text": "他们今天有事。",
       "en": "They have something on today.",
       "pattern": "S T V O",
       "chunks": [
        {
         "role": "S",
         "words": [
          "他们|tāmen"
         ]
        },
        {
         "role": "T",
         "words": [
          "今天|jīntiān"
         ]
        },
        {
         "role": "V",
         "words": [
          "有|yǒu"
         ]
        },
        {
         "role": "O",
         "words": [
          "事|shì"
         ]
        }
       ],
       "punct": [
        {
         "at": 4,
         "p": "。"
        }
       ],
       "py": [
        "tāmen",
        "jīntiān",
        "yǒu",
        "shì"
       ]
      }
     ]
    },
    {
     "id": "work-2",
     "title": "On the phone",
     "words": [
      "喂|wèi",
      "说话|shuōhuà",
      "说|shuō",
      "问|wèn",
      "问题|wèntí",
      "电话|diànhuà",
      "知道|zhīdào",
      "打电话|dǎdiànhuà",
      "对|duì",
      "手机|shǒujī"
     ],
     "dialogue": [
      {
       "id": "d546ea52c",
       "who": "A",
       "en": "Hello?",
       "text": "喂？你好！",
       "tokens": [
        {
         "id": "喂|wèi",
         "py": "wèi"
        },
        {
         "p": "？"
        },
        {
         "id": "你好|nǐhǎo",
         "py": "nǐhǎo"
        },
        {
         "p": "！"
        }
       ]
      },
      {
       "id": "d393b414c",
       "who": "B",
       "en": "Hi, it's David. Can you talk now?",
       "text": "喂，我是大卫。你现在可以说话吗？",
       "tokens": [
        {
         "id": "喂|wèi",
         "py": "wèi"
        },
        {
         "p": "，"
        },
        {
         "id": "我|wǒ",
         "py": "wǒ"
        },
        {
         "id": "是|shì",
         "py": "shì"
        },
        {
         "name": "大卫",
         "py": "Dàwèi"
        },
        {
         "p": "。"
        },
        {
         "id": "你|nǐ",
         "py": "nǐ"
        },
        {
         "id": "现在|xiànzài",
         "py": "xiànzài"
        },
        {
         "id": "可以|kěyǐ",
         "py": "kěyǐ"
        },
        {
         "id": "说话|shuōhuà",
         "py": "shuōhuà"
        },
        {
         "id": "吗|ma",
         "py": "ma"
        },
        {
         "p": "？"
        }
       ]
      },
      {
       "id": "d479676af",
       "who": "A",
       "en": "Sure. What's up?",
       "text": "可以。什么事？",
       "tokens": [
        {
         "id": "可以|kěyǐ",
         "py": "kěyǐ"
        },
        {
         "p": "。"
        },
        {
         "id": "什么|shénme",
         "py": "shénme"
        },
        {
         "id": "事|shì",
         "py": "shì"
        },
        {
         "p": "？"
        }
       ]
      },
      {
       "id": "deddd5b52",
       "who": "B",
       "en": "I'd like to ask you something.",
       "text": "我想问你一个问题。",
       "tokens": [
        {
         "id": "我|wǒ",
         "py": "wǒ"
        },
        {
         "id": "想|xiǎng",
         "py": "xiǎng"
        },
        {
         "id": "问|wèn",
         "py": "wèn"
        },
        {
         "id": "你|nǐ",
         "py": "nǐ"
        },
        {
         "id": "一|yī",
         "py": "yí"
        },
        {
         "id": "个|gè",
         "py": "gè"
        },
        {
         "id": "问题|wèntí",
         "py": "wèntí"
        },
        {
         "p": "。"
        }
       ]
      },
      {
       "id": "de32ded9f",
       "who": "A",
       "en": "Go ahead.",
       "text": "你说。",
       "tokens": [
        {
         "id": "你|nǐ",
         "py": "nǐ"
        },
        {
         "id": "说|shuō",
         "py": "shuō"
        },
        {
         "p": "。"
        }
       ]
      },
      {
       "id": "ddc8f458d",
       "who": "B",
       "en": "What's Teacher Li's phone number?",
       "text": "李老师的电话是多少？",
       "tokens": [
        {
         "name": "李",
         "py": "Lǐ"
        },
        {
         "id": "老师|lǎoshī",
         "py": "lǎoshī"
        },
        {
         "id": "的|de",
         "py": "de"
        },
        {
         "id": "电话|diànhuà",
         "py": "diànhuà"
        },
        {
         "id": "是|shì",
         "py": "shì"
        },
        {
         "id": "多少|duōshao",
         "py": "duōshao"
        },
        {
         "p": "？"
        }
       ]
      },
      {
       "id": "d9747db9a",
       "who": "A",
       "en": "I don't know. Call Xiaoming and ask; he knows.",
       "text": "我不知道。你打电话问小明，他知道。",
       "tokens": [
        {
         "id": "我|wǒ",
         "py": "wǒ"
        },
        {
         "id": "不|bù",
         "py": "bù"
        },
        {
         "id": "知道|zhīdào",
         "py": "zhīdào"
        },
        {
         "p": "。"
        },
        {
         "id": "你|nǐ",
         "py": "nǐ"
        },
        {
         "id": "打电话|dǎdiànhuà",
         "py": "dǎdiànhuà"
        },
        {
         "id": "问|wèn",
         "py": "wèn"
        },
        {
         "name": "小明",
         "py": "Xiǎomíng"
        },
        {
         "p": "，"
        },
        {
         "id": "他|tā",
         "py": "tā"
        },
        {
         "id": "知道|zhīdào",
         "py": "zhīdào"
        },
        {
         "p": "。"
        }
       ]
      },
      {
       "id": "d415b90ab",
       "who": "B",
       "en": "Right! I've got his mobile number. Thanks!",
       "text": "对！他的手机我知道。谢谢！",
       "tokens": [
        {
         "id": "对|duì",
         "py": "duì"
        },
        {
         "p": "！"
        },
        {
         "id": "他|tā",
         "py": "tā"
        },
        {
         "id": "的|de",
         "py": "de"
        },
        {
         "id": "手机|shǒujī",
         "py": "shǒujī"
        },
        {
         "id": "我|wǒ",
         "py": "wǒ"
        },
        {
         "id": "知道|zhīdào",
         "py": "zhīdào"
        },
        {
         "p": "。"
        },
        {
         "id": "谢谢|xièxie",
         "py": "xièxie"
        },
        {
         "p": "！"
        }
       ]
      }
     ],
     "builds": [
      {
       "id": "bfa24f01e",
       "text": "你现在可以说话吗？",
       "en": "Can you talk now?",
       "pattern": "S T A V X",
       "chunks": [
        {
         "role": "S",
         "words": [
          "你|nǐ"
         ]
        },
        {
         "role": "T",
         "words": [
          "现在|xiànzài"
         ]
        },
        {
         "role": "A",
         "words": [
          "可以|kěyǐ"
         ]
        },
        {
         "role": "V",
         "words": [
          "说话|shuōhuà"
         ]
        },
        {
         "role": "X",
         "words": [
          "吗|ma"
         ]
        }
       ],
       "punct": [
        {
         "at": 5,
         "p": "？"
        }
       ],
       "py": [
        "nǐ",
        "xiànzài",
        "kěyǐ",
        "shuōhuà",
        "ma"
       ]
      },
      {
       "id": "b628efd11",
       "text": "我想问一个问题。",
       "en": "I'd like to ask a question.",
       "pattern": "S A V O",
       "chunks": [
        {
         "role": "S",
         "words": [
          "我|wǒ"
         ]
        },
        {
         "role": "A",
         "words": [
          "想|xiǎng"
         ]
        },
        {
         "role": "V",
         "words": [
          "问|wèn"
         ]
        },
        {
         "role": "O",
         "words": [
          "一|yī",
          "个|gè",
          "问题|wèntí"
         ]
        }
       ],
       "punct": [
        {
         "at": 4,
         "p": "。"
        }
       ],
       "py": [
        "wǒ",
        "xiǎng",
        "wèn",
        "yí",
        "gè",
        "wèntí"
       ]
      },
      {
       "id": "b550e7c69",
       "text": "我不知道。",
       "en": "I don't know.",
       "pattern": "S A V",
       "chunks": [
        {
         "role": "S",
         "words": [
          "我|wǒ"
         ]
        },
        {
         "role": "A",
         "words": [
          "不|bù"
         ]
        },
        {
         "role": "V",
         "words": [
          "知道|zhīdào"
         ]
        }
       ],
       "punct": [
        {
         "at": 3,
         "p": "。"
        }
       ],
       "py": [
        "wǒ",
        "bù",
        "zhīdào"
       ]
      },
      {
       "id": "bafbf9c06",
       "text": "你打电话问他。",
       "en": "Call and ask him.",
       "pattern": "S V V O",
       "chunks": [
        {
         "role": "S",
         "words": [
          "你|nǐ"
         ]
        },
        {
         "role": "V",
         "words": [
          "打电话|dǎdiànhuà"
         ]
        },
        {
         "role": "V",
         "words": [
          "问|wèn"
         ]
        },
        {
         "role": "O",
         "words": [
          "他|tā"
         ]
        }
       ],
       "punct": [
        {
         "at": 4,
         "p": "。"
        }
       ],
       "py": [
        "nǐ",
        "dǎdiànhuà",
        "wèn",
        "tā"
       ]
      }
     ]
    }
   ]
  },
  {
   "id": "health",
   "title": "Feeling ill",
   "zh": "看病",
   "topic": "Daily life: health (医疗健康)",
   "notes": [
    "没事 means \"it's nothing\": 我没事, I'm fine. It is one of the most common reassurances in Chinese.",
    "When someone is ill, the usual advice is to drink plenty of water and rest: 多喝水, 多休息."
   ],
   "lessons": [
    {
     "id": "health-1",
     "title": "At the doctor's",
     "words": [
      "生病|shēngbìng",
      "医院|yīyuàn",
      "看病|kànbìng",
      "病|bìng",
      "没事|méishì",
      "休息|xiūxi",
      "不要|búyào",
      "睡觉|shuìjiào",
      "一点儿|yìdiǎnr",
      "睡|shuì"
     ],
     "dialogue": [
      {
       "id": "db306f745",
       "who": "A",
       "en": "What's wrong?",
       "text": "你怎么了？",
       "tokens": [
        {
         "id": "你|nǐ",
         "py": "nǐ"
        },
        {
         "id": "怎么|zěnme",
         "py": "zěnme"
        },
        {
         "id": "了|le",
         "py": "le"
        },
        {
         "p": "？"
        }
       ]
      },
      {
       "id": "d9835ec97",
       "who": "B",
       "en": "I'm ill.",
       "text": "我生病了。",
       "tokens": [
        {
         "id": "我|wǒ",
         "py": "wǒ"
        },
        {
         "id": "生病|shēngbìng",
         "py": "shēngbìng"
        },
        {
         "id": "了|le",
         "py": "le"
        },
        {
         "p": "。"
        }
       ]
      },
      {
       "id": "d834f1e0f",
       "who": "A",
       "en": "You should go to the hospital and see a doctor.",
       "text": "你要去医院看病。",
       "tokens": [
        {
         "id": "你|nǐ",
         "py": "nǐ"
        },
        {
         "id": "要|yào",
         "py": "yào"
        },
        {
         "id": "去|qù",
         "py": "qù"
        },
        {
         "id": "医院|yīyuàn",
         "py": "yīyuàn"
        },
        {
         "id": "看病|kànbìng",
         "py": "kànbìng"
        },
        {
         "p": "。"
        }
       ]
      },
      {
       "id": "d70bac739",
       "who": "C",
       "en": "It's nothing, not a serious illness.",
       "text": "没事，不是大病。",
       "tokens": [
        {
         "id": "没事|méishì",
         "py": "méishì"
        },
        {
         "p": "，"
        },
        {
         "id": "不|bù",
         "py": "bú"
        },
        {
         "id": "是|shì",
         "py": "shì"
        },
        {
         "id": "大|dà",
         "py": "dà"
        },
        {
         "id": "病|bìng",
         "py": "bìng"
        },
        {
         "p": "。"
        }
       ]
      },
      {
       "id": "d039bec2b",
       "who": "C",
       "en": "You need to rest and drink plenty of water.",
       "text": "你要多休息，多喝水。",
       "tokens": [
        {
         "id": "你|nǐ",
         "py": "nǐ"
        },
        {
         "id": "要|yào",
         "py": "yào"
        },
        {
         "id": "多|duō",
         "py": "duō"
        },
        {
         "id": "休息|xiūxi",
         "py": "xiūxi"
        },
        {
         "p": "，"
        },
        {
         "id": "多|duō",
         "py": "duō"
        },
        {
         "id": "喝|hē",
         "py": "hē"
        },
        {
         "id": "水|shuǐ",
         "py": "shuǐ"
        },
        {
         "p": "。"
        }
       ]
      },
      {
       "id": "d3371ff68",
       "who": "B",
       "en": "Can I go to work?",
       "text": "我可以上班吗？",
       "tokens": [
        {
         "id": "我|wǒ",
         "py": "wǒ"
        },
        {
         "id": "可以|kěyǐ",
         "py": "kěyǐ"
        },
        {
         "id": "上班|shàngbān",
         "py": "shàngbān"
        },
        {
         "id": "吗|ma",
         "py": "ma"
        },
        {
         "p": "？"
        }
       ]
      },
      {
       "id": "d613b4901",
       "who": "C",
       "en": "Don't go to work; you need to sleep.",
       "text": "不要上班，你要睡觉。",
       "tokens": [
        {
         "id": "不要|búyào",
         "py": "búyào"
        },
        {
         "id": "上班|shàngbān",
         "py": "shàngbān"
        },
        {
         "p": "，"
        },
        {
         "id": "你|nǐ",
         "py": "nǐ"
        },
        {
         "id": "要|yào",
         "py": "yào"
        },
        {
         "id": "睡觉|shuìjiào",
         "py": "shuìjiào"
        },
        {
         "p": "。"
        }
       ]
      },
      {
       "id": "df33c178a",
       "who": "B",
       "en": "Can I eat a little?",
       "text": "我吃一点儿东西，可以吗？",
       "tokens": [
        {
         "id": "我|wǒ",
         "py": "wǒ"
        },
        {
         "id": "吃|chī",
         "py": "chī"
        },
        {
         "id": "一点儿|yìdiǎnr",
         "py": "yìdiǎnr"
        },
        {
         "id": "东西|dōngxi",
         "py": "dōngxi"
        },
        {
         "p": "，"
        },
        {
         "id": "可以|kěyǐ",
         "py": "kěyǐ"
        },
        {
         "id": "吗|ma",
         "py": "ma"
        },
        {
         "p": "？"
        }
       ]
      },
      {
       "id": "d06c1b356",
       "who": "C",
       "en": "Yes. And go to bed a bit early.",
       "text": "可以。早一点儿睡。",
       "tokens": [
        {
         "id": "可以|kěyǐ",
         "py": "kěyǐ"
        },
        {
         "p": "。"
        },
        {
         "id": "早|zǎo",
         "py": "zǎo"
        },
        {
         "id": "一点儿|yìdiǎnr",
         "py": "yìdiǎnr"
        },
        {
         "id": "睡|shuì",
         "py": "shuì"
        },
        {
         "p": "。"
        }
       ]
      }
     ],
     "builds": [
      {
       "id": "b9835ec97",
       "text": "我生病了。",
       "en": "I'm ill.",
       "pattern": "S V X",
       "chunks": [
        {
         "role": "S",
         "words": [
          "我|wǒ"
         ]
        },
        {
         "role": "V",
         "words": [
          "生病|shēngbìng"
         ]
        },
        {
         "role": "X",
         "words": [
          "了|le"
         ]
        }
       ],
       "punct": [
        {
         "at": 3,
         "p": "。"
        }
       ],
       "py": [
        "wǒ",
        "shēngbìng",
        "le"
       ]
      },
      {
       "id": "b83867cb7",
       "text": "你要休息。",
       "en": "You need to rest.",
       "pattern": "S A V",
       "chunks": [
        {
         "role": "S",
         "words": [
          "你|nǐ"
         ]
        },
        {
         "role": "A",
         "words": [
          "要|yào"
         ]
        },
        {
         "role": "V",
         "words": [
          "休息|xiūxi"
         ]
        }
       ],
       "punct": [
        {
         "at": 3,
         "p": "。"
        }
       ],
       "py": [
        "nǐ",
        "yào",
        "xiūxi"
       ]
      },
      {
       "id": "bcab6634f",
       "text": "不要上班。",
       "en": "Don't go to work.",
       "pattern": "A V",
       "chunks": [
        {
         "role": "A",
         "words": [
          "不要|búyào"
         ]
        },
        {
         "role": "V",
         "words": [
          "上班|shàngbān"
         ]
        }
       ],
       "punct": [
        {
         "at": 2,
         "p": "。"
        }
       ],
       "py": [
        "búyào",
        "shàngbān"
       ]
      },
      {
       "id": "bb1c91382",
       "text": "我想睡觉。",
       "en": "I want to sleep.",
       "pattern": "S A V",
       "chunks": [
        {
         "role": "S",
         "words": [
          "我|wǒ"
         ]
        },
        {
         "role": "A",
         "words": [
          "想|xiǎng"
         ]
        },
        {
         "role": "V",
         "words": [
          "睡觉|shuìjiào"
         ]
        }
       ],
       "punct": [
        {
         "at": 3,
         "p": "。"
        }
       ],
       "py": [
        "wǒ",
        "xiǎng",
        "shuìjiào"
       ]
      }
     ]
    },
    {
     "id": "health-2",
     "title": "A long day",
     "words": [
      "起床|qǐchuáng",
      "晚|wǎn",
      "小时|xiǎoshí",
      "时候|shíhou",
      "时间|shíjiān",
      "白天|báitiān",
      "见|jiàn",
      "一下|yíxià",
      "分钟|fēnzhōng",
      "再|zài"
     ],
     "dialogue": [
      {
       "id": "d08e42a03",
       "who": "A",
       "en": "What time do you get up?",
       "text": "你几点起床？",
       "tokens": [
        {
         "id": "你|nǐ",
         "py": "nǐ"
        },
        {
         "id": "几|jǐ",
         "py": "jǐ"
        },
        {
         "id": "点|diǎn",
         "py": "diǎn"
        },
        {
         "id": "起床|qǐchuáng",
         "py": "qǐchuáng"
        },
        {
         "p": "？"
        }
       ]
      },
      {
       "id": "dc28a3552",
       "who": "B",
       "en": "Seven. And you?",
       "text": "七点。你呢？",
       "tokens": [
        {
         "id": "七|qī",
         "py": "qī"
        },
        {
         "id": "点|diǎn",
         "py": "diǎn"
        },
        {
         "p": "。"
        },
        {
         "id": "你|nǐ",
         "py": "nǐ"
        },
        {
         "id": "呢|ne",
         "py": "ne"
        },
        {
         "p": "？"
        }
       ]
      },
      {
       "id": "d3eb55149",
       "who": "A",
       "en": "I get up late, at nine!",
       "text": "我起床很晚，九点！",
       "tokens": [
        {
         "id": "我|wǒ",
         "py": "wǒ"
        },
        {
         "id": "起床|qǐchuáng",
         "py": "qǐchuáng"
        },
        {
         "id": "很|hěn",
         "py": "hěn"
        },
        {
         "id": "晚|wǎn",
         "py": "wǎn"
        },
        {
         "p": "，"
        },
        {
         "id": "九|jiǔ",
         "py": "jiǔ"
        },
        {
         "id": "点|diǎn",
         "py": "diǎn"
        },
        {
         "p": "！"
        }
       ]
      },
      {
       "id": "d3eccbaeb",
       "who": "A",
       "en": "I sleep eight hours a day.",
       "text": "我一天睡八个小时。",
       "tokens": [
        {
         "id": "我|wǒ",
         "py": "wǒ"
        },
        {
         "id": "一|yī",
         "py": "yì"
        },
        {
         "id": "天|tiān",
         "py": "tiān"
        },
        {
         "id": "睡|shuì",
         "py": "shuì"
        },
        {
         "id": "八|bā",
         "py": "bā"
        },
        {
         "id": "个|gè",
         "py": "gè"
        },
        {
         "id": "小时|xiǎoshí",
         "py": "xiǎoshí"
        },
        {
         "p": "。"
        }
       ]
      },
      {
       "id": "de405533e",
       "who": "B",
       "en": "When do you have time?",
       "text": "你什么时候有时间？",
       "tokens": [
        {
         "id": "你|nǐ",
         "py": "nǐ"
        },
        {
         "id": "什么|shénme",
         "py": "shénme"
        },
        {
         "id": "时候|shíhou",
         "py": "shíhou"
        },
        {
         "id": "有|yǒu",
         "py": "yǒu"
        },
        {
         "id": "时间|shíjiān",
         "py": "shíjiān"
        },
        {
         "p": "？"
        }
       ]
      },
      {
       "id": "d25ad88c4",
       "who": "A",
       "en": "Not in the daytime; in the evening I do.",
       "text": "白天没有时间，晚上有。",
       "tokens": [
        {
         "id": "白天|báitiān",
         "py": "báitiān"
        },
        {
         "id": "没有|méiyǒu",
         "py": "méiyǒu"
        },
        {
         "id": "时间|shíjiān",
         "py": "shíjiān"
        },
        {
         "p": "，"
        },
        {
         "id": "晚上|wǎnshang",
         "py": "wǎnshang"
        },
        {
         "id": "有|yǒu",
         "py": "yǒu"
        },
        {
         "p": "。"
        }
       ]
      },
      {
       "id": "d84434047",
       "who": "B",
       "en": "OK, see you this evening.",
       "text": "好，我们晚上见。",
       "tokens": [
        {
         "id": "好|hǎo",
         "py": "hǎo"
        },
        {
         "p": "，"
        },
        {
         "id": "我们|wǒmen",
         "py": "wǒmen"
        },
        {
         "id": "晚上|wǎnshang",
         "py": "wǎnshang"
        },
        {
         "id": "见|jiàn",
         "py": "jiàn"
        },
        {
         "p": "。"
        }
       ]
      },
      {
       "id": "d020e8d44",
       "who": "A",
       "en": "I'm going to rest for a bit, ten minutes.",
       "text": "我休息一下，十分钟。",
       "tokens": [
        {
         "id": "我|wǒ",
         "py": "wǒ"
        },
        {
         "id": "休息|xiūxi",
         "py": "xiūxi"
        },
        {
         "id": "一下|yíxià",
         "py": "yíxià"
        },
        {
         "p": "，"
        },
        {
         "id": "十|shí",
         "py": "shí"
        },
        {
         "id": "分钟|fēnzhōng",
         "py": "fēnzhōng"
        },
        {
         "p": "。"
        }
       ]
      },
      {
       "id": "d0a6b9767",
       "who": "B",
       "en": "OK, let's talk tomorrow.",
       "text": "好，明天再说。",
       "tokens": [
        {
         "id": "好|hǎo",
         "py": "hǎo"
        },
        {
         "p": "，"
        },
        {
         "id": "明天|míngtiān",
         "py": "míngtiān"
        },
        {
         "id": "再|zài",
         "py": "zài"
        },
        {
         "id": "说|shuō",
         "py": "shuō"
        },
        {
         "p": "。"
        }
       ]
      }
     ],
     "builds": [
      {
       "id": "b08e42a03",
       "text": "你几点起床？",
       "en": "What time do you get up?",
       "pattern": "S T V",
       "chunks": [
        {
         "role": "S",
         "words": [
          "你|nǐ"
         ]
        },
        {
         "role": "T",
         "words": [
          "几|jǐ",
          "点|diǎn"
         ]
        },
        {
         "role": "V",
         "words": [
          "起床|qǐchuáng"
         ]
        }
       ],
       "punct": [
        {
         "at": 3,
         "p": "？"
        }
       ],
       "py": [
        "nǐ",
        "jǐ",
        "diǎn",
        "qǐchuáng"
       ]
      },
      {
       "id": "b87c17bea",
       "text": "我们晚上见。",
       "en": "See you this evening.",
       "pattern": "S T V",
       "chunks": [
        {
         "role": "S",
         "words": [
          "我们|wǒmen"
         ]
        },
        {
         "role": "T",
         "words": [
          "晚上|wǎnshang"
         ]
        },
        {
         "role": "V",
         "words": [
          "见|jiàn"
         ]
        }
       ],
       "punct": [
        {
         "at": 3,
         "p": "。"
        }
       ],
       "py": [
        "wǒmen",
        "wǎnshang",
        "jiàn"
       ]
      },
      {
       "id": "b8350c181",
       "text": "我休息一下。",
       "en": "I'll rest for a bit.",
       "pattern": "S V O",
       "chunks": [
        {
         "role": "S",
         "words": [
          "我|wǒ"
         ]
        },
        {
         "role": "V",
         "words": [
          "休息|xiūxi"
         ]
        },
        {
         "role": "O",
         "words": [
          "一下|yíxià"
         ]
        }
       ],
       "punct": [
        {
         "at": 3,
         "p": "。"
        }
       ],
       "py": [
        "wǒ",
        "xiūxi",
        "yíxià"
       ]
      },
      {
       "id": "be405533e",
       "text": "你什么时候有时间？",
       "en": "When do you have time?",
       "pattern": "S T V O",
       "chunks": [
        {
         "role": "S",
         "words": [
          "你|nǐ"
         ]
        },
        {
         "role": "T",
         "words": [
          "什么|shénme",
          "时候|shíhou"
         ]
        },
        {
         "role": "V",
         "words": [
          "有|yǒu"
         ]
        },
        {
         "role": "O",
         "words": [
          "时间|shíjiān"
         ]
        }
       ],
       "punct": [
        {
         "at": 4,
         "p": "？"
        }
       ],
       "py": [
        "nǐ",
        "shénme",
        "shíhou",
        "yǒu",
        "shíjiān"
       ]
      }
     ]
    }
   ]
  },
  {
   "id": "free",
   "title": "Free time",
   "zh": "周末",
   "topic": "Daily life: leisure (休闲)",
   "notes": [
    "会 and 能 both mean \"can\". 会 is for skills you have learned (我会唱歌, I can sing); 能 is for being able to, or being allowed to.",
    "吧 at the end of a sentence turns it into a suggestion: 我们去书店吧!, let's go to the bookshop!"
   ],
   "lessons": [
    {
     "id": "free-1",
     "title": "At the weekend",
     "words": [
      "电影院|diànyǐngyuàn",
      "看|kàn",
      "电影|diànyǐng",
      "电视|diànshì",
      "听|tīng",
      "歌|gē",
      "唱|chàng",
      "好听|hǎotīng",
      "玩|wán",
      "好玩儿|hǎowánr"
     ],
     "dialogue": [
      {
       "id": "d36f6bdda",
       "who": "A",
       "en": "What are you doing on Sunday?",
       "text": "星期天你做什么？",
       "tokens": [
        {
         "id": "星期天|xīngqītiān",
         "py": "xīngqītiān"
        },
        {
         "id": "你|nǐ",
         "py": "nǐ"
        },
        {
         "id": "做|zuò",
         "py": "zuò"
        },
        {
         "id": "什么|shénme",
         "py": "shénme"
        },
        {
         "p": "？"
        }
       ]
      },
      {
       "id": "ddf9a56ee",
       "who": "B",
       "en": "I'm going to the cinema to see a film.",
       "text": "我去电影院看电影。",
       "tokens": [
        {
         "id": "我|wǒ",
         "py": "wǒ"
        },
        {
         "id": "去|qù",
         "py": "qù"
        },
        {
         "id": "电影院|diànyǐngyuàn",
         "py": "diànyǐngyuàn"
        },
        {
         "id": "看|kàn",
         "py": "kàn"
        },
        {
         "id": "电影|diànyǐng",
         "py": "diànyǐng"
        },
        {
         "p": "。"
        }
       ]
      },
      {
       "id": "de9abd1be",
       "who": "A",
       "en": "I'll be at home watching TV and listening to music.",
       "text": "我在家看电视，听歌。",
       "tokens": [
        {
         "id": "我|wǒ",
         "py": "wǒ"
        },
        {
         "id": "在|zài",
         "py": "zài"
        },
        {
         "id": "家|jiā",
         "py": "jiā"
        },
        {
         "id": "看|kàn",
         "py": "kàn"
        },
        {
         "id": "电视|diànshì",
         "py": "diànshì"
        },
        {
         "p": "，"
        },
        {
         "id": "听|tīng",
         "py": "tīng"
        },
        {
         "id": "歌|gē",
         "py": "gē"
        },
        {
         "p": "。"
        }
       ]
      },
      {
       "id": "de2b15fe5",
       "who": "B",
       "en": "Do you like singing?",
       "text": "你喜欢唱歌吗？",
       "tokens": [
        {
         "id": "你|nǐ",
         "py": "nǐ"
        },
        {
         "id": "喜欢|xǐhuan",
         "py": "xǐhuan"
        },
        {
         "id": "唱|chàng",
         "py": "chàng"
        },
        {
         "id": "歌|gē",
         "py": "gē"
        },
        {
         "id": "吗|ma",
         "py": "ma"
        },
        {
         "p": "？"
        }
       ]
      },
      {
       "id": "d5b96cb06",
       "who": "A",
       "en": "Very much. My younger sister sings beautifully.",
       "text": "很喜欢。我妹妹唱歌很好听。",
       "tokens": [
        {
         "id": "很|hěn",
         "py": "hěn"
        },
        {
         "id": "喜欢|xǐhuan",
         "py": "xǐhuan"
        },
        {
         "p": "。"
        },
        {
         "id": "我|wǒ",
         "py": "wǒ"
        },
        {
         "id": "妹妹|mèimei",
         "py": "mèimei"
        },
        {
         "id": "唱|chàng",
         "py": "chàng"
        },
        {
         "id": "歌|gē",
         "py": "gē"
        },
        {
         "id": "很|hěn",
         "py": "hěn"
        },
        {
         "id": "好听|hǎotīng",
         "py": "hǎotīng"
        },
        {
         "p": "。"
        }
       ]
      },
      {
       "id": "d6aa531e6",
       "who": "B",
       "en": "Where do you go to have fun?",
       "text": "你们去哪儿玩？",
       "tokens": [
        {
         "id": "你们|nǐmen",
         "py": "nǐmen"
        },
        {
         "id": "去|qù",
         "py": "qù"
        },
        {
         "id": "哪儿|nǎr",
         "py": "nǎr"
        },
        {
         "id": "玩|wán",
         "py": "wán"
        },
        {
         "p": "？"
        }
       ]
      },
      {
       "id": "db19c7c40",
       "who": "A",
       "en": "We go round to Xiaoming's; it's great fun!",
       "text": "我们去小明家玩，很好玩儿！",
       "tokens": [
        {
         "id": "我们|wǒmen",
         "py": "wǒmen"
        },
        {
         "id": "去|qù",
         "py": "qù"
        },
        {
         "name": "小明",
         "py": "Xiǎomíng"
        },
        {
         "id": "家|jiā",
         "py": "jiā"
        },
        {
         "id": "玩|wán",
         "py": "wán"
        },
        {
         "p": "，"
        },
        {
         "id": "很|hěn",
         "py": "hěn"
        },
        {
         "id": "好玩儿|hǎowánr",
         "py": "hǎowánr"
        },
        {
         "p": "！"
        }
       ]
      }
     ],
     "builds": [
      {
       "id": "b3ea76d52",
       "text": "我看电影。",
       "en": "I'm watching a film.",
       "pattern": "S V O",
       "chunks": [
        {
         "role": "S",
         "words": [
          "我|wǒ"
         ]
        },
        {
         "role": "V",
         "words": [
          "看|kàn"
         ]
        },
        {
         "role": "O",
         "words": [
          "电影|diànyǐng"
         ]
        }
       ],
       "punct": [
        {
         "at": 3,
         "p": "。"
        }
       ],
       "py": [
        "wǒ",
        "kàn",
        "diànyǐng"
       ]
      },
      {
       "id": "b56da8d17",
       "text": "我喜欢唱歌。",
       "en": "I like singing.",
       "pattern": "S A V O",
       "chunks": [
        {
         "role": "S",
         "words": [
          "我|wǒ"
         ]
        },
        {
         "role": "A",
         "words": [
          "喜欢|xǐhuan"
         ]
        },
        {
         "role": "V",
         "words": [
          "唱|chàng"
         ]
        },
        {
         "role": "O",
         "words": [
          "歌|gē"
         ]
        }
       ],
       "punct": [
        {
         "at": 4,
         "p": "。"
        }
       ],
       "py": [
        "wǒ",
        "xǐhuan",
        "chàng",
        "gē"
       ]
      },
      {
       "id": "b0d288adc",
       "text": "她在家听歌。",
       "en": "She listens to music at home.",
       "pattern": "S P V O",
       "chunks": [
        {
         "role": "S",
         "words": [
          "她|tā"
         ]
        },
        {
         "role": "P",
         "words": [
          "在|zài",
          "家|jiā"
         ]
        },
        {
         "role": "V",
         "words": [
          "听|tīng"
         ]
        },
        {
         "role": "O",
         "words": [
          "歌|gē"
         ]
        }
       ],
       "punct": [
        {
         "at": 4,
         "p": "。"
        }
       ],
       "py": [
        "tā",
        "zài",
        "jiā",
        "tīng",
        "gē"
       ]
      },
      {
       "id": "b59306db2",
       "text": "这很好玩儿。",
       "en": "This is fun.",
       "pattern": "S A V",
       "chunks": [
        {
         "role": "S",
         "words": [
          "这|zhè"
         ]
        },
        {
         "role": "A",
         "words": [
          "很|hěn"
         ]
        },
        {
         "role": "V",
         "words": [
          "好玩儿|hǎowánr"
         ]
        }
       ],
       "punct": [
        {
         "at": 3,
         "p": "。"
        }
       ],
       "py": [
        "zhè",
        "hěn",
        "hǎowánr"
       ]
      }
     ]
    },
    {
     "id": "free-2",
     "title": "What can you do?",
     "words": [
      "会|huì",
      "读|dú",
      "能|néng",
      "觉得|juéde",
      "非常|fēicháng",
      "星期日|xīngqīrì",
      "书店|shūdiàn",
      "吧|ba",
      "读书|dúshū",
      "电脑|diànnǎo"
     ],
     "dialogue": [
      {
       "id": "db194278a",
       "who": "A",
       "en": "Can you speak Chinese?",
       "text": "你会说汉语吗？",
       "tokens": [
        {
         "id": "你|nǐ",
         "py": "nǐ"
        },
        {
         "id": "会|huì",
         "py": "huì"
        },
        {
         "id": "说|shuō",
         "py": "shuō"
        },
        {
         "id": "汉语|Hànyǔ",
         "py": "Hànyǔ"
        },
        {
         "id": "吗|ma",
         "py": "ma"
        },
        {
         "p": "？"
        }
       ]
      },
      {
       "id": "dd3f91444",
       "who": "B",
       "en": "A little. I can read characters too.",
       "text": "会一点儿。我也能读汉字。",
       "tokens": [
        {
         "id": "会|huì",
         "py": "huì"
        },
        {
         "id": "一点儿|yìdiǎnr",
         "py": "yìdiǎnr"
        },
        {
         "p": "。"
        },
        {
         "id": "我|wǒ",
         "py": "wǒ"
        },
        {
         "id": "也|yě",
         "py": "yě"
        },
        {
         "id": "能|néng",
         "py": "néng"
        },
        {
         "id": "读|dú",
         "py": "dú"
        },
        {
         "id": "汉字|Hànzì",
         "py": "Hànzì"
        },
        {
         "p": "。"
        }
       ]
      },
      {
       "id": "d163a601c",
       "who": "A",
       "en": "What do you think of Chinese?",
       "text": "你觉得汉语怎么样？",
       "tokens": [
        {
         "id": "你|nǐ",
         "py": "nǐ"
        },
        {
         "id": "觉得|juéde",
         "py": "juéde"
        },
        {
         "id": "汉语|Hànyǔ",
         "py": "Hànyǔ"
        },
        {
         "id": "怎么样|zěnmeyàng",
         "py": "zěnmeyàng"
        },
        {
         "p": "？"
        }
       ]
      },
      {
       "id": "d745cad6b",
       "who": "B",
       "en": "I think Chinese is great fun!",
       "text": "我觉得汉语非常好玩儿！",
       "tokens": [
        {
         "id": "我|wǒ",
         "py": "wǒ"
        },
        {
         "id": "觉得|juéde",
         "py": "juéde"
        },
        {
         "id": "汉语|Hànyǔ",
         "py": "Hànyǔ"
        },
        {
         "id": "非常|fēicháng",
         "py": "fēicháng"
        },
        {
         "id": "好玩儿|hǎowánr",
         "py": "hǎowánr"
        },
        {
         "p": "！"
        }
       ]
      },
      {
       "id": "d5fbbdb6a",
       "who": "A",
       "en": "Let's go to the bookshop on Sunday!",
       "text": "星期日我们去书店吧！",
       "tokens": [
        {
         "id": "星期日|xīngqīrì",
         "py": "xīngqīrì"
        },
        {
         "id": "我们|wǒmen",
         "py": "wǒmen"
        },
        {
         "id": "去|qù",
         "py": "qù"
        },
        {
         "id": "书店|shūdiàn",
         "py": "shūdiàn"
        },
        {
         "id": "吧|ba",
         "py": "ba"
        },
        {
         "p": "！"
        }
       ]
      },
      {
       "id": "dda02127e",
       "who": "B",
       "en": "Great! I love reading. Can you come?",
       "text": "好！我喜欢读书。你能去吗？",
       "tokens": [
        {
         "id": "好|hǎo",
         "py": "hǎo"
        },
        {
         "p": "！"
        },
        {
         "id": "我|wǒ",
         "py": "wǒ"
        },
        {
         "id": "喜欢|xǐhuan",
         "py": "xǐhuan"
        },
        {
         "id": "读书|dúshū",
         "py": "dúshū"
        },
        {
         "p": "。"
        },
        {
         "id": "你|nǐ",
         "py": "nǐ"
        },
        {
         "id": "能|néng",
         "py": "néng"
        },
        {
         "id": "去|qù",
         "py": "qù"
        },
        {
         "id": "吗|ma",
         "py": "ma"
        },
        {
         "p": "？"
        }
       ]
      },
      {
       "id": "d04c68bfc",
       "who": "A",
       "en": "Yes! I don't want to stay home on the computer.",
       "text": "能！我不想在家玩电脑。",
       "tokens": [
        {
         "id": "能|néng",
         "py": "néng"
        },
        {
         "p": "！"
        },
        {
         "id": "我|wǒ",
         "py": "wǒ"
        },
        {
         "id": "不|bù",
         "py": "bù"
        },
        {
         "id": "想|xiǎng",
         "py": "xiǎng"
        },
        {
         "id": "在|zài",
         "py": "zài"
        },
        {
         "id": "家|jiā",
         "py": "jiā"
        },
        {
         "id": "玩|wán",
         "py": "wán"
        },
        {
         "id": "电脑|diànnǎo",
         "py": "diànnǎo"
        },
        {
         "p": "。"
        }
       ]
      }
     ],
     "builds": [
      {
       "id": "bb194278a",
       "text": "你会说汉语吗？",
       "en": "Can you speak Chinese?",
       "pattern": "S A V O X",
       "chunks": [
        {
         "role": "S",
         "words": [
          "你|nǐ"
         ]
        },
        {
         "role": "A",
         "words": [
          "会|huì"
         ]
        },
        {
         "role": "V",
         "words": [
          "说|shuō"
         ]
        },
        {
         "role": "O",
         "words": [
          "汉语|Hànyǔ"
         ]
        },
        {
         "role": "X",
         "words": [
          "吗|ma"
         ]
        }
       ],
       "punct": [
        {
         "at": 5,
         "p": "？"
        }
       ],
       "py": [
        "nǐ",
        "huì",
        "shuō",
        "Hànyǔ",
        "ma"
       ]
      },
      {
       "id": "be8e4e059",
       "text": "我能读汉字。",
       "en": "I can read characters.",
       "pattern": "S A V O",
       "chunks": [
        {
         "role": "S",
         "words": [
          "我|wǒ"
         ]
        },
        {
         "role": "A",
         "words": [
          "能|néng"
         ]
        },
        {
         "role": "V",
         "words": [
          "读|dú"
         ]
        },
        {
         "role": "O",
         "words": [
          "汉字|Hànzì"
         ]
        }
       ],
       "punct": [
        {
         "at": 4,
         "p": "。"
        }
       ],
       "py": [
        "wǒ",
        "néng",
        "dú",
        "Hànzì"
       ]
      },
      {
       "id": "b6aed6d04",
       "text": "我们去书店吧！",
       "en": "Let's go to the bookshop!",
       "pattern": "S V O X",
       "chunks": [
        {
         "role": "S",
         "words": [
          "我们|wǒmen"
         ]
        },
        {
         "role": "V",
         "words": [
          "去|qù"
         ]
        },
        {
         "role": "O",
         "words": [
          "书店|shūdiàn"
         ]
        },
        {
         "role": "X",
         "words": [
          "吧|ba"
         ]
        }
       ],
       "punct": [
        {
         "at": 4,
         "p": "！"
        }
       ],
       "py": [
        "wǒmen",
        "qù",
        "shūdiàn",
        "ba"
       ]
      },
      {
       "id": "b19f11583",
       "text": "你觉得怎么样？",
       "en": "What do you think?",
       "pattern": "S V O",
       "chunks": [
        {
         "role": "S",
         "words": [
          "你|nǐ"
         ]
        },
        {
         "role": "V",
         "words": [
          "觉得|juéde"
         ]
        },
        {
         "role": "O",
         "words": [
          "怎么样|zěnmeyàng"
         ]
        }
       ],
       "punct": [
        {
         "at": 3,
         "p": "？"
        }
       ],
       "py": [
        "nǐ",
        "juéde",
        "zěnmeyàng"
       ]
      }
     ]
    }
   ]
  },
  {
   "id": "things",
   "title": "Things around me",
   "zh": "东西",
   "topic": "Basic information: objects (物品信息)",
   "notes": [
    "Measure words sort nouns: 本 for books (三本书), 件 for clothes, and 个 for most other things.",
    "这些 and 那些, \"these\" and \"those\", make a plural without changing the noun: 这些书, these books."
   ],
   "lessons": [
    {
     "id": "things-1",
     "title": "In my room",
     "words": [
      "房间|fángjiān",
      "桌子|zhuōzi",
      "椅子|yǐzi",
      "哪些|nǎxiē",
      "这些|zhèxiē",
      "那些|nàxiē",
      "本|běn",
      "哪个|nǎge",
      "杯子|bēizi",
      "些|xiē"
     ],
     "dialogue": [
      {
       "id": "d1a4152ce",
       "who": "A",
       "en": "Is this your room?",
       "text": "这是你的房间吗？",
       "tokens": [
        {
         "id": "这|zhè",
         "py": "zhè"
        },
        {
         "id": "是|shì",
         "py": "shì"
        },
        {
         "id": "你|nǐ",
         "py": "nǐ"
        },
        {
         "id": "的|de",
         "py": "de"
        },
        {
         "id": "房间|fángjiān",
         "py": "fángjiān"
        },
        {
         "id": "吗|ma",
         "py": "ma"
        },
        {
         "p": "？"
        }
       ]
      },
      {
       "id": "d3d6a962b",
       "who": "B",
       "en": "Yes. This is my desk and chair.",
       "text": "是。这是我的桌子和椅子。",
       "tokens": [
        {
         "id": "是|shì",
         "py": "shì"
        },
        {
         "p": "。"
        },
        {
         "id": "这|zhè",
         "py": "zhè"
        },
        {
         "id": "是|shì",
         "py": "shì"
        },
        {
         "id": "我|wǒ",
         "py": "wǒ"
        },
        {
         "id": "的|de",
         "py": "de"
        },
        {
         "id": "桌子|zhuōzi",
         "py": "zhuōzi"
        },
        {
         "id": "和|hé",
         "py": "hé"
        },
        {
         "id": "椅子|yǐzi",
         "py": "yǐzi"
        },
        {
         "p": "。"
        }
       ]
      },
      {
       "id": "d60f5f5b8",
       "who": "A",
       "en": "Which books are yours?",
       "text": "哪些书是你的？",
       "tokens": [
        {
         "id": "哪些|nǎxiē",
         "py": "nǎxiē"
        },
        {
         "id": "书|shū",
         "py": "shū"
        },
        {
         "id": "是|shì",
         "py": "shì"
        },
        {
         "id": "你|nǐ",
         "py": "nǐ"
        },
        {
         "id": "的|de",
         "py": "de"
        },
        {
         "p": "？"
        }
       ]
      },
      {
       "id": "dcf12d1ad",
       "who": "B",
       "en": "These are mine; those are my younger sister's.",
       "text": "这些是我的，那些是我妹妹的。",
       "tokens": [
        {
         "id": "这些|zhèxiē",
         "py": "zhèxiē"
        },
        {
         "id": "是|shì",
         "py": "shì"
        },
        {
         "id": "我|wǒ",
         "py": "wǒ"
        },
        {
         "id": "的|de",
         "py": "de"
        },
        {
         "p": "，"
        },
        {
         "id": "那些|nàxiē",
         "py": "nàxiē"
        },
        {
         "id": "是|shì",
         "py": "shì"
        },
        {
         "id": "我|wǒ",
         "py": "wǒ"
        },
        {
         "id": "妹妹|mèimei",
         "py": "mèimei"
        },
        {
         "id": "的|de",
         "py": "de"
        },
        {
         "p": "。"
        }
       ]
      },
      {
       "id": "d77c691e6",
       "who": "A",
       "en": "How many Chinese books do you have?",
       "text": "你有几本汉语书？",
       "tokens": [
        {
         "id": "你|nǐ",
         "py": "nǐ"
        },
        {
         "id": "有|yǒu",
         "py": "yǒu"
        },
        {
         "id": "几|jǐ",
         "py": "jǐ"
        },
        {
         "id": "本|běn",
         "py": "běn"
        },
        {
         "id": "汉语|Hànyǔ",
         "py": "Hànyǔ"
        },
        {
         "id": "书|shū",
         "py": "shū"
        },
        {
         "p": "？"
        }
       ]
      },
      {
       "id": "d92afe1df",
       "who": "B",
       "en": "Five.",
       "text": "五本。",
       "tokens": [
        {
         "id": "五|wǔ",
         "py": "wǔ"
        },
        {
         "id": "本|běn",
         "py": "běn"
        },
        {
         "p": "。"
        }
       ]
      },
      {
       "id": "de4479400",
       "who": "A",
       "en": "Which cup is yours?",
       "text": "哪个杯子是你的？",
       "tokens": [
        {
         "id": "哪个|nǎge",
         "py": "nǎge"
        },
        {
         "id": "杯子|bēizi",
         "py": "bēizi"
        },
        {
         "id": "是|shì",
         "py": "shì"
        },
        {
         "id": "你|nǐ",
         "py": "nǐ"
        },
        {
         "id": "的|de",
         "py": "de"
        },
        {
         "p": "？"
        }
       ]
      },
      {
       "id": "d9bae4221",
       "who": "B",
       "en": "This one's mine. Let's go and buy some cups!",
       "text": "这个是我的。我们去买些杯子吧！",
       "tokens": [
        {
         "id": "这个|zhège",
         "py": "zhège"
        },
        {
         "id": "是|shì",
         "py": "shì"
        },
        {
         "id": "我|wǒ",
         "py": "wǒ"
        },
        {
         "id": "的|de",
         "py": "de"
        },
        {
         "p": "。"
        },
        {
         "id": "我们|wǒmen",
         "py": "wǒmen"
        },
        {
         "id": "去|qù",
         "py": "qù"
        },
        {
         "id": "买|mǎi",
         "py": "mǎi"
        },
        {
         "id": "些|xiē",
         "py": "xiē"
        },
        {
         "id": "杯子|bēizi",
         "py": "bēizi"
        },
        {
         "id": "吧|ba",
         "py": "ba"
        },
        {
         "p": "！"
        }
       ]
      }
     ],
     "builds": [
      {
       "id": "be8595482",
       "text": "这是我的房间。",
       "en": "This is my room.",
       "pattern": "S V O",
       "chunks": [
        {
         "role": "S",
         "words": [
          "这|zhè"
         ]
        },
        {
         "role": "V",
         "words": [
          "是|shì"
         ]
        },
        {
         "role": "O",
         "words": [
          "我|wǒ",
          "的|de",
          "房间|fángjiān"
         ]
        }
       ],
       "punct": [
        {
         "at": 3,
         "p": "。"
        }
       ],
       "py": [
        "zhè",
        "shì",
        "wǒ",
        "de",
        "fángjiān"
       ]
      },
      {
       "id": "b2a5bdfbc",
       "text": "我有五本书。",
       "en": "I have five books.",
       "pattern": "S V O",
       "chunks": [
        {
         "role": "S",
         "words": [
          "我|wǒ"
         ]
        },
        {
         "role": "V",
         "words": [
          "有|yǒu"
         ]
        },
        {
         "role": "O",
         "words": [
          "五|wǔ",
          "本|běn",
          "书|shū"
         ]
        }
       ],
       "punct": [
        {
         "at": 3,
         "p": "。"
        }
       ],
       "py": [
        "wǒ",
        "yǒu",
        "wǔ",
        "běn",
        "shū"
       ]
      },
      {
       "id": "be4479400",
       "text": "哪个杯子是你的？",
       "en": "Which cup is yours?",
       "pattern": "S V O",
       "chunks": [
        {
         "role": "S",
         "words": [
          "哪个|nǎge",
          "杯子|bēizi"
         ]
        },
        {
         "role": "V",
         "words": [
          "是|shì"
         ]
        },
        {
         "role": "O",
         "words": [
          "你|nǐ",
          "的|de"
         ]
        }
       ],
       "punct": [
        {
         "at": 3,
         "p": "？"
        }
       ],
       "py": [
        "nǎge",
        "bēizi",
        "shì",
        "nǐ",
        "de"
       ]
      },
      {
       "id": "b1065c04b",
       "text": "这些是我的。",
       "en": "These are mine.",
       "pattern": "S V O",
       "chunks": [
        {
         "role": "S",
         "words": [
          "这些|zhèxiē"
         ]
        },
        {
         "role": "V",
         "words": [
          "是|shì"
         ]
        },
        {
         "role": "O",
         "words": [
          "我|wǒ",
          "的|de"
         ]
        }
       ],
       "punct": [
        {
         "at": 3,
         "p": "。"
        }
       ],
       "py": [
        "zhèxiē",
        "shì",
        "wǒ",
        "de"
       ]
      }
     ]
    },
    {
     "id": "things-2",
     "title": "Some and many",
     "words": [
      "找|zhǎo",
      "新|xīn",
      "给|gěi",
      "千|qiān",
      "百|bǎi",
      "一些|yìxiē",
      "一半|yíbàn",
      "有的|yǒude",
      "少|shǎo",
      "有些|yǒuxiē"
     ],
     "dialogue": [
      {
       "id": "d7a233f2e",
       "who": "A",
       "en": "What are you looking for?",
       "text": "你找什么？",
       "tokens": [
        {
         "id": "你|nǐ",
         "py": "nǐ"
        },
        {
         "id": "找|zhǎo",
         "py": "zhǎo"
        },
        {
         "id": "什么|shénme",
         "py": "shénme"
        },
        {
         "p": "？"
        }
       ]
      },
      {
       "id": "dfa5d1dd7",
       "who": "B",
       "en": "My new phone.",
       "text": "我找我的新手机。",
       "tokens": [
        {
         "id": "我|wǒ",
         "py": "wǒ"
        },
        {
         "id": "找|zhǎo",
         "py": "zhǎo"
        },
        {
         "id": "我|wǒ",
         "py": "wǒ"
        },
        {
         "id": "的|de",
         "py": "de"
        },
        {
         "id": "新|xīn",
         "py": "xīn"
        },
        {
         "id": "手机|shǒujī",
         "py": "shǒujī"
        },
        {
         "p": "。"
        }
       ]
      },
      {
       "id": "d7e428ef6",
       "who": "A",
       "en": "Here it is! There you go.",
       "text": "在这儿！给你。",
       "tokens": [
        {
         "id": "在|zài",
         "py": "zài"
        },
        {
         "id": "这儿|zhèr",
         "py": "zhèr"
        },
        {
         "p": "！"
        },
        {
         "id": "给|gěi",
         "py": "gěi"
        },
        {
         "id": "你|nǐ",
         "py": "nǐ"
        },
        {
         "p": "。"
        }
       ]
      },
      {
       "id": "d2f585faa",
       "who": "B",
       "en": "Thanks! This phone cost two thousand yuan.",
       "text": "谢谢！这个手机两千块。",
       "tokens": [
        {
         "id": "谢谢|xièxie",
         "py": "xièxie"
        },
        {
         "p": "！"
        },
        {
         "id": "这个|zhège",
         "py": "zhège"
        },
        {
         "id": "手机|shǒujī",
         "py": "shǒujī"
        },
        {
         "id": "两|liǎng",
         "py": "liǎng"
        },
        {
         "id": "千|qiān",
         "py": "qiān"
        },
        {
         "id": "块|kuài",
         "py": "kuài"
        },
        {
         "p": "。"
        }
       ]
      },
      {
       "id": "d7de557b2",
       "who": "A",
       "en": "That's so expensive! Mine was eight hundred.",
       "text": "太贵了！我的手机八百块。",
       "tokens": [
        {
         "id": "太|tài",
         "py": "tài"
        },
        {
         "id": "贵|guì",
         "py": "guì"
        },
        {
         "id": "了|le",
         "py": "le"
        },
        {
         "p": "！"
        },
        {
         "id": "我|wǒ",
         "py": "wǒ"
        },
        {
         "id": "的|de",
         "py": "de"
        },
        {
         "id": "手机|shǒujī",
         "py": "shǒujī"
        },
        {
         "id": "八|bā",
         "py": "bā"
        },
        {
         "id": "百|bǎi",
         "py": "bǎi"
        },
        {
         "id": "块|kuài",
         "py": "kuài"
        },
        {
         "p": "。"
        }
       ]
      },
      {
       "id": "da5d1d778",
       "who": "B",
       "en": "I have some money, and I give half to my mum.",
       "text": "我有一些钱，我给妈妈一半。",
       "tokens": [
        {
         "id": "我|wǒ",
         "py": "wǒ"
        },
        {
         "id": "有|yǒu",
         "py": "yǒu"
        },
        {
         "id": "一些|yìxiē",
         "py": "yìxiē"
        },
        {
         "id": "钱|qián",
         "py": "qián"
        },
        {
         "p": "，"
        },
        {
         "id": "我|wǒ",
         "py": "wǒ"
        },
        {
         "id": "给|gěi",
         "py": "gěi"
        },
        {
         "id": "妈妈|māma",
         "py": "māma"
        },
        {
         "id": "一半|yíbàn",
         "py": "yíbàn"
        },
        {
         "p": "。"
        }
       ]
      },
      {
       "id": "ddc700f09",
       "who": "A",
       "en": "Some classmates have very little money.",
       "text": "有的同学钱很少。",
       "tokens": [
        {
         "id": "有的|yǒude",
         "py": "yǒude"
        },
        {
         "id": "同学|tóngxué",
         "py": "tóngxué"
        },
        {
         "id": "钱|qián",
         "py": "qián"
        },
        {
         "id": "很|hěn",
         "py": "hěn"
        },
        {
         "id": "少|shǎo",
         "py": "shǎo"
        },
        {
         "p": "。"
        }
       ]
      },
      {
       "id": "dea2b7891",
       "who": "B",
       "en": "Some things are cheap, and some are expensive.",
       "text": "有些东西很便宜，有些很贵。",
       "tokens": [
        {
         "id": "有些|yǒuxiē",
         "py": "yǒuxiē"
        },
        {
         "id": "东西|dōngxi",
         "py": "dōngxi"
        },
        {
         "id": "很|hěn",
         "py": "hěn"
        },
        {
         "id": "便宜|piányi",
         "py": "piányi"
        },
        {
         "p": "，"
        },
        {
         "id": "有些|yǒuxiē",
         "py": "yǒuxiē"
        },
        {
         "id": "很|hěn",
         "py": "hěn"
        },
        {
         "id": "贵|guì",
         "py": "guì"
        },
        {
         "p": "。"
        }
       ]
      }
     ],
     "builds": [
      {
       "id": "b7a233f2e",
       "text": "你找什么？",
       "en": "What are you looking for?",
       "pattern": "S V O",
       "chunks": [
        {
         "role": "S",
         "words": [
          "你|nǐ"
         ]
        },
        {
         "role": "V",
         "words": [
          "找|zhǎo"
         ]
        },
        {
         "role": "O",
         "words": [
          "什么|shénme"
         ]
        }
       ],
       "punct": [
        {
         "at": 3,
         "p": "？"
        }
       ],
       "py": [
        "nǐ",
        "zhǎo",
        "shénme"
       ]
      },
      {
       "id": "b3c8517e0",
       "text": "我的手机八百块。",
       "en": "My phone was eight hundred yuan.",
       "pattern": "S V",
       "chunks": [
        {
         "role": "S",
         "words": [
          "我|wǒ",
          "的|de",
          "手机|shǒujī"
         ]
        },
        {
         "role": "V",
         "words": [
          "八|bā",
          "百|bǎi",
          "块|kuài"
         ]
        }
       ],
       "punct": [
        {
         "at": 2,
         "p": "。"
        }
       ],
       "py": [
        "wǒ",
        "de",
        "shǒujī",
        "bā",
        "bǎi",
        "kuài"
       ]
      },
      {
       "id": "bce977e73",
       "text": "这是我的新手机。",
       "en": "This is my new phone.",
       "pattern": "S V O",
       "chunks": [
        {
         "role": "S",
         "words": [
          "这|zhè"
         ]
        },
        {
         "role": "V",
         "words": [
          "是|shì"
         ]
        },
        {
         "role": "O",
         "words": [
          "我|wǒ",
          "的|de",
          "新|xīn",
          "手机|shǒujī"
         ]
        }
       ],
       "punct": [
        {
         "at": 3,
         "p": "。"
        }
       ],
       "py": [
        "zhè",
        "shì",
        "wǒ",
        "de",
        "xīn",
        "shǒujī"
       ]
      },
      {
       "id": "bcde7806f",
       "text": "我给妈妈一半。",
       "en": "I give half to my mum.",
       "pattern": "S V O O",
       "chunks": [
        {
         "role": "S",
         "words": [
          "我|wǒ"
         ]
        },
        {
         "role": "V",
         "words": [
          "给|gěi"
         ]
        },
        {
         "role": "O",
         "words": [
          "妈妈|māma"
         ]
        },
        {
         "role": "O",
         "words": [
          "一半|yíbàn"
         ]
        }
       ],
       "punct": [
        {
         "at": 4,
         "p": "。"
        }
       ],
       "py": [
        "wǒ",
        "gěi",
        "māma",
        "yíbàn"
       ]
      }
     ]
    }
   ]
  },
  {
   "id": "places",
   "title": "Here and there",
   "zh": "这儿",
   "topic": "Basic information: places and directions (事件信息, 环境信息)",
   "notes": [
    "里 after a noun means \"inside\": 家里, at home; 书店里, in the bookshop. 上 and 下 work the same way for on and under: 桌子上, on the table.",
    "住在 says where you live: 我住在北京."
   ],
   "lessons": [
    {
     "id": "places-1",
     "title": "In, on and under",
     "words": [
      "上|shàng",
      "下|xià",
      "外边|wàibian",
      "里|lǐ",
      "外|wài",
      "那里|nàlǐ",
      "这边|zhèbiān",
      "那边|nàbiān",
      "边|biān",
      "这里|zhèlǐ"
     ],
     "dialogue": [
      {
       "id": "d1fb5c661",
       "who": "A",
       "en": "Where's my book?",
       "text": "我的书在哪儿？",
       "tokens": [
        {
         "id": "我|wǒ",
         "py": "wǒ"
        },
        {
         "id": "的|de",
         "py": "de"
        },
        {
         "id": "书|shū",
         "py": "shū"
        },
        {
         "id": "在|zài",
         "py": "zài"
        },
        {
         "id": "哪儿|nǎr",
         "py": "nǎr"
        },
        {
         "p": "？"
        }
       ]
      },
      {
       "id": "d65c8e466",
       "who": "B",
       "en": "On the table.",
       "text": "在桌子上。",
       "tokens": [
        {
         "id": "在|zài",
         "py": "zài"
        },
        {
         "id": "桌子|zhuōzi",
         "py": "zhuōzi"
        },
        {
         "id": "上|shàng",
         "py": "shàng"
        },
        {
         "p": "。"
        }
       ]
      },
      {
       "id": "d3d0a28e9",
       "who": "A",
       "en": "And my cat?",
       "text": "我的猫呢？",
       "tokens": [
        {
         "id": "我|wǒ",
         "py": "wǒ"
        },
        {
         "id": "的|de",
         "py": "de"
        },
        {
         "id": "猫|māo",
         "py": "māo"
        },
        {
         "id": "呢|ne",
         "py": "ne"
        },
        {
         "p": "？"
        }
       ]
      },
      {
       "id": "d599e4061",
       "who": "B",
       "en": "Under the chair.",
       "text": "在椅子下。",
       "tokens": [
        {
         "id": "在|zài",
         "py": "zài"
        },
        {
         "id": "椅子|yǐzi",
         "py": "yǐzi"
        },
        {
         "id": "下|xià",
         "py": "xià"
        },
        {
         "p": "。"
        }
       ]
      },
      {
       "id": "db18a6b4b",
       "who": "A",
       "en": "Where are you? I'm outside.",
       "text": "你在哪里？我在外边。",
       "tokens": [
        {
         "id": "你|nǐ",
         "py": "nǐ"
        },
        {
         "id": "在|zài",
         "py": "zài"
        },
        {
         "id": "哪里|nǎlǐ",
         "py": "nǎlǐ"
        },
        {
         "p": "？"
        },
        {
         "id": "我|wǒ",
         "py": "wǒ"
        },
        {
         "id": "在|zài",
         "py": "zài"
        },
        {
         "id": "外边|wàibian",
         "py": "wàibian"
        },
        {
         "p": "。"
        }
       ]
      },
      {
       "id": "d2bb6fa13",
       "who": "B",
       "en": "I'm at home. Is it cold out?",
       "text": "我在家里。外边冷吗？",
       "tokens": [
        {
         "id": "我|wǒ",
         "py": "wǒ"
        },
        {
         "id": "在|zài",
         "py": "zài"
        },
        {
         "id": "家|jiā",
         "py": "jiā"
        },
        {
         "id": "里|lǐ",
         "py": "lǐ"
        },
        {
         "p": "。"
        },
        {
         "id": "外边|wàibian",
         "py": "wàibian"
        },
        {
         "id": "冷|lěng",
         "py": "lěng"
        },
        {
         "id": "吗|ma",
         "py": "ma"
        },
        {
         "p": "？"
        }
       ]
      },
      {
       "id": "da0b8f5ed",
       "who": "A",
       "en": "Very! There are lots of foreigners here.",
       "text": "很冷！这里有很多外国人。",
       "tokens": [
        {
         "id": "很|hěn",
         "py": "hěn"
        },
        {
         "id": "冷|lěng",
         "py": "lěng"
        },
        {
         "p": "！"
        },
        {
         "id": "这里|zhèlǐ",
         "py": "zhèlǐ"
        },
        {
         "id": "有|yǒu",
         "py": "yǒu"
        },
        {
         "id": "很|hěn",
         "py": "hěn"
        },
        {
         "id": "多|duō",
         "py": "duō"
        },
        {
         "id": "外|wài",
         "py": "wài"
        },
        {
         "id": "国|guó",
         "py": "guó"
        },
        {
         "id": "人|rén",
         "py": "rén"
        },
        {
         "p": "。"
        }
       ]
      },
      {
       "id": "dcae9c14e",
       "who": "B",
       "en": "What about there? Is the supermarket on this side?",
       "text": "那里呢？超市在这边吗？",
       "tokens": [
        {
         "id": "那里|nàlǐ",
         "py": "nàlǐ"
        },
        {
         "id": "呢|ne",
         "py": "ne"
        },
        {
         "p": "？"
        },
        {
         "id": "超市|chāoshì",
         "py": "chāoshì"
        },
        {
         "id": "在|zài",
         "py": "zài"
        },
        {
         "id": "这边|zhèbiān",
         "py": "zhèbiān"
        },
        {
         "id": "吗|ma",
         "py": "ma"
        },
        {
         "p": "？"
        }
       ]
      },
      {
       "id": "d14aff06b",
       "who": "A",
       "en": "Not this side; it's on that side, next to the bookshop.",
       "text": "不在这边，在那边，书店边上。",
       "tokens": [
        {
         "id": "不|bù",
         "py": "bú"
        },
        {
         "id": "在|zài",
         "py": "zài"
        },
        {
         "id": "这边|zhèbiān",
         "py": "zhèbiān"
        },
        {
         "p": "，"
        },
        {
         "id": "在|zài",
         "py": "zài"
        },
        {
         "id": "那边|nàbiān",
         "py": "nàbiān"
        },
        {
         "p": "，"
        },
        {
         "id": "书店|shūdiàn",
         "py": "shūdiàn"
        },
        {
         "id": "边|biān",
         "py": "biān"
        },
        {
         "id": "上|shàng",
         "py": "shàng"
        },
        {
         "p": "。"
        }
       ]
      }
     ],
     "builds": [
      {
       "id": "b8db73dc1",
       "text": "书在桌子上。",
       "en": "The book is on the table.",
       "pattern": "S V P",
       "chunks": [
        {
         "role": "S",
         "words": [
          "书|shū"
         ]
        },
        {
         "role": "V",
         "words": [
          "在|zài"
         ]
        },
        {
         "role": "P",
         "words": [
          "桌子|zhuōzi",
          "上|shàng"
         ]
        }
       ],
       "punct": [
        {
         "at": 3,
         "p": "。"
        }
       ],
       "py": [
        "shū",
        "zài",
        "zhuōzi",
        "shàng"
       ]
      },
      {
       "id": "b0edd1849",
       "text": "猫在椅子下。",
       "en": "The cat is under the chair.",
       "pattern": "S V P",
       "chunks": [
        {
         "role": "S",
         "words": [
          "猫|māo"
         ]
        },
        {
         "role": "V",
         "words": [
          "在|zài"
         ]
        },
        {
         "role": "P",
         "words": [
          "椅子|yǐzi",
          "下|xià"
         ]
        }
       ],
       "punct": [
        {
         "at": 3,
         "p": "。"
        }
       ],
       "py": [
        "māo",
        "zài",
        "yǐzi",
        "xià"
       ]
      },
      {
       "id": "b7e44eac5",
       "text": "我在家里。",
       "en": "I'm at home.",
       "pattern": "S V P",
       "chunks": [
        {
         "role": "S",
         "words": [
          "我|wǒ"
         ]
        },
        {
         "role": "V",
         "words": [
          "在|zài"
         ]
        },
        {
         "role": "P",
         "words": [
          "家|jiā",
          "里|lǐ"
         ]
        }
       ],
       "punct": [
        {
         "at": 3,
         "p": "。"
        }
       ],
       "py": [
        "wǒ",
        "zài",
        "jiā",
        "lǐ"
       ]
      },
      {
       "id": "b30c611d0",
       "text": "超市在那边。",
       "en": "The supermarket is over there.",
       "pattern": "S V P",
       "chunks": [
        {
         "role": "S",
         "words": [
          "超市|chāoshì"
         ]
        },
        {
         "role": "V",
         "words": [
          "在|zài"
         ]
        },
        {
         "role": "P",
         "words": [
          "那边|nàbiān"
         ]
        }
       ],
       "punct": [
        {
         "at": 3,
         "p": "。"
        }
       ],
       "py": [
        "chāoshì",
        "zài",
        "nàbiān"
       ]
      }
     ]
    },
    {
     "id": "places-2",
     "title": "Where do you live?",
     "words": [
      "住|zhù",
      "后|hòu",
      "口|kǒu",
      "前|qián",
      "看见|kànjiàn",
      "正在|zhèngzài",
      "开|kāi",
      "听见|tīngjiàn",
      "她们|tāmen",
      "它们|tāmen"
     ],
     "dialogue": [
      {
       "id": "d8641b972",
       "who": "A",
       "en": "Where do you live?",
       "text": "你住在哪儿？",
       "tokens": [
        {
         "id": "你|nǐ",
         "py": "nǐ"
        },
        {
         "id": "住|zhù",
         "py": "zhù"
        },
        {
         "id": "在|zài",
         "py": "zài"
        },
        {
         "id": "哪儿|nǎr",
         "py": "nǎr"
        },
        {
         "p": "？"
        }
       ]
      },
      {
       "id": "dbcf6a7af",
       "who": "B",
       "en": "Behind the school.",
       "text": "我住在学校后边。",
       "tokens": [
        {
         "id": "我|wǒ",
         "py": "wǒ"
        },
        {
         "id": "住|zhù",
         "py": "zhù"
        },
        {
         "id": "在|zài",
         "py": "zài"
        },
        {
         "id": "学校|xuéxiào",
         "py": "xuéxiào"
        },
        {
         "id": "后|hòu",
         "py": "hòu"
        },
        {
         "id": "边|biān",
         "py": "biān"
        },
        {
         "p": "。"
        }
       ]
      },
      {
       "id": "d203ca767",
       "who": "A",
       "en": "How many people are in your family?",
       "text": "你家有几口人？",
       "tokens": [
        {
         "id": "你|nǐ",
         "py": "nǐ"
        },
        {
         "id": "家|jiā",
         "py": "jiā"
        },
        {
         "id": "有|yǒu",
         "py": "yǒu"
        },
        {
         "id": "几|jǐ",
         "py": "jǐ"
        },
        {
         "id": "口|kǒu",
         "py": "kǒu"
        },
        {
         "id": "人|rén",
         "py": "rén"
        },
        {
         "p": "？"
        }
       ]
      },
      {
       "id": "db817d58c",
       "who": "B",
       "en": "Four. There's a supermarket in front of our home.",
       "text": "四口人。我家前边有一个超市。",
       "tokens": [
        {
         "id": "四|sì",
         "py": "sì"
        },
        {
         "id": "口|kǒu",
         "py": "kǒu"
        },
        {
         "id": "人|rén",
         "py": "rén"
        },
        {
         "p": "。"
        },
        {
         "id": "我|wǒ",
         "py": "wǒ"
        },
        {
         "id": "家|jiā",
         "py": "jiā"
        },
        {
         "id": "前|qián",
         "py": "qián"
        },
        {
         "id": "边|biān",
         "py": "biān"
        },
        {
         "id": "有|yǒu",
         "py": "yǒu"
        },
        {
         "id": "一|yī",
         "py": "yí"
        },
        {
         "id": "个|gè",
         "py": "gè"
        },
        {
         "id": "超市|chāoshì",
         "py": "chāoshì"
        },
        {
         "p": "。"
        }
       ]
      },
      {
       "id": "da6d2482a",
       "who": "A",
       "en": "Have you seen Xiaoming?",
       "text": "你看见小明了吗？",
       "tokens": [
        {
         "id": "你|nǐ",
         "py": "nǐ"
        },
        {
         "id": "看见|kànjiàn",
         "py": "kànjiàn"
        },
        {
         "name": "小明",
         "py": "Xiǎomíng"
        },
        {
         "id": "了|le",
         "py": "le"
        },
        {
         "id": "吗|ma",
         "py": "ma"
        },
        {
         "p": "？"
        }
       ]
      },
      {
       "id": "d9a9b821e",
       "who": "B",
       "en": "Yes, he's switching on his computer.",
       "text": "看见了，他正在开电脑。",
       "tokens": [
        {
         "id": "看见|kànjiàn",
         "py": "kànjiàn"
        },
        {
         "id": "了|le",
         "py": "le"
        },
        {
         "p": "，"
        },
        {
         "id": "他|tā",
         "py": "tā"
        },
        {
         "id": "正在|zhèngzài",
         "py": "zhèngzài"
        },
        {
         "id": "开|kāi",
         "py": "kāi"
        },
        {
         "id": "电脑|diànnǎo",
         "py": "diànnǎo"
        },
        {
         "p": "。"
        }
       ]
      },
      {
       "id": "de3354bb5",
       "who": "A",
       "en": "Can you hear that? They're singing.",
       "text": "你听见了吗？她们在唱歌。",
       "tokens": [
        {
         "id": "你|nǐ",
         "py": "nǐ"
        },
        {
         "id": "听见|tīngjiàn",
         "py": "tīngjiàn"
        },
        {
         "id": "了|le",
         "py": "le"
        },
        {
         "id": "吗|ma",
         "py": "ma"
        },
        {
         "p": "？"
        },
        {
         "id": "她们|tāmen",
         "py": "tāmen"
        },
        {
         "id": "在|zài",
         "py": "zài"
        },
        {
         "id": "唱|chàng",
         "py": "chàng"
        },
        {
         "id": "歌|gē",
         "py": "gē"
        },
        {
         "p": "。"
        }
       ]
      },
      {
       "id": "dfc78eec7",
       "who": "B",
       "en": "I can! Where are our cats?",
       "text": "听见了！我们的猫呢？",
       "tokens": [
        {
         "id": "听见|tīngjiàn",
         "py": "tīngjiàn"
        },
        {
         "id": "了|le",
         "py": "le"
        },
        {
         "p": "！"
        },
        {
         "id": "我们|wǒmen",
         "py": "wǒmen"
        },
        {
         "id": "的|de",
         "py": "de"
        },
        {
         "id": "猫|māo",
         "py": "māo"
        },
        {
         "id": "呢|ne",
         "py": "ne"
        },
        {
         "p": "？"
        }
       ]
      },
      {
       "id": "d7695a7c9",
       "who": "A",
       "en": "They're playing outside.",
       "text": "它们在外边玩。",
       "tokens": [
        {
         "id": "它们|tāmen",
         "py": "tāmen"
        },
        {
         "id": "在|zài",
         "py": "zài"
        },
        {
         "id": "外边|wàibian",
         "py": "wàibian"
        },
        {
         "id": "玩|wán",
         "py": "wán"
        },
        {
         "p": "。"
        }
       ]
      }
     ],
     "builds": [
      {
       "id": "bbcf6a7af",
       "text": "我住在学校后边。",
       "en": "I live behind the school.",
       "pattern": "S V P",
       "chunks": [
        {
         "role": "S",
         "words": [
          "我|wǒ"
         ]
        },
        {
         "role": "V",
         "words": [
          "住|zhù"
         ]
        },
        {
         "role": "P",
         "words": [
          "在|zài",
          "学校|xuéxiào",
          "后|hòu",
          "边|biān"
         ]
        }
       ],
       "punct": [
        {
         "at": 3,
         "p": "。"
        }
       ],
       "py": [
        "wǒ",
        "zhù",
        "zài",
        "xuéxiào",
        "hòu",
        "biān"
       ]
      },
      {
       "id": "b203ca767",
       "text": "你家有几口人？",
       "en": "How many people are in your family?",
       "pattern": "S V O",
       "chunks": [
        {
         "role": "S",
         "words": [
          "你|nǐ",
          "家|jiā"
         ]
        },
        {
         "role": "V",
         "words": [
          "有|yǒu"
         ]
        },
        {
         "role": "O",
         "words": [
          "几|jǐ",
          "口|kǒu",
          "人|rén"
         ]
        }
       ],
       "punct": [
        {
         "at": 3,
         "p": "？"
        }
       ],
       "py": [
        "nǐ",
        "jiā",
        "yǒu",
        "jǐ",
        "kǒu",
        "rén"
       ]
      },
      {
       "id": "b59f43cc9",
       "text": "他正在开电脑。",
       "en": "He's switching on his computer.",
       "pattern": "S A V O",
       "chunks": [
        {
         "role": "S",
         "words": [
          "他|tā"
         ]
        },
        {
         "role": "A",
         "words": [
          "正在|zhèngzài"
         ]
        },
        {
         "role": "V",
         "words": [
          "开|kāi"
         ]
        },
        {
         "role": "O",
         "words": [
          "电脑|diànnǎo"
         ]
        }
       ],
       "punct": [
        {
         "at": 4,
         "p": "。"
        }
       ],
       "py": [
        "tā",
        "zhèngzài",
        "kāi",
        "diànnǎo"
       ]
      },
      {
       "id": "b7695a7c9",
       "text": "它们在外边玩。",
       "en": "They're playing outside.",
       "pattern": "S P V",
       "chunks": [
        {
         "role": "S",
         "words": [
          "它们|tāmen"
         ]
        },
        {
         "role": "P",
         "words": [
          "在|zài",
          "外边|wàibian"
         ]
        },
        {
         "role": "V",
         "words": [
          "玩|wán"
         ]
        }
       ],
       "punct": [
        {
         "at": 3,
         "p": "。"
        }
       ],
       "py": [
        "tāmen",
        "zài",
        "wàibian",
        "wán"
       ]
      }
     ]
    }
   ]
  },
  {
   "id": "culture",
   "title": "Chinese food",
   "zh": "中国菜",
   "topic": "Culture: food culture (饮食文化)",
   "notes": [
    "Dumplings (饺子) are a family favourite across northern China, eaten above all at Spring Festival; families often make them together.",
    "饭店 can mean a restaurant or a hotel; in everyday talk it usually means a restaurant."
   ],
   "lessons": [
    {
     "id": "culture-1",
     "title": "Dumplings",
     "words": [
      "做饭|zuòfàn",
      "饺子|jiǎozi",
      "饭店|fàndiàn",
      "店|diàn",
      "男|nán",
      "女|nǚ",
      "第|dì",
      "日|rì"
     ],
     "dialogue": [
      {
       "id": "db960bc76",
       "who": "A",
       "en": "Can you cook?",
       "text": "你会做饭吗？",
       "tokens": [
        {
         "id": "你|nǐ",
         "py": "nǐ"
        },
        {
         "id": "会|huì",
         "py": "huì"
        },
        {
         "id": "做饭|zuòfàn",
         "py": "zuòfàn"
        },
        {
         "id": "吗|ma",
         "py": "ma"
        },
        {
         "p": "？"
        }
       ]
      },
      {
       "id": "d04aca045",
       "who": "B",
       "en": "Yes! I love making dumplings.",
       "text": "会！我很喜欢做饺子。",
       "tokens": [
        {
         "id": "会|huì",
         "py": "huì"
        },
        {
         "p": "！"
        },
        {
         "id": "我|wǒ",
         "py": "wǒ"
        },
        {
         "id": "很|hěn",
         "py": "hěn"
        },
        {
         "id": "喜欢|xǐhuan",
         "py": "xǐhuan"
        },
        {
         "id": "做|zuò",
         "py": "zuò"
        },
        {
         "id": "饺子|jiǎozi",
         "py": "jiǎozi"
        },
        {
         "p": "。"
        }
       ]
      },
      {
       "id": "d69ee38da",
       "who": "A",
       "en": "I can't cook. Let's go to a restaurant for dumplings!",
       "text": "我不会做饭。我们去饭店吃饺子吧！",
       "tokens": [
        {
         "id": "我|wǒ",
         "py": "wǒ"
        },
        {
         "id": "不|bù",
         "py": "bú"
        },
        {
         "id": "会|huì",
         "py": "huì"
        },
        {
         "id": "做饭|zuòfàn",
         "py": "zuòfàn"
        },
        {
         "p": "。"
        },
        {
         "id": "我们|wǒmen",
         "py": "wǒmen"
        },
        {
         "id": "去|qù",
         "py": "qù"
        },
        {
         "id": "饭店|fàndiàn",
         "py": "fàndiàn"
        },
        {
         "id": "吃|chī",
         "py": "chī"
        },
        {
         "id": "饺子|jiǎozi",
         "py": "jiǎozi"
        },
        {
         "id": "吧|ba",
         "py": "ba"
        },
        {
         "p": "！"
        }
       ]
      },
      {
       "id": "dce26b9aa",
       "who": "B",
       "en": "Great! The dumplings here are really good; my classmates all love them.",
       "text": "好！这个店的饺子非常好吃，我的男同学和女同学都喜欢。",
       "tokens": [
        {
         "id": "好|hǎo",
         "py": "hǎo"
        },
        {
         "p": "！"
        },
        {
         "id": "这个|zhège",
         "py": "zhège"
        },
        {
         "id": "店|diàn",
         "py": "diàn"
        },
        {
         "id": "的|de",
         "py": "de"
        },
        {
         "id": "饺子|jiǎozi",
         "py": "jiǎozi"
        },
        {
         "id": "非常|fēicháng",
         "py": "fēicháng"
        },
        {
         "id": "好吃|hǎochī",
         "py": "hǎochī"
        },
        {
         "p": "，"
        },
        {
         "id": "我|wǒ",
         "py": "wǒ"
        },
        {
         "id": "的|de",
         "py": "de"
        },
        {
         "id": "男|nán",
         "py": "nán"
        },
        {
         "id": "同学|tóngxué",
         "py": "tóngxué"
        },
        {
         "id": "和|hé",
         "py": "hé"
        },
        {
         "id": "女|nǚ",
         "py": "nǚ"
        },
        {
         "id": "同学|tóngxué",
         "py": "tóngxué"
        },
        {
         "id": "都|dōu",
         "py": "dōu"
        },
        {
         "id": "喜欢|xǐhuan",
         "py": "xǐhuan"
        },
        {
         "p": "。"
        }
       ]
      },
      {
       "id": "d85ba1289",
       "who": "A",
       "en": "This is my first dumpling ever! It's so good!",
       "text": "这是我第一个饺子！真好吃！",
       "tokens": [
        {
         "id": "这|zhè",
         "py": "zhè"
        },
        {
         "id": "是|shì",
         "py": "shì"
        },
        {
         "id": "我|wǒ",
         "py": "wǒ"
        },
        {
         "id": "第|dì",
         "py": "dì"
        },
        {
         "id": "一|yī",
         "py": "yī"
        },
        {
         "id": "个|gè",
         "py": "gè"
        },
        {
         "id": "饺子|jiǎozi",
         "py": "jiǎozi"
        },
        {
         "p": "！"
        },
        {
         "id": "真|zhēn",
         "py": "zhēn"
        },
        {
         "id": "好吃|hǎochī",
         "py": "hǎochī"
        },
        {
         "p": "！"
        }
       ]
      },
      {
       "id": "d7f8947b3",
       "who": "B",
       "en": "Let's come back on Sunday.",
       "text": "我们星期日再来吧。",
       "tokens": [
        {
         "id": "我们|wǒmen",
         "py": "wǒmen"
        },
        {
         "id": "星期|xīngqī",
         "py": "xīngqī"
        },
        {
         "id": "日|rì",
         "py": "rì"
        },
        {
         "id": "再|zài",
         "py": "zài"
        },
        {
         "id": "来|lái",
         "py": "lái"
        },
        {
         "id": "吧|ba",
         "py": "ba"
        },
        {
         "p": "。"
        }
       ]
      }
     ],
     "builds": [
      {
       "id": "bb960bc76",
       "text": "你会做饭吗？",
       "en": "Can you cook?",
       "pattern": "S A V X",
       "chunks": [
        {
         "role": "S",
         "words": [
          "你|nǐ"
         ]
        },
        {
         "role": "A",
         "words": [
          "会|huì"
         ]
        },
        {
         "role": "V",
         "words": [
          "做饭|zuòfàn"
         ]
        },
        {
         "role": "X",
         "words": [
          "吗|ma"
         ]
        }
       ],
       "punct": [
        {
         "at": 4,
         "p": "？"
        }
       ],
       "py": [
        "nǐ",
        "huì",
        "zuòfàn",
        "ma"
       ]
      },
      {
       "id": "b7fdd63c3",
       "text": "我们去饭店吃饺子吧！",
       "en": "Let's go to a restaurant for dumplings!",
       "pattern": "S P V O X",
       "chunks": [
        {
         "role": "S",
         "words": [
          "我们|wǒmen"
         ]
        },
        {
         "role": "P",
         "words": [
          "去|qù",
          "饭店|fàndiàn"
         ]
        },
        {
         "role": "V",
         "words": [
          "吃|chī"
         ]
        },
        {
         "role": "O",
         "words": [
          "饺子|jiǎozi"
         ]
        },
        {
         "role": "X",
         "words": [
          "吧|ba"
         ]
        }
       ],
       "punct": [
        {
         "at": 5,
         "p": "！"
        }
       ],
       "py": [
        "wǒmen",
        "qù",
        "fàndiàn",
        "chī",
        "jiǎozi",
        "ba"
       ]
      },
      {
       "id": "b62462b4e",
       "text": "这个店的饺子非常好吃。",
       "en": "The dumplings here are really good.",
       "pattern": "S A V",
       "chunks": [
        {
         "role": "S",
         "words": [
          "这个|zhège",
          "店|diàn",
          "的|de",
          "饺子|jiǎozi"
         ]
        },
        {
         "role": "A",
         "words": [
          "非常|fēicháng"
         ]
        },
        {
         "role": "V",
         "words": [
          "好吃|hǎochī"
         ]
        }
       ],
       "punct": [
        {
         "at": 3,
         "p": "。"
        }
       ],
       "py": [
        "zhège",
        "diàn",
        "de",
        "jiǎozi",
        "fēicháng",
        "hǎochī"
       ]
      },
      {
       "id": "b3676e504",
       "text": "这是我的第一个饺子。",
       "en": "This is my first dumpling.",
       "pattern": "S V O",
       "chunks": [
        {
         "role": "S",
         "words": [
          "这|zhè"
         ]
        },
        {
         "role": "V",
         "words": [
          "是|shì"
         ]
        },
        {
         "role": "O",
         "words": [
          "我|wǒ",
          "的|de",
          "第|dì",
          "一|yī",
          "个|gè",
          "饺子|jiǎozi"
         ]
        }
       ],
       "punct": [
        {
         "at": 3,
         "p": "。"
        }
       ],
       "py": [
        "zhè",
        "shì",
        "wǒ",
        "de",
        "dì",
        "yī",
        "gè",
        "jiǎozi"
       ]
      }
     ]
    }
   ]
  }
 ]
}
